(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire44e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire44e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k1CNB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e941ff55e5dd7cda$export$71511d61b312f219; });
function $e941ff55e5dd7cda$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e941ff55e5dd7cda$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e941ff55e5dd7cda$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e941ff55e5dd7cda$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("9qD8b", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $6dd4e5592687d246$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $1PKUs = parcelRequire("1PKUs");
var $6dd4e5592687d246$var$extendStatics = function extendStatics1(d, b) {
    $6dd4e5592687d246$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6dd4e5592687d246$var$extendStatics(d, b);
};
function $6dd4e5592687d246$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6dd4e5592687d246$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6dd4e5592687d246$export$18ce0697a983be9b = function __assign1() {
    $6dd4e5592687d246$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6dd4e5592687d246$export$18ce0697a983be9b.apply(this, arguments);
};
function $6dd4e5592687d246$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6dd4e5592687d246$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $1PKUs._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6dd4e5592687d246$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6dd4e5592687d246$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $1PKUs._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6dd4e5592687d246$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6dd4e5592687d246$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $1PKUs._)(x)) === "symbol" ? x : "".concat(x);
}
function $6dd4e5592687d246$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $1PKUs._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6dd4e5592687d246$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $1PKUs._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6dd4e5592687d246$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6dd4e5592687d246$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6dd4e5592687d246$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6dd4e5592687d246$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6dd4e5592687d246$export$45d3717a4c69092e(o, m, p);
}
function $6dd4e5592687d246$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6dd4e5592687d246$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6dd4e5592687d246$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6dd4e5592687d246$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6dd4e5592687d246$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6dd4e5592687d246$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6dd4e5592687d246$export$10c90e4f7922046c(v) {
    return this instanceof $6dd4e5592687d246$export$10c90e4f7922046c ? (this.v = v, this) : new $6dd4e5592687d246$export$10c90e4f7922046c(v);
}
function $6dd4e5592687d246$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6dd4e5592687d246$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6dd4e5592687d246$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6dd4e5592687d246$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6dd4e5592687d246$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6dd4e5592687d246$export$19a8beecd37a4c45 === "function" ? $6dd4e5592687d246$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6dd4e5592687d246$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6dd4e5592687d246$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $6dd4e5592687d246$var$ownKeys = function ownKeys1(o) {
    $6dd4e5592687d246$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $6dd4e5592687d246$var$ownKeys(o);
};
function $6dd4e5592687d246$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $6dd4e5592687d246$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $6dd4e5592687d246$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $6dd4e5592687d246$var$__setModuleDefault(result, mod);
    return result;
}
function $6dd4e5592687d246$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $6dd4e5592687d246$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6dd4e5592687d246$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6dd4e5592687d246$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $1PKUs._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6dd4e5592687d246$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $1PKUs._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6dd4e5592687d246$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6dd4e5592687d246$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6dd4e5592687d246$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $6dd4e5592687d246$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $6dd4e5592687d246$export$2e2bcd8739ae039 = {
    __extends: $6dd4e5592687d246$export$a8ba968b8961cb8a,
    __assign: $6dd4e5592687d246$export$18ce0697a983be9b,
    __rest: $6dd4e5592687d246$export$3c9a16f847548506,
    __decorate: $6dd4e5592687d246$export$29e00dfd3077644b,
    __param: $6dd4e5592687d246$export$d5ad3fd78186038f,
    __esDecorate: $6dd4e5592687d246$export$3a84e1ae4e97e9b0,
    __runInitializers: $6dd4e5592687d246$export$d831c04e792af3d,
    __propKey: $6dd4e5592687d246$export$6a2a36740a146cb8,
    __setFunctionName: $6dd4e5592687d246$export$d1a06452d3489bc7,
    __metadata: $6dd4e5592687d246$export$f1db080c865becb9,
    __awaiter: $6dd4e5592687d246$export$1050f835b63b671e,
    __generator: $6dd4e5592687d246$export$67ebef60e6f28a6,
    __createBinding: $6dd4e5592687d246$export$45d3717a4c69092e,
    __exportStar: $6dd4e5592687d246$export$f33643c0debef087,
    __values: $6dd4e5592687d246$export$19a8beecd37a4c45,
    __read: $6dd4e5592687d246$export$8d051b38c9118094,
    __spread: $6dd4e5592687d246$export$afc72e2116322959,
    __spreadArrays: $6dd4e5592687d246$export$6388937ca91ccae8,
    __spreadArray: $6dd4e5592687d246$export$1216008129fb82ed,
    __await: $6dd4e5592687d246$export$10c90e4f7922046c,
    __asyncGenerator: $6dd4e5592687d246$export$e427f37a30a4de9b,
    __asyncDelegator: $6dd4e5592687d246$export$bbd80228419bb833,
    __asyncValues: $6dd4e5592687d246$export$e3b29a3d6162315f,
    __makeTemplateObject: $6dd4e5592687d246$export$4fb47efe1390b86f,
    __importStar: $6dd4e5592687d246$export$c21735bcef00d192,
    __importDefault: $6dd4e5592687d246$export$da59b14a69baef04,
    __classPrivateFieldGet: $6dd4e5592687d246$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6dd4e5592687d246$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6dd4e5592687d246$export$81fdc39f203e4e04,
    __addDisposableResource: $6dd4e5592687d246$export$88ac25d8e944e405,
    __disposeResources: $6dd4e5592687d246$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $6dd4e5592687d246$export$889dfb5d17574b0b
};

});
parcelRegister("1PKUs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $155ef11d517ef0c4$export$71511d61b312f219; });
function $155ef11d517ef0c4$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("8MSeJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $665ce0af0488a208$export$71511d61b312f219; });
function $665ce0af0488a208$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eSf5K", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad41d0bd3a5ed0f7$export$71511d61b312f219; });
function $ad41d0bd3a5ed0f7$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("537SV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3ad35952737de5da$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $3ad35952737de5da$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $a3d64._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $a3d64._)(o, minLen);
}

});
parcelRegister("a3d64", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $751457f6259d374a$export$71511d61b312f219; });
function $751457f6259d374a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("hvZMf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc05409771aeea55$export$71511d61b312f219; });

var $2zPWk = parcelRequire("2zPWk");

var $91t4N = parcelRequire("91t4N");

var $eTJIp = parcelRequire("eTJIp");

var $537SV = parcelRequire("537SV");
function $cc05409771aeea55$export$71511d61b312f219(arr) {
    return (0, $2zPWk._)(arr) || (0, $91t4N._)(arr) || (0, $537SV._)(arr) || (0, $eTJIp._)();
}

});
parcelRegister("2zPWk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1e0723cca33e235d$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $1e0723cca33e235d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $a3d64._)(arr);
}

});

parcelRegister("91t4N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $691ac3035b950bbe$export$71511d61b312f219; });
function $691ac3035b950bbe$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eTJIp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad89a9d214926ab2$export$71511d61b312f219; });
function $ad89a9d214926ab2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eBaMo", function(module, exports) {

$parcel$export(module.exports, "DayGridView", function () { return DayTableView; });
$parcel$export(module.exports, "TableDateProfileGenerator", function () { return TableDateProfileGenerator; });

var $4v96Q = parcelRequire("4v96Q");

var $8MSeJ = parcelRequire("8MSeJ");

var $gia3M = parcelRequire("gia3M");

var $bFyls = parcelRequire("bFyls");

var $TCtnO = parcelRequire("TCtnO");

var $9i7pb = parcelRequire("9i7pb");

var $hvZMf = parcelRequire("hvZMf");

var $4r1TJ = parcelRequire("4r1TJ");

var $kG1qx = parcelRequire("kG1qx");
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var TableView = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(TableView, DateComponent);
    function TableView() {
        (0, $8MSeJ._)(this, TableView);
        var _this;
        _this = (0, $4v96Q._)(this, TableView, arguments);
        _this.headerElRef = (0, $kG1qx.createRef)();
        return _this;
    }
    (0, $gia3M._)(TableView, [
        {
            key: "renderSimpleLayout",
            value: function renderSimpleLayout(headerRowContent, bodyContent) {
                var _this = this, props = _this.props, context = _this.context;
                var sections = [];
                var stickyHeaderDates = (0, $4r1TJ.ca)(context.options);
                if (headerRowContent) sections.push({
                    type: 'header',
                    key: 'header',
                    isSticky: stickyHeaderDates,
                    chunk: {
                        elRef: this.headerElRef,
                        tableClassName: 'fc-col-header',
                        rowContent: headerRowContent
                    }
                });
                sections.push({
                    type: 'body',
                    key: 'body',
                    liquid: true,
                    chunk: {
                        content: bodyContent
                    }
                });
                return (0, $kG1qx.createElement)((0, $4r1TJ.cq), {
                    elClasses: [
                        'fc-daygrid'
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kG1qx.createElement)((0, $4r1TJ.bZ), {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    collapsibleWidth: props.forPrint,
                    cols: [],
                    sections: sections
                }));
            }
        },
        {
            key: "renderHScrollLayout",
            value: function renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
                var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
                if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
                var _this = this, props = _this.props, context = _this.context;
                var stickyHeaderDates = !props.forPrint && (0, $4r1TJ.ca)(context.options);
                var stickyFooterScrollbar = !props.forPrint && (0, $4r1TJ.c9)(context.options);
                var sections = [];
                if (headerRowContent) sections.push({
                    type: 'header',
                    key: 'header',
                    isSticky: stickyHeaderDates,
                    chunks: [
                        {
                            key: 'main',
                            elRef: this.headerElRef,
                            tableClassName: 'fc-col-header',
                            rowContent: headerRowContent
                        }
                    ]
                });
                sections.push({
                    type: 'body',
                    key: 'body',
                    liquid: true,
                    chunks: [
                        {
                            key: 'main',
                            content: bodyContent
                        }
                    ]
                });
                if (stickyFooterScrollbar) sections.push({
                    type: 'footer',
                    key: 'footer',
                    isSticky: true,
                    chunks: [
                        {
                            key: 'main',
                            content: (0, $4r1TJ.c8)
                        }
                    ]
                });
                return (0, $kG1qx.createElement)((0, $4r1TJ.cq), {
                    elClasses: [
                        'fc-daygrid'
                    ],
                    viewSpec: context.viewSpec
                }, (0, $kG1qx.createElement)(ScrollGrid, {
                    liquid: !props.isHeightAuto && !props.forPrint,
                    forPrint: props.forPrint,
                    collapsibleWidth: props.forPrint,
                    colGroups: [
                        {
                            cols: [
                                {
                                    span: colCnt,
                                    minWidth: dayMinWidth
                                }
                            ]
                        }
                    ],
                    sections: sections
                }));
            }
        }
    ]);
    return TableView;
}((0, $4r1TJ.bc));
function splitSegsByRow(segs, rowCnt) {
    var byRow = [];
    for(var i = 0; i < rowCnt; i += 1)byRow[i] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            byRow[seg.row].push(seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    var byCol = [];
    for(var i = 0; i < colCnt; i += 1)byCol[i] = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            byCol[seg.firstCol].push(seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    var byRow = [];
    if (!ui) for(var i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(var i1 = 0; i1 < rowCnt; i1 += 1)byRow[i1] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ui.segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var seg = _step.value;
                byRow[seg.row].segs.push(seg);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return byRow;
}
var DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $4r1TJ.x)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow'
});
function hasListItemDisplay(seg) {
    var display = seg.eventRange.ui.display;
    return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
var TableBlockEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(TableBlockEvent, BaseComponent);
    function TableBlockEvent() {
        (0, $8MSeJ._)(this, TableBlockEvent);
        return (0, $4v96Q._)(this, TableBlockEvent, arguments);
    }
    (0, $gia3M._)(TableBlockEvent, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                return (0, $kG1qx.createElement)((0, $4r1TJ.cg), Object.assign({}, props, {
                    elClasses: [
                        'fc-daygrid-event',
                        'fc-daygrid-block-event',
                        'fc-h-event'
                    ],
                    defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT,
                    defaultDisplayEventEnd: props.defaultDisplayEventEnd,
                    disableResizing: !props.seg.eventRange.def.allDay
                }));
            }
        }
    ]);
    return TableBlockEvent;
}((0, $4r1TJ.B));
var TableListItemEvent = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(TableListItemEvent, BaseComponent);
    function TableListItemEvent() {
        (0, $8MSeJ._)(this, TableListItemEvent);
        return (0, $4v96Q._)(this, TableListItemEvent, arguments);
    }
    (0, $gia3M._)(TableListItemEvent, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var timeFormat = options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
                var timeText = (0, $4r1TJ.bO)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
                return (0, $kG1qx.createElement)((0, $4r1TJ.ck), Object.assign({}, props, {
                    elTag: "a",
                    elClasses: [
                        'fc-daygrid-event',
                        'fc-daygrid-dot-event'
                    ],
                    elAttrs: (0, $4r1TJ.bS)(props.seg, context),
                    defaultGenerator: renderInnerContent,
                    timeText: timeText,
                    isResizing: false,
                    isDateSelecting: false
                }));
            }
        }
    ]);
    return TableListItemEvent;
}((0, $4r1TJ.B));
function renderInnerContent(renderProps) {
    return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, (0, $kG1qx.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $kG1qx.createElement)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $kG1qx.createElement)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, "\u00A0")));
}
var TableCellMoreLink = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(TableCellMoreLink, BaseComponent);
    function TableCellMoreLink() {
        (0, $8MSeJ._)(this, TableCellMoreLink);
        var _this;
        _this = (0, $4v96Q._)(this, TableCellMoreLink, arguments);
        _this.compileSegs = (0, $4r1TJ.z)(compileSegs);
        return _this;
    }
    (0, $gia3M._)(TableCellMoreLink, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this_compileSegs = this.compileSegs(props.singlePlacements), allSegs = _this_compileSegs.allSegs, invisibleSegs = _this_compileSegs.invisibleSegs;
                return (0, $kG1qx.createElement)((0, $4r1TJ.co), {
                    elClasses: [
                        'fc-daygrid-more-link'
                    ],
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    allDayDate: props.allDayDate,
                    moreCnt: props.moreCnt,
                    allSegs: allSegs,
                    hiddenSegs: invisibleSegs,
                    alignmentElRef: props.alignmentElRef,
                    alignGridTop: props.alignGridTop,
                    extraDateSpan: props.extraDateSpan,
                    popoverContent: function() {
                        var isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                        return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, allSegs.map(function(seg) {
                            var instanceId = seg.eventRange.instance.instanceId;
                            return (0, $kG1qx.createElement)("div", {
                                className: "fc-daygrid-event-harness",
                                key: instanceId,
                                style: {
                                    visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                                }
                            }, hasListItemDisplay(seg) ? (0, $kG1qx.createElement)(TableListItemEvent, Object.assign({
                                seg: seg,
                                isDragging: false,
                                isSelected: instanceId === props.eventSelection,
                                defaultDisplayEventEnd: false
                            }, (0, $4r1TJ.bQ)(seg, props.todayRange))) : (0, $kG1qx.createElement)(TableBlockEvent, Object.assign({
                                seg: seg,
                                isDragging: false,
                                isResizing: false,
                                isDateSelecting: false,
                                isSelected: instanceId === props.eventSelection,
                                defaultDisplayEventEnd: false
                            }, (0, $4r1TJ.bQ)(seg, props.todayRange))));
                        }));
                    }
                });
            }
        }
    ]);
    return TableCellMoreLink;
}((0, $4r1TJ.B));
function compileSegs(singlePlacements) {
    var allSegs = [];
    var invisibleSegs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = singlePlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var placement = _step.value;
            allSegs.push(placement.seg);
            if (!placement.isVisible) invisibleSegs.push(placement.seg);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
var DEFAULT_WEEK_NUM_FORMAT = (0, $4r1TJ.x)({
    week: 'narrow'
});
var TableCell = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(TableCell, DateComponent);
    function TableCell() {
        (0, $8MSeJ._)(this, TableCell);
        var _this;
        _this = (0, $4v96Q._)(this, TableCell, arguments);
        _this.rootElRef = (0, $kG1qx.createRef)();
        _this.state = {
            dayNumberId: (0, $4r1TJ.a3)()
        };
        _this.handleRootEl = function(el) {
            (0, $4r1TJ.W)(_this.rootElRef, el);
            (0, $4r1TJ.W)(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $gia3M._)(TableCell, [
        {
            key: "render",
            value: function render() {
                var _this = this, context = _this.context, props = _this.props, state = _this.state, rootElRef = _this.rootElRef;
                var options = context.options, dateEnv = context.dateEnv;
                var date = props.date, dateProfile = props.dateProfile;
                // TODO: memoize this?
                var isMonthStart = props.showDayNumber && shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
                return (0, $kG1qx.createElement)((0, $4r1TJ.ci), {
                    elTag: "td",
                    elRef: this.handleRootEl,
                    elClasses: [
                        'fc-daygrid-day'
                    ].concat((0, $hvZMf._)(props.extraClassNames || [])),
                    elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                        'aria-labelledby': state.dayNumberId
                    } : {}), {
                        role: 'gridcell'
                    }),
                    defaultGenerator: renderTopInner,
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: props.todayRange,
                    showDayNumber: props.showDayNumber,
                    isMonthStart: isMonthStart,
                    extraRenderProps: props.extraRenderProps
                }, function(InnerContent, renderProps) {
                    return (0, $kG1qx.createElement)("div", {
                        ref: props.innerElRef,
                        className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                        style: {
                            minHeight: props.minHeight
                        }
                    }, props.showWeekNumber && (0, $kG1qx.createElement)((0, $4r1TJ.cn), {
                        elTag: "a",
                        elClasses: [
                            'fc-daygrid-week-number'
                        ],
                        elAttrs: (0, $4r1TJ.a_)(context, date, 'week'),
                        date: date,
                        defaultFormat: DEFAULT_WEEK_NUM_FORMAT
                    }), !renderProps.isDisabled && (props.showDayNumber || (0, $4r1TJ.cj)(options) || props.forceDayTop) ? (0, $kG1qx.createElement)("div", {
                        className: "fc-daygrid-day-top"
                    }, (0, $kG1qx.createElement)(InnerContent, {
                        elTag: "a",
                        elClasses: [
                            'fc-daygrid-day-number',
                            isMonthStart && 'fc-daygrid-month-start'
                        ],
                        elAttrs: Object.assign(Object.assign({}, (0, $4r1TJ.a_)(context, date)), {
                            id: state.dayNumberId
                        })
                    })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
                    (0, $kG1qx.createElement)("div", {
                        className: "fc-daygrid-day-top",
                        style: {
                            visibility: 'hidden'
                        }
                    }, (0, $kG1qx.createElement)("a", {
                        className: "fc-daygrid-day-number"
                    }, "\u00A0")) : undefined, (0, $kG1qx.createElement)("div", {
                        className: "fc-daygrid-day-events",
                        ref: props.fgContentElRef
                    }, props.fgContent, (0, $kG1qx.createElement)("div", {
                        className: "fc-daygrid-day-bottom",
                        style: {
                            marginTop: props.moreMarginTop
                        }
                    }, (0, $kG1qx.createElement)(TableCellMoreLink, {
                        allDayDate: date,
                        singlePlacements: props.singlePlacements,
                        moreCnt: props.moreCnt,
                        alignmentElRef: rootElRef,
                        alignGridTop: !props.showDayNumber,
                        extraDateSpan: props.extraDateSpan,
                        dateProfile: props.dateProfile,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        todayRange: props.todayRange
                    }))), (0, $kG1qx.createElement)("div", {
                        className: "fc-daygrid-day-bg"
                    }, props.bgContent));
                });
            }
        }
    ]);
    return TableCell;
}((0, $4r1TJ.bc));
function renderTopInner(props) {
    return props.dayNumberText || (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, "\u00A0");
}
function shouldDisplayMonthStart(date, currentRange, dateEnv) {
    var currentStart = currentRange.start, currentEnd = currentRange.end;
    var currentEndIncl = (0, $4r1TJ.be)(currentEnd, -1);
    var currentFirstYear = dateEnv.getYear(currentStart);
    var currentFirstMonth = dateEnv.getMonth(currentStart);
    var currentLastYear = dateEnv.getYear(currentEndIncl);
    var currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ':' + seg.firstCol;
}
function generateSegUid(seg) {
    return generateSegKey(seg) + ':' + seg.lastCol;
}
function computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    var hierarchy = new DayGridSegHierarchy(function(segEntry) {
        // TODO: more DRY with generateSegUid
        var segUid = segs[segEntry.index].eventRange.instance.instanceId + ':' + segEntry.span.start + ':' + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    var segInputs = [];
    var unknownHeightSegs = [];
    for(var i = 0; i < segs.length; i += 1){
        var seg = segs[i];
        var segUid = generateSegUid(seg);
        var eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var segRects = hierarchy.toRects();
    var _placeRects = placeRects(segRects, segs, cells), singleColPlacements = _placeRects.singleColPlacements, multiColPlacements = _placeRects.multiColPlacements, leftoverMargins = _placeRects.leftoverMargins;
    var moreCnts = [];
    var moreMarginTops = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add segs with unknown heights
        for(var _iterator = unknownHeightSegs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg1 = _step.value;
            multiColPlacements[seg1.firstCol].push({
                seg: seg1,
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(var col = seg1.firstCol; col <= seg1.lastCol; col += 1)singleColPlacements[col].push({
                seg: resliceSeg(seg1, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // add the hidden entries
    for(var col1 = 0; col1 < cells.length; col1 += 1)moreCnts.push(0);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = hiddenEntries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var hiddenEntry = _step1.value;
            var seg2 = segs[hiddenEntry.index];
            var hiddenSpan = hiddenEntry.span;
            multiColPlacements[hiddenSpan.start].push({
                seg: resliceSeg(seg2, hiddenSpan.start, hiddenSpan.end, cells),
                isVisible: false,
                isAbsolute: true,
                absoluteTop: 0,
                marginTop: 0
            });
            for(var col2 = hiddenSpan.start; col2 < hiddenSpan.end; col2 += 1){
                moreCnts[col2] += 1;
                singleColPlacements[col2].push({
                    seg: resliceSeg(seg2, col2, col2 + 1, cells),
                    isVisible: false,
                    isAbsolute: false,
                    absoluteTop: 0,
                    marginTop: 0
                });
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // deal with leftover margins
    for(var col3 = 0; col3 < cells.length; col3 += 1)moreMarginTops.push(leftoverMargins[col3]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    var rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    var singleColPlacements = [];
    var multiColPlacements = [];
    var leftoverMargins = [];
    for(var col = 0; col < cells.length; col += 1){
        var rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        var singlePlacements = [];
        var currentHeight = 0;
        var currentMarginTop = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rect = _step.value;
                var seg = segs[rect.index];
                singlePlacements.push({
                    seg: resliceSeg(seg, col, col + 1, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: rect.levelCoord - currentHeight
                });
                currentHeight = rect.levelCoord + rect.thickness;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // compute mixed static/absolute segs in multiPlacements
        var multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = rects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var rect1 = _step1.value;
                var seg1 = segs[rect1.index];
                var isAbsolute = rect1.span.end - rect1.span.start > 1; // multi-column?
                var isFirstCol = rect1.span.start === col;
                currentMarginTop += rect1.levelCoord - currentHeight; // amount of space since bottom of previous seg
                currentHeight = rect1.levelCoord + rect1.thickness; // height will now be bottom of current seg
                if (isAbsolute) {
                    currentMarginTop += rect1.thickness;
                    if (isFirstCol) multiPlacements.push({
                        seg: resliceSeg(seg1, rect1.span.start, rect1.span.end, cells),
                        isVisible: true,
                        isAbsolute: true,
                        absoluteTop: rect1.levelCoord,
                        marginTop: 0
                    });
                } else if (isFirstCol) {
                    multiPlacements.push({
                        seg: resliceSeg(seg1, rect1.span.start, rect1.span.end, cells),
                        isVisible: true,
                        isAbsolute: false,
                        absoluteTop: rect1.levelCoord,
                        marginTop: currentMarginTop
                    });
                    currentMarginTop = 0;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function groupRectsByEachCol(rects, colCnt) {
    var rectsByEachCol = [];
    for(var col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rect = _step.value;
            for(var col1 = rect.span.start; col1 < rect.span.end; col1 += 1)rectsByEachCol[col1].push(rect);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    var eventRange = seg.eventRange;
    var origRange = eventRange.range;
    var slicedRange = (0, $4r1TJ.o)(origRange, {
        start: cells[spanStart].date,
        end: (0, $4r1TJ.t)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
var DayGridSegHierarchy = /*#__PURE__*/ function(SegHierarchy) {
    "use strict";
    (0, $9i7pb._)(DayGridSegHierarchy, SegHierarchy);
    function DayGridSegHierarchy() {
        (0, $8MSeJ._)(this, DayGridSegHierarchy);
        var _this;
        _this = (0, $4v96Q._)(this, DayGridSegHierarchy, arguments);
        // config
        _this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        _this.forceHidden = {};
        return _this;
    }
    (0, $gia3M._)(DayGridSegHierarchy, [
        {
            key: "addSegs",
            value: function addSegs(segInputs) {
                var _this = this;
                var hiddenSegs = (0, $bFyls._)((0, $TCtnO._)(DayGridSegHierarchy.prototype), "addSegs", this).call(this, segInputs);
                var entriesByLevel = this.entriesByLevel;
                var excludeHidden = function(entry) {
                    return !_this.forceHidden[(0, $4r1TJ.bz)(entry)];
                };
                // remove the forced-hidden segs
                for(var level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
                return hiddenSegs;
            }
        },
        {
            key: "handleInvalidInsertion",
            value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
                var _this = this, entriesByLevel = _this.entriesByLevel, forceHidden = _this.forceHidden;
                var touchingEntry = insertion.touchingEntry, touchingLevel = insertion.touchingLevel, touchingLateral = insertion.touchingLateral;
                // the entry that the new insertion is touching must be hidden
                if (this.hiddenConsumes && touchingEntry) {
                    var touchingEntryId = (0, $4r1TJ.bz)(touchingEntry);
                    if (!forceHidden[touchingEntryId]) {
                        if (this.allowReslicing) {
                            // split up the touchingEntry, reinsert it
                            var hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                                span: (0, $4r1TJ.bD)(touchingEntry.span, entry.span)
                            });
                            // reinsert the area that turned into a "more" link (so no other entries try to
                            // occupy the space) but mark it forced-hidden
                            var hiddenEntryId = (0, $4r1TJ.bz)(hiddenEntry);
                            forceHidden[hiddenEntryId] = true;
                            entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                            hiddenEntries.push(hiddenEntry);
                            this.splitEntry(touchingEntry, entry, hiddenEntries);
                        } else {
                            forceHidden[touchingEntryId] = true;
                            hiddenEntries.push(touchingEntry);
                        }
                    }
                }
                // will try to reslice...
                (0, $bFyls._)((0, $TCtnO._)(DayGridSegHierarchy.prototype), "handleInvalidInsertion", this).call(this, insertion, entry, hiddenEntries);
            }
        }
    ]);
    return DayGridSegHierarchy;
}((0, $4r1TJ.by));
var TableRow = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(TableRow, DateComponent);
    function TableRow() {
        (0, $8MSeJ._)(this, TableRow);
        var _this;
        _this = (0, $4v96Q._)(this, TableRow, arguments);
        _this.cellElRefs = new (0, $4r1TJ.cd)(); // the <td>
        _this.frameElRefs = new (0, $4r1TJ.cd)(); // the fc-daygrid-day-frame
        _this.fgElRefs = new (0, $4r1TJ.cd)(); // the fc-daygrid-day-events
        _this.segHarnessRefs = new (0, $4r1TJ.cd)(); // indexed by "instanceId:firstCol"
        _this.rootElRef = (0, $kG1qx.createRef)();
        _this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        _this.handleResize = function(isForced) {
            if (isForced) _this.updateSizing(true); // isExternal=true
        };
        return _this;
    }
    (0, $gia3M._)(TableRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, state = _this1.state, context = _this1.context;
                var options = context.options;
                var colCnt = props.cells.length;
                var businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
                var bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
                var highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
                var mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
                var _computeFgSegPlacement = computeFgSegPlacement((0, $4r1TJ.bP)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells), singleColPlacements = _computeFgSegPlacement.singleColPlacements, multiColPlacements = _computeFgSegPlacement.multiColPlacements, moreCnts = _computeFgSegPlacement.moreCnts, moreMarginTops = _computeFgSegPlacement.moreMarginTops;
                var isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
                return (0, $kG1qx.createElement)("tr", {
                    ref: this.rootElRef,
                    role: "row"
                }, props.renderIntro && props.renderIntro(), props.cells.map(function(cell, col) {
                    var normalFgNodes = _this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
                    var mirrorFgNodes = _this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
                    return (0, $kG1qx.createElement)(TableCell, {
                        key: cell.key,
                        elRef: _this.cellElRefs.createRef(cell.key),
                        innerElRef: _this.frameElRefs.createRef(cell.key),
                        dateProfile: props.dateProfile,
                        date: cell.date,
                        showDayNumber: props.showDayNumbers,
                        showWeekNumber: props.showWeekNumbers && col === 0,
                        forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                        todayRange: props.todayRange,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        extraRenderProps: cell.extraRenderProps,
                        extraDataAttrs: cell.extraDataAttrs,
                        extraClassNames: cell.extraClassNames,
                        extraDateSpan: cell.extraDateSpan,
                        moreCnt: moreCnts[col],
                        moreMarginTop: moreMarginTops[col],
                        singlePlacements: singleColPlacements[col],
                        fgContentElRef: _this.fgElRefs.createRef(cell.key),
                        fgContent: (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, normalFgNodes), (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, mirrorFgNodes)),
                        bgContent: (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, _this.renderFillSegs(highlightSegsByCol[col], 'highlight'), _this.renderFillSegs(businessHoursByCol[col], 'non-business'), _this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                        minHeight: props.cellMinHeight
                    });
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateSizing(true);
                this.context.addResizeHandler(this.handleResize);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var currentProps = this.props;
                this.updateSizing(!(0, $4r1TJ.E)(prevProps, currentProps));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleResize);
            }
        },
        {
            key: "getHighlightSegs",
            value: function getHighlightSegs() {
                var props = this.props;
                if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
                if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
                return props.dateSelectionSegs;
            }
        },
        {
            key: "getMirrorSegs",
            value: function getMirrorSegs() {
                var props = this.props;
                if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
                return [];
            }
        },
        {
            key: "renderFgSegs",
            value: function renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
                var context = this.context;
                var eventSelection = this.props.eventSelection;
                var framePositions = this.state.framePositions;
                var defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
                var isMirror = isDragging || isResizing || isDateSelecting;
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (framePositions) try {
                    for(var _iterator = segPlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var placement = _step.value;
                        var seg = placement.seg;
                        var instanceId = seg.eventRange.instance.instanceId;
                        var isVisible = placement.isVisible && !isForcedInvisible[instanceId];
                        var isAbsolute = placement.isAbsolute;
                        var left = '';
                        var right = '';
                        if (isAbsolute) {
                            if (context.isRtl) {
                                right = 0;
                                left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                            } else {
                                left = 0;
                                right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                            }
                        }
                        /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $kG1qx.createElement)("div", {
                            className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                            key: generateSegKey(seg),
                            ref: isMirror ? null : this.segHarnessRefs.createRef(generateSegUid(seg)),
                            style: {
                                visibility: isVisible ? '' : 'hidden',
                                marginTop: isAbsolute ? '' : placement.marginTop,
                                top: isAbsolute ? placement.absoluteTop : '',
                                left: left,
                                right: right
                            }
                        }, hasListItemDisplay(seg) ? (0, $kG1qx.createElement)(TableListItemEvent, Object.assign({
                            seg: seg,
                            isDragging: isDragging,
                            isSelected: instanceId === eventSelection,
                            defaultDisplayEventEnd: defaultDisplayEventEnd
                        }, (0, $4r1TJ.bQ)(seg, todayRange))) : (0, $kG1qx.createElement)(TableBlockEvent, Object.assign({
                            seg: seg,
                            isDragging: isDragging,
                            isResizing: isResizing,
                            isDateSelecting: isDateSelecting,
                            isSelected: instanceId === eventSelection,
                            defaultDisplayEventEnd: defaultDisplayEventEnd
                        }, (0, $4r1TJ.bQ)(seg, todayRange)))));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return nodes;
            }
        },
        {
            key: "renderFillSegs",
            value: function renderFillSegs(segs, fillType) {
                var isRtl = this.context.isRtl;
                var todayRange = this.props.todayRange;
                var framePositions = this.state.framePositions;
                var nodes = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (framePositions) try {
                    for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seg = _step.value;
                        var leftRightCss = isRtl ? {
                            right: 0,
                            left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
                        } : {
                            left: 0,
                            right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
                        };
                        nodes.push((0, $kG1qx.createElement)("div", {
                            key: (0, $4r1TJ.bR)(seg.eventRange),
                            className: "fc-daygrid-bg-harness",
                            style: leftRightCss
                        }, fillType === 'bg-event' ? (0, $kG1qx.createElement)((0, $4r1TJ.cm), Object.assign({
                            seg: seg
                        }, (0, $4r1TJ.bQ)(seg, todayRange))) : (0, $4r1TJ.cl)(fillType)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return (0, $kG1qx.createElement).apply(void 0, [
                    (0, $kG1qx.Fragment),
                    {}
                ].concat((0, $hvZMf._)(nodes)));
            }
        },
        {
            key: "updateSizing",
            value: function updateSizing(isExternalSizingChange) {
                var _this = this, props = _this.props, state = _this.state, frameElRefs = _this.frameElRefs;
                if (!props.forPrint && props.clientWidth !== null // positioning ready?
                ) {
                    if (isExternalSizingChange) {
                        var frameEls = props.cells.map(function(cell) {
                            return frameElRefs.currentMap[cell.key];
                        });
                        if (frameEls.length) {
                            var originEl = this.rootElRef.current;
                            var newPositionCache = new (0, $4r1TJ.b8)(originEl, frameEls, true, false);
                            if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                                framePositions: new (0, $4r1TJ.b8)(originEl, frameEls, true, false)
                            });
                        }
                    }
                    var oldSegHeights = this.state.segHeights;
                    var newSegHeights = this.querySegHeights();
                    var limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
                    this.safeSetState({
                        // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                        // Essentially, once you compute an element's height, never null-out.
                        // TODO: always display all events, as visibility:hidden?
                        segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                        maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
                    });
                }
            }
        },
        {
            key: "querySegHeights",
            value: function querySegHeights() {
                var segElMap = this.segHarnessRefs.currentMap;
                var segHeights = {};
                // get the max height amongst instance segs
                for(var segUid in segElMap){
                    var height = Math.round(segElMap[segUid].getBoundingClientRect().height);
                    segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
                }
                return segHeights;
            }
        },
        {
            key: "computeMaxContentHeight",
            value: function computeMaxContentHeight() {
                var firstKey = this.props.cells[0].key;
                var cellEl = this.cellElRefs.currentMap[firstKey];
                var fcContainerEl = this.fgElRefs.currentMap[firstKey];
                return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
            }
        },
        {
            key: "getCellEls",
            value: function getCellEls() {
                var elMap = this.cellElRefs.currentMap;
                return this.props.cells.map(function(cell) {
                    return elMap[cell.key];
                });
            }
        }
    ]);
    return TableRow;
}((0, $4r1TJ.bc));
TableRow.addStateEquality({
    segHeights: (0, $4r1TJ.E)
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    var topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map(function(seg) {
        return {
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        };
    });
}
function buildAbsoluteTopHash(colPlacements) {
    var topsByInstanceId = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = colPlacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var placements = _step.value;
            try {
                for(var _iterator1 = placements[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var placement = _step1.value;
                    topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return topsByInstanceId;
}
var TableRows = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(TableRows, DateComponent);
    function TableRows() {
        (0, $8MSeJ._)(this, TableRows);
        var _this;
        _this = (0, $4v96Q._)(this, TableRows, arguments);
        _this.splitBusinessHourSegs = (0, $4r1TJ.z)(splitSegsByRow);
        _this.splitBgEventSegs = (0, $4r1TJ.z)(splitAllDaySegsByRow);
        _this.splitFgEventSegs = (0, $4r1TJ.z)(splitSegsByRow);
        _this.splitDateSelectionSegs = (0, $4r1TJ.z)(splitSegsByRow);
        _this.splitEventDrag = (0, $4r1TJ.z)(splitInteractionByRow);
        _this.splitEventResize = (0, $4r1TJ.z)(splitInteractionByRow);
        _this.rowRefs = new (0, $4r1TJ.cd)();
        return _this;
    }
    (0, $gia3M._)(TableRows, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, context = _this1.context;
                var rowCnt = props.cells.length;
                var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
                var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
                var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
                var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
                var eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
                var eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
                // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
                // choose 7 because a month view will have max 6 rows
                var cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
                return (0, $kG1qx.createElement)((0, $4r1TJ.a6), {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, props.cells.map(function(cells, row) {
                        return (0, $kG1qx.createElement)(TableRow, {
                            ref: _this.rowRefs.createRef(row),
                            key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                            ,
                            showDayNumbers: rowCnt > 1,
                            showWeekNumbers: props.showWeekNumbers,
                            todayRange: todayRange,
                            dateProfile: props.dateProfile,
                            cells: cells,
                            renderIntro: props.renderRowIntro,
                            businessHourSegs: businessHourSegsByRow[row],
                            eventSelection: props.eventSelection,
                            bgEventSegs: bgEventSegsByRow[row],
                            fgEventSegs: fgEventSegsByRow[row],
                            dateSelectionSegs: dateSelectionSegsByRow[row],
                            eventDrag: eventDragByRow[row],
                            eventResize: eventResizeByRow[row],
                            dayMaxEvents: props.dayMaxEvents,
                            dayMaxEventRows: props.dayMaxEventRows,
                            clientWidth: props.clientWidth,
                            clientHeight: props.clientHeight,
                            cellMinHeight: cellMinHeight,
                            forPrint: props.forPrint
                        });
                    }));
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.registerInteractiveComponent();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // for if started with zero cells
                this.registerInteractiveComponent();
            }
        },
        {
            key: "registerInteractiveComponent",
            value: function registerInteractiveComponent() {
                if (!this.rootEl) {
                    // HACK: need a daygrid wrapper parent to do positioning
                    // NOTE: a daygrid resource view w/o resources can have zero cells
                    var firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
                    var rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
                    if (rootEl) {
                        this.rootEl = rootEl;
                        this.context.registerInteractiveComponent(this, {
                            el: rootEl,
                            isHitComboAllowed: this.props.isHitComboAllowed
                        });
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.rootEl) {
                    this.context.unregisterInteractiveComponent(this);
                    this.rootEl = null;
                }
            }
        },
        {
            // Hit System
            // ----------------------------------------------------------------------------------------------------
            key: "prepareHits",
            value: function prepareHits() {
                this.rowPositions = new (0, $4r1TJ.b8)(this.rootEl, this.rowRefs.collect().map(function(rowObj) {
                    return rowObj.getCellEls()[0];
                }), false, true);
                this.colPositions = new (0, $4r1TJ.b8)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop) {
                var _this = this, colPositions = _this.colPositions, rowPositions = _this.rowPositions;
                var col = colPositions.leftToIndex(positionLeft);
                var row = rowPositions.topToIndex(positionTop);
                if (row != null && col != null) {
                    var cell = this.props.cells[row][col];
                    return {
                        dateProfile: this.props.dateProfile,
                        dateSpan: Object.assign({
                            range: this.getCellRange(row, col),
                            allDay: true
                        }, cell.extraDateSpan),
                        dayEl: this.getCellEl(row, col),
                        rect: {
                            left: colPositions.lefts[col],
                            right: colPositions.rights[col],
                            top: rowPositions.tops[row],
                            bottom: rowPositions.bottoms[row]
                        },
                        layer: 0
                    };
                }
                return null;
            }
        },
        {
            key: "getCellEl",
            value: function getCellEl(row, col) {
                return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
            }
        },
        {
            key: "getCellRange",
            value: function getCellRange(row, col) {
                var start = this.props.cells[row][col].date;
                var end = (0, $4r1TJ.t)(start, 1);
                return {
                    start: start,
                    end: end
                };
            }
        }
    ]);
    return TableRows;
}((0, $4r1TJ.bc));
function splitAllDaySegsByRow(segs, rowCnt) {
    return splitSegsByRow(segs.filter(isSegAllDay), rowCnt);
}
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
var Table = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(Table, DateComponent);
    function Table() {
        (0, $8MSeJ._)(this, Table);
        var _this;
        _this = (0, $4v96Q._)(this, Table, arguments);
        _this.elRef = (0, $kG1qx.createRef)();
        _this.needsScrollReset = false;
        return _this;
    }
    (0, $gia3M._)(Table, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var dayMaxEventRows = props.dayMaxEventRows, dayMaxEvents = props.dayMaxEvents, expandRows = props.expandRows;
                var limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
                // if rows can't expand to fill fixed height, can't do balanced-height event limit
                // TODO: best place to normalize these options?
                if (limitViaBalanced && !expandRows) {
                    limitViaBalanced = false;
                    dayMaxEventRows = null;
                    dayMaxEvents = null;
                }
                var classNames = [
                    'fc-daygrid-body',
                    limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
                    expandRows ? '' : 'fc-daygrid-body-natural'
                ];
                return (0, $kG1qx.createElement)("div", {
                    ref: this.elRef,
                    className: classNames.join(' '),
                    style: {
                        // these props are important to give this wrapper correct dimensions for interactions
                        // TODO: if we set it here, can we avoid giving to inner tables?
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth
                    }
                }, (0, $kG1qx.createElement)("table", {
                    role: "presentation",
                    className: "fc-scrollgrid-sync-table",
                    style: {
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth,
                        height: expandRows ? props.clientHeight : ''
                    }
                }, props.colGroupNode, (0, $kG1qx.createElement)("tbody", {
                    role: "presentation"
                }, (0, $kG1qx.createElement)(TableRows, {
                    dateProfile: props.dateProfile,
                    cells: props.cells,
                    renderRowIntro: props.renderRowIntro,
                    showWeekNumbers: props.showWeekNumbers,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    businessHourSegs: props.businessHourSegs,
                    bgEventSegs: props.bgEventSegs,
                    fgEventSegs: props.fgEventSegs,
                    dateSelectionSegs: props.dateSelectionSegs,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    dayMaxEvents: dayMaxEvents,
                    dayMaxEventRows: dayMaxEventRows,
                    forPrint: props.forPrint,
                    isHitComboAllowed: props.isHitComboAllowed
                }))));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.requestScrollReset();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
                else this.flushScrollReset();
            }
        },
        {
            key: "requestScrollReset",
            value: function requestScrollReset() {
                this.needsScrollReset = true;
                this.flushScrollReset();
            }
        },
        {
            key: "flushScrollReset",
            value: function flushScrollReset() {
                if (this.needsScrollReset && this.props.clientWidth // sizes computed?
                ) {
                    var subjectEl = getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
                    if (subjectEl) {
                        var originEl = subjectEl.closest('.fc-daygrid-body');
                        var scrollEl = originEl.closest('.fc-scroller');
                        var scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                        scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
                    }
                    this.needsScrollReset = false;
                }
            }
        }
    ]);
    return Table;
}((0, $4r1TJ.bc));
function getScrollSubjectEl(containerEl, dateProfile) {
    var el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector('[data-date="'.concat((0, $4r1TJ.bv)(dateProfile.currentDate), '-01"]'));
    if (!el) el = containerEl.querySelector('[data-date="'.concat((0, $4r1TJ.bt)(dateProfile.currentDate), '"]'));
    return el;
}
var DayTableSlicer = /*#__PURE__*/ function(Slicer) {
    "use strict";
    (0, $9i7pb._)(DayTableSlicer, Slicer);
    function DayTableSlicer() {
        (0, $8MSeJ._)(this, DayTableSlicer);
        var _this;
        _this = (0, $4v96Q._)(this, DayTableSlicer, arguments);
        _this.forceDayIfListItem = true;
        return _this;
    }
    (0, $gia3M._)(DayTableSlicer, [
        {
            key: "sliceRange",
            value: function sliceRange(dateRange, dayTableModel) {
                return dayTableModel.sliceRange(dateRange);
            }
        }
    ]);
    return DayTableSlicer;
}((0, $4r1TJ.bU));
var DayTable = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(DayTable, DateComponent);
    function DayTable() {
        (0, $8MSeJ._)(this, DayTable);
        var _this;
        _this = (0, $4v96Q._)(this, DayTable, arguments);
        _this.slicer = new DayTableSlicer();
        _this.tableRef = (0, $kG1qx.createRef)();
        return _this;
    }
    (0, $gia3M._)(DayTable, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                return (0, $kG1qx.createElement)(Table, Object.assign({
                    ref: this.tableRef
                }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
                    dateProfile: props.dateProfile,
                    cells: props.dayTableModel.cells,
                    colGroupNode: props.colGroupNode,
                    tableMinWidth: props.tableMinWidth,
                    renderRowIntro: props.renderRowIntro,
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    showWeekNumbers: props.showWeekNumbers,
                    expandRows: props.expandRows,
                    headerAlignElRef: props.headerAlignElRef,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    forPrint: props.forPrint
                }));
            }
        }
    ]);
    return DayTable;
}((0, $4r1TJ.bc));
var DayTableView = /*#__PURE__*/ function(TableView) {
    "use strict";
    (0, $9i7pb._)(DayTableView, TableView);
    function DayTableView() {
        (0, $8MSeJ._)(this, DayTableView);
        var _this;
        _this = (0, $4v96Q._)(this, DayTableView, arguments);
        _this.buildDayTableModel = (0, $4r1TJ.z)(buildDayTableModel);
        _this.headerRef = (0, $kG1qx.createRef)();
        _this.tableRef = (0, $kG1qx.createRef)();
        return _this;
    }
    (0, $gia3M._)(DayTableView, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_context = this.context, options = _this_context.options, dateProfileGenerator = _this_context.dateProfileGenerator;
                var props = this.props;
                var dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
                var headerContent = options.dayHeaders && (0, $kG1qx.createElement)((0, $4r1TJ.bI), {
                    ref: this.headerRef,
                    dateProfile: props.dateProfile,
                    dates: dayTableModel.headerDates,
                    datesRepDistinctDays: dayTableModel.rowCnt === 1
                });
                var bodyContent = function(contentArg) {
                    return (0, $kG1qx.createElement)(DayTable, {
                        ref: _this.tableRef,
                        dateProfile: props.dateProfile,
                        dayTableModel: dayTableModel,
                        businessHours: props.businessHours,
                        dateSelection: props.dateSelection,
                        eventStore: props.eventStore,
                        eventUiBases: props.eventUiBases,
                        eventSelection: props.eventSelection,
                        eventDrag: props.eventDrag,
                        eventResize: props.eventResize,
                        nextDayThreshold: options.nextDayThreshold,
                        colGroupNode: contentArg.tableColGroupNode,
                        tableMinWidth: contentArg.tableMinWidth,
                        dayMaxEvents: options.dayMaxEvents,
                        dayMaxEventRows: options.dayMaxEventRows,
                        showWeekNumbers: options.weekNumbers,
                        expandRows: !props.isHeightAuto,
                        headerAlignElRef: _this.headerElRef,
                        clientWidth: contentArg.clientWidth,
                        clientHeight: contentArg.clientHeight,
                        forPrint: props.forPrint
                    });
                };
                return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
            }
        }
    ]);
    return DayTableView;
}(TableView);
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    var daySeries = new (0, $4r1TJ.bM)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $4r1TJ.bT)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
var TableDateProfileGenerator = /*#__PURE__*/ function(DateProfileGenerator) {
    "use strict";
    (0, $9i7pb._)(TableDateProfileGenerator, DateProfileGenerator);
    function TableDateProfileGenerator() {
        (0, $8MSeJ._)(this, TableDateProfileGenerator);
        return (0, $4v96Q._)(this, TableDateProfileGenerator, arguments);
    }
    (0, $gia3M._)(TableDateProfileGenerator, [
        {
            // Computes the date range that will be rendered
            key: "buildRenderRange",
            value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
                var renderRange = (0, $bFyls._)((0, $TCtnO._)(TableDateProfileGenerator.prototype), "buildRenderRange", this).call(this, currentRange, currentRangeUnit, isRangeAllDay);
                var props = this.props;
                return buildDayTableRenderRange({
                    currentRange: renderRange,
                    snapToWeek: /^(year|month)$/.test(currentRangeUnit),
                    fixedWeekCount: props.fixedWeekCount,
                    dateEnv: props.dateEnv
                });
            }
        }
    ]);
    return TableDateProfileGenerator;
}((0, $4r1TJ.R));
function buildDayTableRenderRange(props) {
    var dateEnv = props.dateEnv, currentRange = props.currentRange;
    var start = currentRange.start, end = currentRange.end;
    var endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $4r1TJ.bf)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        var lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $4r1TJ.t)(currentRange.end, -1)));
        var rowCnt = Math.ceil((0, $4r1TJ.bg)(lastMonthRenderStart, end));
        end = (0, $4r1TJ.bf)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
var css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
(0, $4r1TJ.ct)(css_248z);

});
parcelRegister("4v96Q", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $34711f9df490b74b$export$71511d61b312f219; });

var $TCtnO = parcelRequire("TCtnO");

var $avISP = parcelRequire("avISP");

var $f9228 = parcelRequire("f9228");
function $34711f9df490b74b$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $TCtnO._)(derived);
    return (0, $f9228._)(_this, (0, $avISP._)() ? Reflect.construct(derived, args || [], (0, $TCtnO._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("TCtnO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0a72fb16f3f872cb$export$71511d61b312f219; });
function $0a72fb16f3f872cb$export$71511d61b312f219(o) {
    $0a72fb16f3f872cb$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0a72fb16f3f872cb$export$71511d61b312f219(o);
}

});

parcelRegister("avISP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7a6f9d832660fd58$export$71511d61b312f219; });
function $7a6f9d832660fd58$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($7a6f9d832660fd58$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("f9228", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b06946172dd236ba$export$71511d61b312f219; });

var $lpzwG = parcelRequire("lpzwG");

var $1PKUs = parcelRequire("1PKUs");
function $b06946172dd236ba$export$71511d61b312f219(self, call) {
    if (call && ((0, $1PKUs._)(call) === "object" || typeof call === "function")) return call;
    return (0, $lpzwG._)(self);
}

});
parcelRegister("lpzwG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f9677d87f5dc9e09$export$71511d61b312f219; });
function $f9677d87f5dc9e09$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("gia3M", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bdc6217a034a05da$export$71511d61b312f219; });
function $bdc6217a034a05da$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bdc6217a034a05da$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $bdc6217a034a05da$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bdc6217a034a05da$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("bFyls", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $87ee2a412a1bc655$export$71511d61b312f219; });

var $c3S0d = parcelRequire("c3S0d");
function $87ee2a412a1bc655$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $87ee2a412a1bc655$export$71511d61b312f219 = Reflect.get;
    else $87ee2a412a1bc655$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $c3S0d._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $87ee2a412a1bc655$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("c3S0d", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8c7fa7a1f71126fb$export$71511d61b312f219; });

var $TCtnO = parcelRequire("TCtnO");
function $8c7fa7a1f71126fb$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $TCtnO._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("9i7pb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c3b8a02d0ff6d9d$export$71511d61b312f219; });

var $8oGuN = parcelRequire("8oGuN");
function $6c3b8a02d0ff6d9d$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $8oGuN._)(subClass, superClass);
}

});
parcelRegister("8oGuN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $61d18760c3bb14a0$export$71511d61b312f219; });
function $61d18760c3bb14a0$export$71511d61b312f219(o, p) {
    $61d18760c3bb14a0$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $61d18760c3bb14a0$export$71511d61b312f219(o, p);
}

});


parcelRegister("4r1TJ", function(module, exports) {

$parcel$export(module.exports, "ct", function () { return $33ab27ec71b00902$export$e9316ff9106cdb75; });
$parcel$export(module.exports, "ab", function () { return $33ab27ec71b00902$export$555508cbc6add439; });
$parcel$export(module.exports, "D", function () { return $33ab27ec71b00902$export$96f57966bedc81b4; });
$parcel$export(module.exports, "Z", function () { return $33ab27ec71b00902$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "ac", function () { return $33ab27ec71b00902$export$2219238a014317b0; });
$parcel$export(module.exports, "a3", function () { return $33ab27ec71b00902$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "$", function () { return $33ab27ec71b00902$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "a0", function () { return $33ab27ec71b00902$export$34aec0b863436764; });
$parcel$export(module.exports, "g", function () { return $33ab27ec71b00902$export$39b482c5e57630a8; });
$parcel$export(module.exports, "k", function () { return $33ab27ec71b00902$export$342063e11d6c3cad; });
$parcel$export(module.exports, "d", function () { return $33ab27ec71b00902$export$4368d992c4eafac0; });
$parcel$export(module.exports, "s", function () { return $33ab27ec71b00902$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $33ab27ec71b00902$export$db3b6bfb95261072; });
$parcel$export(module.exports, "i", function () { return $33ab27ec71b00902$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "bf", function () { return $33ab27ec71b00902$export$151db275011178c4; });
$parcel$export(module.exports, "t", function () { return $33ab27ec71b00902$export$625550452a3fa3ec; });
$parcel$export(module.exports, "be", function () { return $33ab27ec71b00902$export$51b138e5a065c2bb; });
$parcel$export(module.exports, "bg", function () { return $33ab27ec71b00902$export$136fd86de524d3c2; });
$parcel$export(module.exports, "q", function () { return $33ab27ec71b00902$export$9e5f44173e64f162; });
$parcel$export(module.exports, "y", function () { return $33ab27ec71b00902$export$4a5767248b18ef41; });
$parcel$export(module.exports, "bt", function () { return $33ab27ec71b00902$export$56350196709588fc; });
$parcel$export(module.exports, "bv", function () { return $33ab27ec71b00902$export$5dbe06c6d8c68cfb; });
$parcel$export(module.exports, "z", function () { return $33ab27ec71b00902$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $33ab27ec71b00902$export$ebd11618f299a286; });
$parcel$export(module.exports, "E", function () { return $33ab27ec71b00902$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "x", function () { return $33ab27ec71b00902$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "L", function () { return $33ab27ec71b00902$export$61196ced6d74a310; });
$parcel$export(module.exports, "n", function () { return $33ab27ec71b00902$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "e", function () { return $33ab27ec71b00902$export$f1e1789686576879; });
$parcel$export(module.exports, "M", function () { return $33ab27ec71b00902$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "N", function () { return $33ab27ec71b00902$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "O", function () { return $33ab27ec71b00902$export$c4ce752e73470fba; });
$parcel$export(module.exports, "P", function () { return $33ab27ec71b00902$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "K", function () { return $33ab27ec71b00902$export$3466f893ebf79586; });
$parcel$export(module.exports, "m", function () { return $33ab27ec71b00902$export$953cecd6e717a553; });
$parcel$export(module.exports, "h", function () { return $33ab27ec71b00902$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a", function () { return $33ab27ec71b00902$export$407448d2b89b1813; });
$parcel$export(module.exports, "f", function () { return $33ab27ec71b00902$export$2d1720544b23b823; });
$parcel$export(module.exports, "v", function () { return $33ab27ec71b00902$export$90a7f3efeed30595; });
$parcel$export(module.exports, "Q", function () { return $33ab27ec71b00902$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "T", function () { return $33ab27ec71b00902$export$971d5caa766a69d7; });
$parcel$export(module.exports, "a8", function () { return $33ab27ec71b00902$export$c3950d9923825c02; });
$parcel$export(module.exports, "V", function () { return $33ab27ec71b00902$export$e7c866399fa523f5; });
$parcel$export(module.exports, "a2", function () { return $33ab27ec71b00902$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "a1", function () { return $33ab27ec71b00902$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "B", function () { return $33ab27ec71b00902$export$ef35774e6d314e91; });
$parcel$export(module.exports, "W", function () { return $33ab27ec71b00902$export$71cec2538cb2c617; });
$parcel$export(module.exports, "aa", function () { return $33ab27ec71b00902$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "C", function () { return $33ab27ec71b00902$export$e7094788287c5e9b; });
$parcel$export(module.exports, "cq", function () { return $33ab27ec71b00902$export$a3c9165b94390bcd; });
$parcel$export(module.exports, "b", function () { return $33ab27ec71b00902$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "o", function () { return $33ab27ec71b00902$export$ae1af26003f05816; });
$parcel$export(module.exports, "G", function () { return $33ab27ec71b00902$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "R", function () { return $33ab27ec71b00902$export$db202ddc8be9136; });
$parcel$export(module.exports, "S", function () { return $33ab27ec71b00902$export$25ce5a424b770e84; });
$parcel$export(module.exports, "H", function () { return $33ab27ec71b00902$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "p", function () { return $33ab27ec71b00902$export$ffb5f4729a158638; });
$parcel$export(module.exports, "j", function () { return $33ab27ec71b00902$export$35e795649ee09318; });
$parcel$export(module.exports, "I", function () { return $33ab27ec71b00902$export$9bb611d729802a56; });
$parcel$export(module.exports, "J", function () { return $33ab27ec71b00902$export$b4171a6734a65d42; });
$parcel$export(module.exports, "F", function () { return $33ab27ec71b00902$export$d66501df72047452; });
$parcel$export(module.exports, "U", function () { return $33ab27ec71b00902$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "_", function () { return $33ab27ec71b00902$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $33ab27ec71b00902$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "ad", function () { return $33ab27ec71b00902$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "Y", function () { return $33ab27ec71b00902$export$8743009a87fcb00f; });
$parcel$export(module.exports, "bP", function () { return $33ab27ec71b00902$export$a91cd623adc48128; });
$parcel$export(module.exports, "bO", function () { return $33ab27ec71b00902$export$2538633961795d6b; });
$parcel$export(module.exports, "bQ", function () { return $33ab27ec71b00902$export$993a080e5cb62d74; });
$parcel$export(module.exports, "bR", function () { return $33ab27ec71b00902$export$4d522598b426bb73; });
$parcel$export(module.exports, "bS", function () { return $33ab27ec71b00902$export$6dabbe08653f866f; });
$parcel$export(module.exports, "l", function () { return $33ab27ec71b00902$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $33ab27ec71b00902$export$3b14a55fb2447963; });
$parcel$export(module.exports, "r", function () { return $33ab27ec71b00902$export$43caf9889c228507; });
$parcel$export(module.exports, "a9", function () { return $33ab27ec71b00902$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "X", function () { return $33ab27ec71b00902$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a4", function () { return $33ab27ec71b00902$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a5", function () { return $33ab27ec71b00902$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a6", function () { return $33ab27ec71b00902$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a7", function () { return $33ab27ec71b00902$export$a93c5207d687da10; });
$parcel$export(module.exports, "a_", function () { return $33ab27ec71b00902$export$a17c37559e1db147; });
$parcel$export(module.exports, "b8", function () { return $33ab27ec71b00902$export$ad4aebacdcaf47f8; });
$parcel$export(module.exports, "bc", function () { return $33ab27ec71b00902$export$d22783b3c2400a3a; });
$parcel$export(module.exports, "by", function () { return $33ab27ec71b00902$export$766bf7dcfb630b6c; });
$parcel$export(module.exports, "bD", function () { return $33ab27ec71b00902$export$b0165a7e514844; });
$parcel$export(module.exports, "bz", function () { return $33ab27ec71b00902$export$674f8f4247a5112e; });
$parcel$export(module.exports, "bI", function () { return $33ab27ec71b00902$export$27d1aff6bea49709; });
$parcel$export(module.exports, "bM", function () { return $33ab27ec71b00902$export$ebb8f7cd71856fb9; });
$parcel$export(module.exports, "bT", function () { return $33ab27ec71b00902$export$1314441b8d04e1d5; });
$parcel$export(module.exports, "bU", function () { return $33ab27ec71b00902$export$e0c3a065614c6254; });
$parcel$export(module.exports, "cd", function () { return $33ab27ec71b00902$export$807f1ba34db587c7; });
$parcel$export(module.exports, "c8", function () { return $33ab27ec71b00902$export$1ec7a8278ebd1290; });
$parcel$export(module.exports, "ca", function () { return $33ab27ec71b00902$export$89e9012e902952b6; });
$parcel$export(module.exports, "c9", function () { return $33ab27ec71b00902$export$4ad369a19af21c23; });
$parcel$export(module.exports, "bZ", function () { return $33ab27ec71b00902$export$c667925124dac624; });
$parcel$export(module.exports, "ck", function () { return $33ab27ec71b00902$export$c1df809846363ebe; });
$parcel$export(module.exports, "cg", function () { return $33ab27ec71b00902$export$6735ce526161c7bd; });
$parcel$export(module.exports, "ci", function () { return $33ab27ec71b00902$export$c5d7c1ac98841e53; });
$parcel$export(module.exports, "cj", function () { return $33ab27ec71b00902$export$d92db8a7dc823bb0; });
$parcel$export(module.exports, "cm", function () { return $33ab27ec71b00902$export$b02498c06ddfef28; });
$parcel$export(module.exports, "cl", function () { return $33ab27ec71b00902$export$b975d55abac2bbe3; });
$parcel$export(module.exports, "cn", function () { return $33ab27ec71b00902$export$1343a74baacb0543; });
$parcel$export(module.exports, "co", function () { return $33ab27ec71b00902$export$87b6ab1c2cb8b955; });

var $4v96Q = parcelRequire("4v96Q");

var $8MSeJ = parcelRequire("8MSeJ");

var $gia3M = parcelRequire("gia3M");

var $eSf5K = parcelRequire("eSf5K");

var $9i7pb = parcelRequire("9i7pb");

var $ar1mO = parcelRequire("ar1mO");

var $hvZMf = parcelRequire("hvZMf");

var $1PKUs = parcelRequire("1PKUs");

var $jdjhw = parcelRequire("jdjhw");

var $kG1qx = parcelRequire("kG1qx");

var $8IBTv = parcelRequire("8IBTv");
var $33ab27ec71b00902$var$styleTexts = [];
var $33ab27ec71b00902$var$styleEls = new Map();
function $33ab27ec71b00902$export$e9316ff9106cdb75(styleText) {
    $33ab27ec71b00902$var$styleTexts.push(styleText);
    $33ab27ec71b00902$var$styleEls.forEach(function(styleEl) {
        $33ab27ec71b00902$var$appendStylesTo(styleEl, styleText);
    });
}
function $33ab27ec71b00902$export$555508cbc6add439(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) $33ab27ec71b00902$var$registerStylesRoot(el.getRootNode());
}
function $33ab27ec71b00902$var$registerStylesRoot(rootNode) {
    var styleEl = $33ab27ec71b00902$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector('style[data-fullcalendar]');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.setAttribute('data-fullcalendar', '');
            var nonce = $33ab27ec71b00902$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            var parentEl = rootNode === document ? document.head : rootNode;
            var insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $33ab27ec71b00902$var$styleEls.set(rootNode, styleEl);
        $33ab27ec71b00902$var$hydrateStylesRoot(styleEl);
    }
}
function $33ab27ec71b00902$var$hydrateStylesRoot(styleEl) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $33ab27ec71b00902$var$styleTexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var styleText = _step.value;
            $33ab27ec71b00902$var$appendStylesTo(styleEl, styleText);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $33ab27ec71b00902$var$appendStylesTo(styleEl, styleText) {
    var sheet = styleEl.sheet;
    var ruleCnt = sheet.cssRules.length;
    styleText.split('}').forEach(function(styleStr, i) {
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + '}', ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
var $33ab27ec71b00902$var$queriedNonceValue;
function $33ab27ec71b00902$var$getNonceValue() {
    if ($33ab27ec71b00902$var$queriedNonceValue === undefined) $33ab27ec71b00902$var$queriedNonceValue = $33ab27ec71b00902$var$queryNonceValue();
    return $33ab27ec71b00902$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $33ab27ec71b00902$var$queryNonceValue() {
    var metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
    var elWithNonce = document.querySelector('script[nonce]');
    if (elWithNonce) return elWithNonce.nonce || '';
    return '';
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== 'undefined') $33ab27ec71b00902$var$registerStylesRoot(document);
var $33ab27ec71b00902$var$css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
$33ab27ec71b00902$export$e9316ff9106cdb75($33ab27ec71b00902$var$css_248z);
var $33ab27ec71b00902$export$96f57966bedc81b4 = /*#__PURE__*/ function() {
    "use strict";
    function DelayedRunner(drainedOption) {
        (0, $8MSeJ._)(this, DelayedRunner);
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    (0, $gia3M._)(DelayedRunner, [
        {
            key: "request",
            value: function request(delay) {
                this.isDirty = true;
                if (!this.isPaused()) {
                    this.clearTimeout();
                    if (delay == null) this.tryDrain();
                    else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                var pauseDepths = this.pauseDepths;
                pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
                this.clearTimeout();
            }
        },
        {
            key: "resume",
            value: function resume() {
                var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', force = arguments.length > 1 ? arguments[1] : void 0;
                var pauseDepths = this.pauseDepths;
                if (scope in pauseDepths) {
                    if (force) delete pauseDepths[scope];
                    else {
                        pauseDepths[scope] -= 1;
                        var depth = pauseDepths[scope];
                        if (depth <= 0) delete pauseDepths[scope];
                    }
                    this.tryDrain();
                }
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                return Object.keys(this.pauseDepths).length;
            }
        },
        {
            key: "tryDrain",
            value: function tryDrain() {
                if (!this.isRunning && !this.isPaused()) {
                    this.isRunning = true;
                    while(this.isDirty){
                        this.isDirty = false;
                        this.drained(); // might set isDirty to true again
                    }
                    this.isRunning = false;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.clearTimeout();
                this.isDirty = false;
                this.pauseDepths = {};
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = 0;
                }
            }
        },
        {
            key: "drained",
            value: function drained() {
                if (this.drainedOption) this.drainedOption();
            }
        }
    ]);
    return DelayedRunner;
}();
function $33ab27ec71b00902$export$9f4f30ee63539e24(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$export$dc98b0b04f4c7758(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($33ab27ec71b00902$export$c03999cb2f36933f(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $33ab27ec71b00902$export$c03999cb2f36933f(el, selector) {
    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $33ab27ec71b00902$export$23ebac1979863676(container, selector) {
    var containers = container instanceof HTMLElement ? [
        container
    ] : container;
    var allMatches = [];
    for(var i = 0; i < containers.length; i += 1){
        var matches = containers[i].querySelectorAll(selector);
        for(var j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $33ab27ec71b00902$export$91477dc880baac21(parent, selector) {
    var parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    var allMatches = [];
    for(var i = 0; i < parents.length; i += 1){
        var childNodes = parents[i].children; // only ever elements
        for(var j = 0; j < childNodes.length; j += 1){
            var childNode = childNodes[j];
            if (!selector || $33ab27ec71b00902$export$c03999cb2f36933f(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
var $33ab27ec71b00902$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $33ab27ec71b00902$export$faec65b429be379(el, props) {
    for(var propName in props)$33ab27ec71b00902$export$2219238a014317b0(el, propName, props[propName]);
}
function $33ab27ec71b00902$export$2219238a014317b0(el, name, val) {
    if (val == null) el.style[name] = '';
    else if (typeof val === 'number' && $33ab27ec71b00902$var$PIXEL_PROP_RE.test(name)) el.style[name] = "".concat(val, "px");
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $33ab27ec71b00902$export$2ed0fc6709e59212(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
var $33ab27ec71b00902$var$guid$1 = 0;
function $33ab27ec71b00902$export$6559d589eb85fbb6() {
    $33ab27ec71b00902$var$guid$1 += 1;
    return 'fc-dom-' + $33ab27ec71b00902$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $33ab27ec71b00902$export$fef3dfd9bad05307(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$var$buildDelegationHandler(selector, handler) {
    return function(ev) {
        var matchedChild = $33ab27ec71b00902$export$dc98b0b04f4c7758(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $33ab27ec71b00902$export$3d8c2f653ac9d0b9(container, eventType, selector, handler) {
    var attachedHandler = $33ab27ec71b00902$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return function() {
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $33ab27ec71b00902$export$34aec0b863436764(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return $33ab27ec71b00902$export$3d8c2f653ac9d0b9(container, 'mouseover', selector, function(mouseOverEv, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            var realOnMouseLeave = function(mouseLeaveEv) {
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
var $33ab27ec71b00902$var$transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function $33ab27ec71b00902$export$8c78c7c36408ea29(el, callback) {
    var realCallback = function(ev) {
        callback(ev);
        $33ab27ec71b00902$var$transitionEventNames.forEach(function(eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    $33ab27ec71b00902$var$transitionEventNames.forEach(function(eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $33ab27ec71b00902$var$createAriaKeyboardAttrs(handler));
}
function $33ab27ec71b00902$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown: function(ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
var $33ab27ec71b00902$var$guidNumber = 0;
function $33ab27ec71b00902$export$39b482c5e57630a8() {
    $33ab27ec71b00902$var$guidNumber += 1;
    return String($33ab27ec71b00902$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $33ab27ec71b00902$export$d66dc83d8cfc8dd() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function $33ab27ec71b00902$export$1fbe638ecf81657e() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $33ab27ec71b00902$export$2f6ca3d3b1f80bf5(el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.addEventListener('selectstart', $33ab27ec71b00902$export$fef3dfd9bad05307);
}
function $33ab27ec71b00902$export$8a5498727ef6be21(el) {
    el.style.userSelect = '';
    el.style.webkitUserSelect = '';
    el.removeEventListener('selectstart', $33ab27ec71b00902$export$fef3dfd9bad05307);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $33ab27ec71b00902$export$d24c54395ce0c509(el) {
    el.addEventListener('contextmenu', $33ab27ec71b00902$export$fef3dfd9bad05307);
}
function $33ab27ec71b00902$export$6554612db691658e(el) {
    el.removeEventListener('contextmenu', $33ab27ec71b00902$export$fef3dfd9bad05307);
}
function $33ab27ec71b00902$export$1a82df3d29112e01(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
    else if (typeof input === 'function') tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === 'function') specs.push({
            func: token
        });
    }
    return specs;
}
function $33ab27ec71b00902$export$306ddfe3a8403e2(obj0, obj1, fieldSpecs) {
    var i;
    var cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $33ab27ec71b00902$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $33ab27ec71b00902$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $33ab27ec71b00902$export$7a38258bbe170828(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $33ab27ec71b00902$export$7a38258bbe170828(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $33ab27ec71b00902$export$21579262ef46735b(val, len) {
    var s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function $33ab27ec71b00902$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === 'function') return formatter.apply(void 0, (0, $hvZMf._)(args));
    if (typeof formatter === 'string') return args.reduce(function(str, arg, index) {
        return str.replace('$' + index, arg || '');
    }, formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $33ab27ec71b00902$export$493d36ec626b6698(a, b) {
    return a - b;
}
function $33ab27ec71b00902$export$ab83b03e4111b1d0(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $33ab27ec71b00902$var$computeSmallestCellWidth(cellEl) {
    var allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    var contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
var $33ab27ec71b00902$var$INTERNAL_UNITS = [
    'years',
    'months',
    'days',
    'milliseconds'
];
var $33ab27ec71b00902$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $33ab27ec71b00902$export$4368d992c4eafac0(input, unit) {
    if (typeof input === 'string') return $33ab27ec71b00902$var$parseString(input);
    if ((typeof input === "undefined" ? "undefined" : (0, $1PKUs._)(input)) === 'object' && input) return $33ab27ec71b00902$var$parseObject(input);
    if (typeof input === 'number') return $33ab27ec71b00902$var$parseObject((0, $eSf5K._)({}, unit || 'milliseconds', input));
    return null;
}
function $33ab27ec71b00902$var$parseString(s) {
    var m = $33ab27ec71b00902$var$PARSE_RE.exec(s);
    if (m) {
        var sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $33ab27ec71b00902$var$parseObject(obj) {
    var duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    var weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $33ab27ec71b00902$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $33ab27ec71b00902$export$a36fb7d24305ed9d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $33ab27ec71b00902$export$acf3ba20e47771d(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $33ab27ec71b00902$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $33ab27ec71b00902$export$55ff3cc1821e8445(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $33ab27ec71b00902$var$asRoughYears(dur) {
    return $33ab27ec71b00902$var$asRoughDays(dur) / 365;
}
function $33ab27ec71b00902$var$asRoughMonths(dur) {
    return $33ab27ec71b00902$var$asRoughDays(dur) / 30;
}
function $33ab27ec71b00902$var$asRoughDays(dur) {
    return $33ab27ec71b00902$export$4b170465d7badfa1(dur) / 864e5;
}
function $33ab27ec71b00902$export$847533e5bf524f5f(dur) {
    return $33ab27ec71b00902$export$4b170465d7badfa1(dur) / 60000;
}
function $33ab27ec71b00902$export$b169257caa88022a(dur) {
    return $33ab27ec71b00902$export$4b170465d7badfa1(dur) / 1000;
}
function $33ab27ec71b00902$export$4b170465d7badfa1(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $33ab27ec71b00902$export$479ac0420f53ed26(numerator, denominator) {
    var res = null;
    for(var i = 0; i < $33ab27ec71b00902$var$INTERNAL_UNITS.length; i += 1){
        var unit = $33ab27ec71b00902$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            var localRes = numerator[unit] / denominator[unit];
            if (!$33ab27ec71b00902$export$ab83b03e4111b1d0(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $33ab27ec71b00902$export$db3b6bfb95261072(dur) {
    var ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: 'millisecond',
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: 'second',
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: 'minute',
            value: ms / 60000
        };
        if (ms) return {
            unit: 'hour',
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: 'week',
            value: dur.days / 7
        };
        return {
            unit: 'day',
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: 'month',
        value: dur.months
    };
    if (dur.years) return {
        unit: 'year',
        value: dur.years
    };
    return {
        unit: 'millisecond',
        value: 0
    };
}
// TODO: new util arrayify?
function $33ab27ec71b00902$export$3d12bd131bb975d1(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $33ab27ec71b00902$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    var len = a0.length;
    var i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
var $33ab27ec71b00902$var$DAY_IDS = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat'
];
// Adding
function $33ab27ec71b00902$export$151db275011178c4(m, n) {
    var a = $33ab27ec71b00902$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $33ab27ec71b00902$var$arrayToUtcDate(a);
}
function $33ab27ec71b00902$export$625550452a3fa3ec(m, n) {
    var a = $33ab27ec71b00902$var$dateToUtcArray(m);
    a[2] += n;
    return $33ab27ec71b00902$var$arrayToUtcDate(a);
}
function $33ab27ec71b00902$export$51b138e5a065c2bb(m, n) {
    var a = $33ab27ec71b00902$var$dateToUtcArray(m);
    a[6] += n;
    return $33ab27ec71b00902$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $33ab27ec71b00902$export$136fd86de524d3c2(m0, m1) {
    return $33ab27ec71b00902$export$b4d5ecaefe2b27f3(m0, m1) / 7;
}
function $33ab27ec71b00902$export$b4d5ecaefe2b27f3(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $33ab27ec71b00902$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $33ab27ec71b00902$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $33ab27ec71b00902$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $33ab27ec71b00902$export$62d08d6fa708df47(m0, m1) {
    var m0day = $33ab27ec71b00902$export$9e5f44173e64f162(m0);
    var m1day = $33ab27ec71b00902$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($33ab27ec71b00902$export$b4d5ecaefe2b27f3(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $33ab27ec71b00902$export$31e67cf12fc9668(m0, m1) {
    var d = $33ab27ec71b00902$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $33ab27ec71b00902$export$4a5767248b18ef41(m0, m1) {
    if ($33ab27ec71b00902$var$timeAsMs(m0) === $33ab27ec71b00902$var$timeAsMs(m1)) return Math.round($33ab27ec71b00902$export$b4d5ecaefe2b27f3(m0, m1));
    return null;
}
// Start-Of
function $33ab27ec71b00902$export$9e5f44173e64f162(m) {
    return $33ab27ec71b00902$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $33ab27ec71b00902$var$startOfHour(m) {
    return $33ab27ec71b00902$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $33ab27ec71b00902$var$startOfMinute(m) {
    return $33ab27ec71b00902$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $33ab27ec71b00902$var$startOfSecond(m) {
    return $33ab27ec71b00902$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $33ab27ec71b00902$var$weekOfYear(marker, dow, doy) {
    var y = marker.getUTCFullYear();
    var w = $33ab27ec71b00902$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $33ab27ec71b00902$var$weekOfGivenYear(marker, y - 1, dow, doy);
    var nextW = $33ab27ec71b00902$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $33ab27ec71b00902$var$weekOfGivenYear(marker, year, dow, doy) {
    var firstWeekStart = $33ab27ec71b00902$var$arrayToUtcDate([
        year,
        0,
        1 + $33ab27ec71b00902$var$firstWeekOffset(year, dow, doy)
    ]);
    var dayStart = $33ab27ec71b00902$export$9e5f44173e64f162(marker);
    var days = Math.round($33ab27ec71b00902$export$b4d5ecaefe2b27f3(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $33ab27ec71b00902$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + $33ab27ec71b00902$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $33ab27ec71b00902$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $33ab27ec71b00902$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $33ab27ec71b00902$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $33ab27ec71b00902$var$arrayToUtcDate(a) {
    var _Date;
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date((_Date = Date).UTC.apply(_Date, (0, $hvZMf._)(a)));
}
// Other Utils
function $33ab27ec71b00902$export$5521614468b862fb(m) {
    return !isNaN(m.valueOf());
}
function $33ab27ec71b00902$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $33ab27ec71b00902$export$f438b12253c2b499(marker, timeZoneOffset) {
    var stripZeroTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) s = s.replace('T00:00:00Z', '');
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace('Z', '');
        else if (timeZoneOffset !== 0) s = s.replace('Z', $33ab27ec71b00902$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $33ab27ec71b00902$export$56350196709588fc(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
function $33ab27ec71b00902$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $33ab27ec71b00902$export$4e222d082f82ee97(marker) {
    return $33ab27ec71b00902$export$21579262ef46735b(marker.getUTCHours(), 2) + ':' + $33ab27ec71b00902$export$21579262ef46735b(marker.getUTCMinutes(), 2) + ':' + $33ab27ec71b00902$export$21579262ef46735b(marker.getUTCSeconds(), 2);
}
function $33ab27ec71b00902$var$formatTimeZoneOffset(minutes) {
    var doIso = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sign = minutes < 0 ? '-' : '+';
    var abs = Math.abs(minutes);
    var hours = Math.floor(abs / 60);
    var mins = Math.round(abs % 60);
    if (doIso) return "".concat(sign + $33ab27ec71b00902$export$21579262ef46735b(hours, 2), ":").concat($33ab27ec71b00902$export$21579262ef46735b(mins, 2));
    return "GMT".concat(sign).concat(hours).concat(mins ? ":".concat($33ab27ec71b00902$export$21579262ef46735b(mins, 2)) : '');
}
function $33ab27ec71b00902$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    var currentArgs;
    var currentRes;
    return function() {
        for(var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++){
            newArgs[_key] = arguments[_key];
        }
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$33ab27ec71b00902$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $33ab27ec71b00902$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArg;
    var currentRes;
    return function(newArg) {
        if (!currentArg) currentRes = workerFunc.call(_this, newArg);
        else if (!$33ab27ec71b00902$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            var res = workerFunc.call(_this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $33ab27ec71b00902$export$91c6e00c14e7e6fd(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgSets = [];
    var currentResults = [];
    return function(newArgSets) {
        var currentLen = currentArgSets.length;
        var newLen = newArgSets.length;
        var i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$33ab27ec71b00902$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                var res = workerFunc.apply(_this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $33ab27ec71b00902$export$9d398bebfec1c039(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgHash = {};
    var currentResHash = {};
    return function(newArgHash) {
        var newResHash = {};
        for(var key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
            else if (!$33ab27ec71b00902$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                var res = workerFunc.apply(_this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
var $33ab27ec71b00902$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
var $33ab27ec71b00902$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
var $33ab27ec71b00902$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
var $33ab27ec71b00902$var$COMMA_RE = /,/g; // we need re for globalness
var $33ab27ec71b00902$var$MULTI_SPACE_RE = /\s+/g;
var $33ab27ec71b00902$var$LTR_RE = /\u200e/g; // control character
var $33ab27ec71b00902$var$UTC_RE = /UTC|GMT/;
var $33ab27ec71b00902$var$NativeFormatter = /*#__PURE__*/ function() {
    "use strict";
    function NativeFormatter(formatSettings) {
        (0, $8MSeJ._)(this, NativeFormatter);
        var standardDateProps = {};
        var extendedSettings = {};
        var smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(var name in formatSettings)if (name in $33ab27ec71b00902$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            var severity = $33ab27ec71b00902$var$EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min($33ab27ec71b00902$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $33ab27ec71b00902$var$STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min($33ab27ec71b00902$var$STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = $33ab27ec71b00902$export$df995fae86a55f06($33ab27ec71b00902$var$buildFormattingFunc);
    }
    (0, $gia3M._)(NativeFormatter, [
        {
            key: "format",
            value: function format(date, context) {
                return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                var _this = this, standardDateProps = _this.standardDateProps, extendedSettings = _this.extendedSettings;
                var diffSeverity = $33ab27ec71b00902$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
                if (!diffSeverity) return this.format(start, context);
                var biggestUnitForPartial = diffSeverity;
                if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
                (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
                var full0 = this.format(start, context);
                var full1 = this.format(end, context);
                if (full0 === full1) return full0;
                var partialDateProps = $33ab27ec71b00902$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
                var partialFormattingFunc = $33ab27ec71b00902$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
                var partial0 = partialFormattingFunc(start);
                var partial1 = partialFormattingFunc(end);
                var insertion = $33ab27ec71b00902$var$findCommonInsertion(full0, partial0, full1, partial1);
                var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
                if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
                return full0 + separator + full1;
            }
        },
        {
            key: "getSmallestUnit",
            value: function getSmallestUnit() {
                switch(this.smallestUnitNum){
                    case 7:
                    case 6:
                    case 5:
                        return 'year';
                    case 4:
                        return 'month';
                    case 3:
                        return 'week';
                    case 2:
                        return 'day';
                    default:
                        return 'time'; // really?
                }
            }
        }
    ]);
    return NativeFormatter;
}();
function $33ab27ec71b00902$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    var standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return function(date) {
        return $33ab27ec71b00902$var$formatTimeZoneOffset(date.timeZoneOffset);
    };
    if (standardDatePropCnt === 0 && extendedSettings.week) return function(date) {
        return $33ab27ec71b00902$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    };
    return $33ab27ec71b00902$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $33ab27ec71b00902$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $33ab27ec71b00902$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    var zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        var zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return function(date) {
        var marker = date.marker;
        var format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        var s = format.format(marker);
        return $33ab27ec71b00902$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $33ab27ec71b00902$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
        if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $33ab27ec71b00902$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($33ab27ec71b00902$var$LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') s = $33ab27ec71b00902$var$injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : $33ab27ec71b00902$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($33ab27ec71b00902$var$COMMA_RE, '').trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($33ab27ec71b00902$var$MERIDIEM_RE, '').trim();
    else if (extendedSettings.meridiem === 'narrow') s = s.replace($33ab27ec71b00902$var$MERIDIEM_RE, function(m0, m1) {
        return m1.toLocaleLowerCase();
    });
    else if (extendedSettings.meridiem === 'short') s = s.replace($33ab27ec71b00902$var$MERIDIEM_RE, function(m0, m1) {
        return "".concat(m1.toLocaleLowerCase(), "m");
    });
    else if (extendedSettings.meridiem === 'lowercase') s = s.replace($33ab27ec71b00902$var$MERIDIEM_RE, function(m0) {
        return m0.toLocaleLowerCase();
    });
    s = s.replace($33ab27ec71b00902$var$MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function $33ab27ec71b00902$var$injectTzoStr(s, tzoStr) {
    var replaced = false;
    s = s.replace($33ab27ec71b00902$var$UTC_RE, function() {
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += " ".concat(tzoStr);
    return s;
}
function $33ab27ec71b00902$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    var parts = [];
    if (display === 'long') parts.push(weekTextLong);
    else if (display === 'short' || display === 'narrow') parts.push(weekText);
    if (display === 'long' || display === 'short') parts.push(' ');
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') parts.reverse();
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $33ab27ec71b00902$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($33ab27ec71b00902$var$timeAsMs(d0) !== $33ab27ec71b00902$var$timeAsMs(d1)) return 1;
    return 0;
}
function $33ab27ec71b00902$var$computePartialFormattingOptions(options, biggestUnit) {
    var partialOptions = {};
    for(var name in options)if (!(name in $33ab27ec71b00902$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $33ab27ec71b00902$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $33ab27ec71b00902$var$findCommonInsertion(full0, partial0, full1, partial1) {
    var i0 = 0;
    while(i0 < full0.length){
        var found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        var before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        var after0 = full0.substr(i0);
        var i1 = 0;
        while(i1 < full1.length){
            var found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            var before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            var after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $33ab27ec71b00902$var$expandZonedMarker(dateInfo, calendarSystem) {
    var a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $33ab27ec71b00902$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    var startInfo = $33ab27ec71b00902$var$expandZonedMarker(start, context.calendarSystem);
    var endInfo = end ? $33ab27ec71b00902$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ var $33ab27ec71b00902$var$CmdFormatter = /*#__PURE__*/ function() {
    "use strict";
    function CmdFormatter(cmdStr) {
        (0, $8MSeJ._)(this, CmdFormatter);
        this.cmdStr = cmdStr;
    }
    (0, $gia3M._)(CmdFormatter, [
        {
            key: "format",
            value: function format(date, context, betterDefaultSeparator) {
                return context.cmdFormatter(this.cmdStr, $33ab27ec71b00902$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                return context.cmdFormatter(this.cmdStr, $33ab27ec71b00902$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
            }
        }
    ]);
    return CmdFormatter;
}();
var $33ab27ec71b00902$var$FuncFormatter = /*#__PURE__*/ function() {
    "use strict";
    function FuncFormatter(func) {
        (0, $8MSeJ._)(this, FuncFormatter);
        this.func = func;
    }
    (0, $gia3M._)(FuncFormatter, [
        {
            key: "format",
            value: function format(date, context, betterDefaultSeparator) {
                return this.func($33ab27ec71b00902$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, context, betterDefaultSeparator) {
                return this.func($33ab27ec71b00902$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
            }
        }
    ]);
    return FuncFormatter;
}();
function $33ab27ec71b00902$export$d141bba7fdc215a3(input) {
    if ((typeof input === "undefined" ? "undefined" : (0, $1PKUs._)(input)) === 'object' && input) return new $33ab27ec71b00902$var$NativeFormatter(input);
    if (typeof input === 'string') return new $33ab27ec71b00902$var$CmdFormatter(input);
    if (typeof input === 'function') return new $33ab27ec71b00902$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
var $33ab27ec71b00902$export$61196ced6d74a310 = {
    navLinkDayClick: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    duration: $33ab27ec71b00902$export$4368d992c4eafac0,
    bootstrapFontAwesome: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    buttonIcons: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    customButtons: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $33ab27ec71b00902$export$4368d992c4eafac0,
    defaultTimedEventDuration: $33ab27ec71b00902$export$4368d992c4eafac0,
    nextDayThreshold: $33ab27ec71b00902$export$4368d992c4eafac0,
    scrollTime: $33ab27ec71b00902$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $33ab27ec71b00902$export$4368d992c4eafac0,
    slotMaxTime: $33ab27ec71b00902$export$4368d992c4eafac0,
    dayPopoverFormat: $33ab27ec71b00902$export$d141bba7fdc215a3,
    slotDuration: $33ab27ec71b00902$export$4368d992c4eafac0,
    snapDuration: $33ab27ec71b00902$export$4368d992c4eafac0,
    headerToolbar: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    footerToolbar: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $33ab27ec71b00902$export$d141bba7fdc215a3,
    dayHeaderClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayCellContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    viewDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorSnap: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    nowIndicatorClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    locale: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventOrder: $33ab27ec71b00902$export$1a82df3d29112e01,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    contentHeight: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $33ab27ec71b00902$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    initialDate: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    now: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    viewHeight: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventConstraint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventAllow: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    selectConstraint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    selectOverlap: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    selectAllow: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $33ab27ec71b00902$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    allDayContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $33ab27ec71b00902$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $33ab27ec71b00902$export$4368d992c4eafac0,
    hiddenDays: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    visibleRange: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    titleFormat: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    navLinkHint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $33ab27ec71b00902$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
var $33ab27ec71b00902$export$f1e1789686576879 = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: 'long',
        day: 'numeric'
    },
    nowIndicatorSnap: 'auto'
};
// calendar listeners
// ------------------
var $33ab27ec71b00902$export$3a1a48c8f6ef640e = {
    datesSet: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventsSet: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventAdd: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventChange: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventRemove: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    windowResize: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventClick: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    select: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    unselect: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    loading: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    _beforeprint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    _afterprint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    _noEventResize: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    _resize: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
var $33ab27ec71b00902$export$a07804094c3ecf2d = {
    buttonText: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    buttonHints: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    views: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    plugins: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    initialEvents: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    events: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventSources: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5
};
var $33ab27ec71b00902$export$c4ce752e73470fba = (0, $eSf5K._)({
    headerToolbar: $33ab27ec71b00902$var$isMaybeObjectsEqual,
    footerToolbar: $33ab27ec71b00902$var$isMaybeObjectsEqual,
    buttonText: $33ab27ec71b00902$var$isMaybeObjectsEqual,
    buttonHints: $33ab27ec71b00902$var$isMaybeObjectsEqual,
    buttonIcons: $33ab27ec71b00902$var$isMaybeObjectsEqual,
    dateIncrement: $33ab27ec71b00902$var$isMaybeObjectsEqual,
    plugins: $33ab27ec71b00902$var$isMaybeArraysEqual,
    events: $33ab27ec71b00902$var$isMaybeArraysEqual,
    eventSources: $33ab27ec71b00902$var$isMaybeArraysEqual
}, 'resources', $33ab27ec71b00902$var$isMaybeArraysEqual);
function $33ab27ec71b00902$var$isMaybeObjectsEqual(a, b) {
    if ((typeof a === "undefined" ? "undefined" : (0, $1PKUs._)(a)) === 'object' && (typeof b === "undefined" ? "undefined" : (0, $1PKUs._)(b)) === 'object' && a && b) return $33ab27ec71b00902$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $33ab27ec71b00902$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $33ab27ec71b00902$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
var $33ab27ec71b00902$export$56c0d5a1e737357d = {
    type: String,
    component: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    content: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    didMount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    willUnmount: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$export$3466f893ebf79586(optionSets) {
    return $33ab27ec71b00902$export$953cecd6e717a553(optionSets, $33ab27ec71b00902$export$c4ce752e73470fba);
}
function $33ab27ec71b00902$export$ee7c8ad385a60b7b(input, refiners) {
    var refined = {};
    var extra = {};
    for(var propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(var propName1 in input)if (!(propName1 in refiners)) extra[propName1] = input[propName1];
    return {
        refined: refined,
        extra: extra
    };
}
function $33ab27ec71b00902$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
var $33ab27ec71b00902$var$hasOwnProperty = Object.prototype.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $33ab27ec71b00902$export$953cecd6e717a553(propObjs, complexPropsMap) {
    var dest = {};
    if (complexPropsMap) {
        for(var name in complexPropsMap)if (complexPropsMap[name] === $33ab27ec71b00902$var$isMaybeObjectsEqual) {
            var complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(var i = propObjs.length - 1; i >= 0; i -= 1){
                var val = propObjs[i][name];
                if ((typeof val === "undefined" ? "undefined" : (0, $1PKUs._)(val)) === 'object' && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $33ab27ec71b00902$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(var i1 = propObjs.length - 1; i1 >= 0; i1 -= 1){
        var props = propObjs[i1];
        for(var name1 in props)if (!(name1 in dest)) dest[name1] = props[name1];
    }
    return dest;
}
function $33ab27ec71b00902$export$dda1d9f60106f0e9(hash, func) {
    var filtered = {};
    for(var key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $33ab27ec71b00902$export$407448d2b89b1813(hash, func) {
    var newHash = {};
    for(var key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $33ab27ec71b00902$export$2d1720544b23b823(a) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            hash[item] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $33ab27ec71b00902$export$90a7f3efeed30595(obj) {
    var a = [];
    for(var key in obj)a.push(obj[key]);
    return a;
}
function $33ab27ec71b00902$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(var key in obj0)if ($33ab27ec71b00902$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(var key1 in obj1)if ($33ab27ec71b00902$var$hasOwnProperty.call(obj1, key1)) {
        if (obj0[key1] !== obj1[key1]) return false;
    }
    return true;
}
var $33ab27ec71b00902$var$HANDLER_RE = /^on[A-Z]/;
function $33ab27ec71b00902$var$isNonHandlerPropsEqual(obj0, obj1) {
    var keys = $33ab27ec71b00902$var$getUnequalProps(obj0, obj1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!$33ab27ec71b00902$var$HANDLER_RE.test(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $33ab27ec71b00902$var$getUnequalProps(obj0, obj1) {
    var keys = [];
    for(var key in obj0){
        if ($33ab27ec71b00902$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(var key1 in obj1){
        if ($33ab27ec71b00902$var$hasOwnProperty.call(obj1, key1)) {
            if (obj0[key1] !== obj1[key1]) keys.push(key1);
        }
    }
    return keys;
}
function $33ab27ec71b00902$export$b9a6b53f9be3734(oldProps, newProps) {
    var equalityFuncs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (oldProps === newProps) return true;
    // if (debug) {
    //   for (let key in newProps) {
    //     if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) {
    //       // equal
    //     } else {
    //       if (debug) {
    //         console.log('prop difference', key, oldProps[key], newProps[key])
    //       }
    //     }
    //   }
    //   // check for props that were omitted in the new
    //   for (let key in oldProps) {
    //     if (!(key in newProps)) {
    //       if (debug) {
    //         console.log('prop absent', key)
    //       }
    //     }
    //   }
    // }
    for(var key in newProps){
        if (key in oldProps && $33ab27ec71b00902$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(var key1 in oldProps){
        if (!(key1 in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $33ab27ec71b00902$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $33ab27ec71b00902$export$a05254e7c3aeba6e(hash) {
    var startIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, endIndex = arguments.length > 2 ? arguments[2] : void 0, step = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(var i = startIndex; i < endIndex; i += step){
        var val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
var $33ab27ec71b00902$var$calendarSystemClassMap = {};
function $33ab27ec71b00902$var$registerCalendarSystem(name, theClass) {
    $33ab27ec71b00902$var$calendarSystemClassMap[name] = theClass;
}
function $33ab27ec71b00902$var$createCalendarSystem(name) {
    return new $33ab27ec71b00902$var$calendarSystemClassMap[name]();
}
var $33ab27ec71b00902$var$GregorianCalendarSystem = /*#__PURE__*/ function() {
    "use strict";
    function GregorianCalendarSystem() {
        (0, $8MSeJ._)(this, GregorianCalendarSystem);
    }
    (0, $gia3M._)(GregorianCalendarSystem, [
        {
            key: "getMarkerYear",
            value: function getMarkerYear(d) {
                return d.getUTCFullYear();
            }
        },
        {
            key: "getMarkerMonth",
            value: function getMarkerMonth(d) {
                return d.getUTCMonth();
            }
        },
        {
            key: "getMarkerDay",
            value: function getMarkerDay(d) {
                return d.getUTCDate();
            }
        },
        {
            key: "arrayToMarker",
            value: function arrayToMarker(arr) {
                return $33ab27ec71b00902$var$arrayToUtcDate(arr);
            }
        },
        {
            key: "markerToArray",
            value: function markerToArray(marker) {
                return $33ab27ec71b00902$var$dateToUtcArray(marker);
            }
        }
    ]);
    return GregorianCalendarSystem;
}();
$33ab27ec71b00902$var$registerCalendarSystem('gregory', $33ab27ec71b00902$var$GregorianCalendarSystem);
var $33ab27ec71b00902$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $33ab27ec71b00902$export$26a0a7676ca7aa04(str) {
    var m = $33ab27ec71b00902$var$ISO_RE.exec(str);
    if (m) {
        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0.".concat(m[12])) * 1000 : 0));
        if ($33ab27ec71b00902$export$5521614468b862fb(marker)) {
            var timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
var $33ab27ec71b00902$export$3722cfe417b6ed86 = /*#__PURE__*/ function() {
    "use strict";
    function DateEnv(settings) {
        (0, $8MSeJ._)(this, DateEnv);
        var timeZone = this.timeZone = settings.timeZone;
        var isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $33ab27ec71b00902$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    (0, $gia3M._)(DateEnv, [
        {
            // Creating / Parsing
            key: "createMarker",
            value: function createMarker(input) {
                var meta = this.createMarkerMeta(input);
                if (meta === null) return null;
                return meta.marker;
            }
        },
        {
            key: "createNowMarker",
            value: function createNowMarker() {
                if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
                // if we can't compute the current date val for a timezone,
                // better to give the current local date vals than UTC
                return $33ab27ec71b00902$var$arrayToUtcDate($33ab27ec71b00902$var$dateToLocalArray(new Date()));
            }
        },
        {
            key: "createMarkerMeta",
            value: function createMarkerMeta(input) {
                if (typeof input === 'string') return this.parse(input);
                var marker = null;
                if (typeof input === 'number') marker = this.timestampToMarker(input);
                else if (input instanceof Date) {
                    input = input.valueOf();
                    if (!isNaN(input)) marker = this.timestampToMarker(input);
                } else if (Array.isArray(input)) marker = $33ab27ec71b00902$var$arrayToUtcDate(input);
                if (marker === null || !$33ab27ec71b00902$export$5521614468b862fb(marker)) return null;
                return {
                    marker: marker,
                    isTimeUnspecified: false,
                    forcedTzo: null
                };
            }
        },
        {
            key: "parse",
            value: function parse1(s) {
                var parts = $33ab27ec71b00902$export$26a0a7676ca7aa04(s);
                if (parts === null) return null;
                var marker = parts.marker;
                var forcedTzo = null;
                if (parts.timeZoneOffset !== null) {
                    if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
                    else forcedTzo = parts.timeZoneOffset;
                }
                return {
                    marker: marker,
                    isTimeUnspecified: parts.isTimeUnspecified,
                    forcedTzo: forcedTzo
                };
            }
        },
        {
            // Accessors
            key: "getYear",
            value: function getYear(marker) {
                return this.calendarSystem.getMarkerYear(marker);
            }
        },
        {
            key: "getMonth",
            value: function getMonth(marker) {
                return this.calendarSystem.getMarkerMonth(marker);
            }
        },
        {
            key: "getDay",
            value: function getDay(marker) {
                return this.calendarSystem.getMarkerDay(marker);
            }
        },
        {
            // Adding / Subtracting
            key: "add",
            value: function add(marker, dur) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] += dur.years;
                a[1] += dur.months;
                a[2] += dur.days;
                a[6] += dur.milliseconds;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "subtract",
            value: function subtract(marker, dur) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] -= dur.years;
                a[1] -= dur.months;
                a[2] -= dur.days;
                a[6] -= dur.milliseconds;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "addYears",
            value: function addYears(marker, n) {
                var a = this.calendarSystem.markerToArray(marker);
                a[0] += n;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            key: "addMonths",
            value: function addMonths(marker, n) {
                var a = this.calendarSystem.markerToArray(marker);
                a[1] += n;
                return this.calendarSystem.arrayToMarker(a);
            }
        },
        {
            // Diffing Whole Units
            key: "diffWholeYears",
            value: function diffWholeYears(m0, m1) {
                var calendarSystem = this.calendarSystem;
                if ($33ab27ec71b00902$var$timeAsMs(m0) === $33ab27ec71b00902$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
                return null;
            }
        },
        {
            key: "diffWholeMonths",
            value: function diffWholeMonths(m0, m1) {
                var calendarSystem = this.calendarSystem;
                if ($33ab27ec71b00902$var$timeAsMs(m0) === $33ab27ec71b00902$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
                return null;
            }
        },
        {
            // Range / Duration
            key: "greatestWholeUnit",
            value: function greatestWholeUnit(m0, m1) {
                var n = this.diffWholeYears(m0, m1);
                if (n !== null) return {
                    unit: 'year',
                    value: n
                };
                n = this.diffWholeMonths(m0, m1);
                if (n !== null) return {
                    unit: 'month',
                    value: n
                };
                n = $33ab27ec71b00902$export$31e67cf12fc9668(m0, m1);
                if (n !== null) return {
                    unit: 'week',
                    value: n
                };
                n = $33ab27ec71b00902$export$4a5767248b18ef41(m0, m1);
                if (n !== null) return {
                    unit: 'day',
                    value: n
                };
                n = $33ab27ec71b00902$var$diffHours(m0, m1);
                if ($33ab27ec71b00902$export$ab83b03e4111b1d0(n)) return {
                    unit: 'hour',
                    value: n
                };
                n = $33ab27ec71b00902$var$diffMinutes(m0, m1);
                if ($33ab27ec71b00902$export$ab83b03e4111b1d0(n)) return {
                    unit: 'minute',
                    value: n
                };
                n = $33ab27ec71b00902$var$diffSeconds(m0, m1);
                if ($33ab27ec71b00902$export$ab83b03e4111b1d0(n)) return {
                    unit: 'second',
                    value: n
                };
                return {
                    unit: 'millisecond',
                    value: m1.valueOf() - m0.valueOf()
                };
            }
        },
        {
            key: "countDurationsBetween",
            value: function countDurationsBetween(m0, m1, d) {
                // TODO: can use greatestWholeUnit
                var diff;
                if (d.years) {
                    diff = this.diffWholeYears(m0, m1);
                    if (diff !== null) return diff / $33ab27ec71b00902$var$asRoughYears(d);
                }
                if (d.months) {
                    diff = this.diffWholeMonths(m0, m1);
                    if (diff !== null) return diff / $33ab27ec71b00902$var$asRoughMonths(d);
                }
                if (d.days) {
                    diff = $33ab27ec71b00902$export$4a5767248b18ef41(m0, m1);
                    if (diff !== null) return diff / $33ab27ec71b00902$var$asRoughDays(d);
                }
                return (m1.valueOf() - m0.valueOf()) / $33ab27ec71b00902$export$4b170465d7badfa1(d);
            }
        },
        {
            // Start-Of
            // these DON'T return zoned-dates. only UTC start-of dates
            key: "startOf",
            value: function startOf(m, unit) {
                if (unit === 'year') return this.startOfYear(m);
                if (unit === 'month') return this.startOfMonth(m);
                if (unit === 'week') return this.startOfWeek(m);
                if (unit === 'day') return $33ab27ec71b00902$export$9e5f44173e64f162(m);
                if (unit === 'hour') return $33ab27ec71b00902$var$startOfHour(m);
                if (unit === 'minute') return $33ab27ec71b00902$var$startOfMinute(m);
                if (unit === 'second') return $33ab27ec71b00902$var$startOfSecond(m);
                return null;
            }
        },
        {
            key: "startOfYear",
            value: function startOfYear(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m)
                ]);
            }
        },
        {
            key: "startOfMonth",
            value: function startOfMonth(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m),
                    this.calendarSystem.getMarkerMonth(m)
                ]);
            }
        },
        {
            key: "startOfWeek",
            value: function startOfWeek(m) {
                return this.calendarSystem.arrayToMarker([
                    this.calendarSystem.getMarkerYear(m),
                    this.calendarSystem.getMarkerMonth(m),
                    m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
                ]);
            }
        },
        {
            // Week Number
            key: "computeWeekNumber",
            value: function computeWeekNumber(marker) {
                if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
                return $33ab27ec71b00902$var$weekOfYear(marker, this.weekDow, this.weekDoy);
            }
        },
        {
            // TODO: choke on timeZoneName: long
            key: "format",
            value: function format(marker, formatter) {
                var dateOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return formatter.format({
                    marker: marker,
                    timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
                }, this);
            }
        },
        {
            key: "formatRange",
            value: function formatRange(start, end, formatter) {
                var dateOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (dateOptions.isEndExclusive) end = $33ab27ec71b00902$export$51b138e5a065c2bb(end, -1);
                return formatter.formatRange({
                    marker: start,
                    timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
                }, {
                    marker: end,
                    timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
                }, this, dateOptions.defaultSeparator);
            }
        },
        {
            /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ key: "formatIso",
            value: function formatIso(marker) {
                var extraOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var timeZoneOffset = null;
                if (!extraOptions.omitTimeZoneOffset) {
                    if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
                    else timeZoneOffset = this.offsetForMarker(marker);
                }
                return $33ab27ec71b00902$export$f438b12253c2b499(marker, timeZoneOffset, extraOptions.omitTime);
            }
        },
        {
            // TimeZone
            key: "timestampToMarker",
            value: function timestampToMarker(ms) {
                if (this.timeZone === 'local') return $33ab27ec71b00902$var$arrayToUtcDate($33ab27ec71b00902$var$dateToLocalArray(new Date(ms)));
                if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
                return $33ab27ec71b00902$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
            }
        },
        {
            key: "offsetForMarker",
            value: function offsetForMarker(m) {
                if (this.timeZone === 'local') return -$33ab27ec71b00902$var$arrayToLocalDate($33ab27ec71b00902$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
                if (this.timeZone === 'UTC') return 0;
                if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($33ab27ec71b00902$var$dateToUtcArray(m));
                return null;
            }
        },
        {
            // Conversion
            key: "toDate",
            value: function toDate(m, forcedTzo) {
                if (this.timeZone === 'local') return $33ab27ec71b00902$var$arrayToLocalDate($33ab27ec71b00902$var$dateToUtcArray(m));
                if (this.timeZone === 'UTC') return new Date(m.valueOf()); // make sure it's a copy
                if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
                return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($33ab27ec71b00902$var$dateToUtcArray(m)) * 60000);
            }
        }
    ]);
    return DateEnv;
}();
var $33ab27ec71b00902$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function Theme(calendarOptions) {
        (0, $8MSeJ._)(this, Theme);
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    (0, $gia3M._)(Theme, [
        {
            key: "setIconOverride",
            value: function setIconOverride(iconOverrideHash) {
                var iconClassesCopy;
                var buttonName;
                if ((typeof iconOverrideHash === "undefined" ? "undefined" : (0, $1PKUs._)(iconOverrideHash)) === 'object' && iconOverrideHash) {
                    iconClassesCopy = Object.assign({}, this.iconClasses);
                    for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
                    this.iconClasses = iconClassesCopy;
                } else if (iconOverrideHash === false) this.iconClasses = {};
            }
        },
        {
            key: "applyIconOverridePrefix",
            value: function applyIconOverridePrefix(className) {
                var prefix = this.iconOverridePrefix;
                if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
                return className;
            }
        },
        {
            key: "getClass",
            value: function getClass(key) {
                return this.classes[key] || '';
            }
        },
        {
            key: "getIconClass",
            value: function getIconClass(buttonName, isRtl) {
                var className;
                if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
                else className = this.iconClasses[buttonName];
                if (className) return "".concat(this.baseIconClass, " ").concat(className);
                return '';
            }
        },
        {
            key: "getCustomButtonIconClass",
            value: function getCustomButtonIconClass(customButtonProps) {
                var className;
                if (this.iconOverrideCustomButtonOption) {
                    className = customButtonProps[this.iconOverrideCustomButtonOption];
                    if (className) return "".concat(this.baseIconClass, " ").concat(this.applyIconOverridePrefix(className));
                }
                return '';
            }
        }
    ]);
    return Theme;
}();
$33ab27ec71b00902$export$971d5caa766a69d7.prototype.classes = {};
$33ab27ec71b00902$export$971d5caa766a69d7.prototype.iconClasses = {};
$33ab27ec71b00902$export$971d5caa766a69d7.prototype.baseIconClass = '';
$33ab27ec71b00902$export$971d5caa766a69d7.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $33ab27ec71b00902$export$c3950d9923825c02(runBeforeFlush) {
    runBeforeFlush();
    var oldDebounceRendering = $kG1qx.options.debounceRendering; // orig
    var callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $kG1qx.options.debounceRendering = execCallbackSync;
    $kG1qx.render($kG1qx.createElement($33ab27ec71b00902$var$FakeComponent, {}), document.createElement('div'));
    while(callbackQ.length)callbackQ.shift()();
    $kG1qx.options.debounceRendering = oldDebounceRendering;
}
var $33ab27ec71b00902$var$FakeComponent = /*#__PURE__*/ function(_preact_Component) {
    "use strict";
    (0, $9i7pb._)(FakeComponent, _preact_Component);
    function FakeComponent() {
        (0, $8MSeJ._)(this, FakeComponent);
        return (0, $4v96Q._)(this, FakeComponent, arguments);
    }
    (0, $gia3M._)(FakeComponent, [
        {
            key: "render",
            value: function render() {
                return $kG1qx.createElement('div', {});
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({});
            }
        }
    ]);
    return FakeComponent;
}($kG1qx.Component);
// TODO: use preact/compat instead?
function $33ab27ec71b00902$export$c9170ad7d4cd7e57(defaultValue) {
    var ContextType = $kG1qx.createContext(defaultValue);
    var origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        var _this = this;
        var isNew = !this.getChildContext;
        var children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            var subs = [];
            this.shouldComponentUpdate = function(_props) {
                if (_this.props.value !== _props.value) subs.forEach(function(c) {
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = function(c) {
                subs.push(c);
                var old = c.componentWillUnmount;
                c.componentWillUnmount = function() {
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
var $33ab27ec71b00902$export$49e6ee724f7f1ace = /*#__PURE__*/ function() {
    "use strict";
    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
        var _this = this;
        (0, $8MSeJ._)(this, ScrollResponder);
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = function(request) {
            _this.queuedRequest = Object.assign({}, _this.queuedRequest || {}, request);
            _this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    (0, $gia3M._)(ScrollResponder, [
        {
            key: "detach",
            value: function detach() {
                this.emitter.off('_scrollRequest', this.handleScrollRequest);
            }
        },
        {
            key: "update",
            value: function update(isDatesNew) {
                if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
                else this.drain();
            }
        },
        {
            key: "fireInitialScroll",
            value: function fireInitialScroll() {
                this.handleScrollRequest({
                    time: this.scrollTime
                });
            }
        },
        {
            key: "drain",
            value: function drain() {
                if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
            }
        }
    ]);
    return ScrollResponder;
}();
var $33ab27ec71b00902$export$e7c866399fa523f5 = $33ab27ec71b00902$export$c9170ad7d4cd7e57({}); // for Components
function $33ab27ec71b00902$export$ce26c07117d59d6a(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        nowManager: nowManager,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler: function(handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler: function(handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder: function(execFunc) {
            return new $33ab27ec71b00902$export$49e6ee724f7f1ace(execFunc, emitter, $33ab27ec71b00902$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ var $33ab27ec71b00902$export$3c2fa207a37baaea = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $9i7pb._)(PureComponent, Component);
    function PureComponent() {
        (0, $8MSeJ._)(this, PureComponent);
        return (0, $4v96Q._)(this, PureComponent, arguments);
    }
    (0, $gia3M._)(PureComponent, [
        {
            // debug: boolean
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                var shouldUpdate = !$33ab27ec71b00902$export$b9a6b53f9be3734(this.props, nextProps, this.propEquality /*, this.debug */ ) || !$33ab27ec71b00902$export$b9a6b53f9be3734(this.state, nextState, this.stateEquality /*, this.debug */ );
                // if (this.debug && shouldUpdate) {
                //   console.log('shouldUpdate!')
                // }
                return shouldUpdate;
            }
        },
        {
            // HACK for freakin' React StrictMode
            key: "safeSetState",
            value: function safeSetState(newState) {
                if (!$33ab27ec71b00902$export$b9a6b53f9be3734(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
            }
        }
    ]);
    return PureComponent;
}((0, $kG1qx.Component));
$33ab27ec71b00902$export$3c2fa207a37baaea.addPropsEquality = $33ab27ec71b00902$var$addPropsEquality;
$33ab27ec71b00902$export$3c2fa207a37baaea.addStateEquality = $33ab27ec71b00902$var$addStateEquality;
$33ab27ec71b00902$export$3c2fa207a37baaea.contextType = $33ab27ec71b00902$export$e7c866399fa523f5;
$33ab27ec71b00902$export$3c2fa207a37baaea.prototype.propEquality = {};
$33ab27ec71b00902$export$3c2fa207a37baaea.prototype.stateEquality = {};
var $33ab27ec71b00902$export$ef35774e6d314e91 = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0, $9i7pb._)(BaseComponent, PureComponent);
    function BaseComponent() {
        (0, $8MSeJ._)(this, BaseComponent);
        return (0, $4v96Q._)(this, BaseComponent, arguments);
    }
    return BaseComponent;
}($33ab27ec71b00902$export$3c2fa207a37baaea);
$33ab27ec71b00902$export$ef35774e6d314e91.contextType = $33ab27ec71b00902$export$e7c866399fa523f5;
function $33ab27ec71b00902$var$addPropsEquality(propEquality) {
    var hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $33ab27ec71b00902$var$addStateEquality(stateEquality) {
    var hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $33ab27ec71b00902$export$71cec2538cb2c617(ref, current) {
    if (typeof ref === 'function') ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
var $33ab27ec71b00902$var$ContentInjector = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(ContentInjector, BaseComponent);
    function ContentInjector() {
        (0, $8MSeJ._)(this, ContentInjector);
        var _this;
        _this = (0, $4v96Q._)(this, ContentInjector, arguments);
        _this.id = $33ab27ec71b00902$export$39b482c5e57630a8();
        _this.queuedDomNodes = [];
        _this.currentDomNodes = [];
        _this.handleEl = function(el) {
            var options = _this.context.options;
            var generatorName = _this.props.generatorName;
            if (!options.customRenderingReplaces || !$33ab27ec71b00902$var$hasCustomRenderingHandler(generatorName, options)) _this.updateElRef(el);
        };
        _this.updateElRef = function(el) {
            if (_this.props.elRef) $33ab27ec71b00902$export$71cec2538cb2c617(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $gia3M._)(ContentInjector, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var customGenerator = props.customGenerator, defaultGenerator = props.defaultGenerator, renderProps = props.renderProps;
                var attrs = $33ab27ec71b00902$export$9ddbdd0bfc5623a(props, [], this.handleEl);
                var useDefault = false;
                var innerContent;
                var queuedDomNodes = [];
                var currentGeneratorMeta;
                if (customGenerator != null) {
                    var customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, $kG1qx.createElement)) : customGenerator;
                    if (customGeneratorRes === true) useDefault = true;
                    else {
                        var isObject = customGeneratorRes && (typeof customGeneratorRes === "undefined" ? "undefined" : (0, $1PKUs._)(customGeneratorRes)) === 'object'; // non-null
                        if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                            __html: customGeneratorRes.html
                        };
                        else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                        else if (isObject ? (0, $kG1qx.isValidElement)(customGeneratorRes) // vdom node
                         : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
                        ) // use in vdom
                        innerContent = customGeneratorRes;
                        else // an exotic object for handleCustomRendering
                        currentGeneratorMeta = customGeneratorRes;
                    }
                } else useDefault = !$33ab27ec71b00902$var$hasCustomRenderingHandler(props.generatorName, options);
                if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
                this.queuedDomNodes = queuedDomNodes;
                this.currentGeneratorMeta = currentGeneratorMeta;
                return (0, $kG1qx.createElement)(props.elTag, attrs, innerContent);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.applyQueueudDomNodes();
                this.triggerCustomRendering(true);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyQueueudDomNodes();
                this.triggerCustomRendering(true);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.triggerCustomRendering(false); // TODO: different API for removal?
            }
        },
        {
            key: "triggerCustomRendering",
            value: function triggerCustomRendering(isActive) {
                var _a;
                var _this = this, props = _this.props, context = _this.context;
                var _context_options = context.options, handleCustomRendering = _context_options.handleCustomRendering, customRenderingMetaMap = _context_options.customRenderingMetaMap;
                if (handleCustomRendering) {
                    var generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
                    if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                        id: this.id,
                        isActive: isActive,
                        containerEl: this.base,
                        reportNewContainerEl: this.updateElRef,
                        generatorMeta: generatorMeta
                    }, props), {
                        elClasses: (props.elClasses || []).filter($33ab27ec71b00902$var$isTruthy)
                    }));
                }
            }
        },
        {
            key: "applyQueueudDomNodes",
            value: function applyQueueudDomNodes() {
                var _this = this, queuedDomNodes = _this.queuedDomNodes, currentDomNodes = _this.currentDomNodes;
                var el = this.base;
                if (!$33ab27ec71b00902$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
                    currentDomNodes.forEach($33ab27ec71b00902$export$9f4f30ee63539e24);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = queuedDomNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var newNode = _step.value;
                            el.appendChild(newNode);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.currentDomNodes = queuedDomNodes;
                }
            }
        }
    ]);
    return ContentInjector;
}($33ab27ec71b00902$export$ef35774e6d314e91);
$33ab27ec71b00902$var$ContentInjector.addPropsEquality({
    elClasses: $33ab27ec71b00902$export$23f2a1d2818174ef,
    elStyle: $33ab27ec71b00902$export$a9c23c6ac3fc3eca,
    elAttrs: $33ab27ec71b00902$var$isNonHandlerPropsEqual,
    renderProps: $33ab27ec71b00902$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function $33ab27ec71b00902$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $33ab27ec71b00902$export$9ddbdd0bfc5623a(props, extraClassNames, elRef) {
    var attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $33ab27ec71b00902$var$isTruthy(val) {
    return Boolean(val);
}
var $33ab27ec71b00902$export$7910e0436ed8d1de = $33ab27ec71b00902$export$c9170ad7d4cd7e57(0);
var $33ab27ec71b00902$export$e7094788287c5e9b = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $9i7pb._)(ContentContainer, Component);
    function ContentContainer() {
        (0, $8MSeJ._)(this, ContentContainer);
        var _this;
        _this = (0, $4v96Q._)(this, ContentContainer, arguments);
        _this.InnerContent = $33ab27ec71b00902$var$InnerContentInjector.bind(undefined, _this);
        _this.handleEl = function(el) {
            _this.el = el;
            if (_this.props.elRef) {
                $33ab27ec71b00902$export$71cec2538cb2c617(_this.props.elRef, el);
                if (el && _this.didMountMisfire) _this.componentDidMount();
            }
        };
        return _this;
    }
    (0, $gia3M._)(ContentContainer, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var generatedClassNames = $33ab27ec71b00902$var$generateClassNames(props.classNameGenerator, props.renderProps);
                if (props.children) {
                    var elAttrs = $33ab27ec71b00902$export$9ddbdd0bfc5623a(props, generatedClassNames, this.handleEl);
                    var children = props.children(this.InnerContent, props.renderProps, elAttrs);
                    if (props.elTag) return (0, $kG1qx.createElement)(props.elTag, elAttrs, children);
                    else return children;
                } else return (0, $kG1qx.createElement)($33ab27ec71b00902$var$ContentInjector, Object.assign(Object.assign({}, props), {
                    elRef: this.handleEl,
                    elTag: props.elTag || 'div',
                    elClasses: (props.elClasses || []).concat(generatedClassNames),
                    renderId: this.context
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _a, _b;
                if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                    el: this.el
                }));
                else this.didMountMisfire = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _a, _b;
                (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
                    el: this.el
                }));
            }
        }
    ]);
    return ContentContainer;
}((0, $kG1qx.Component));
$33ab27ec71b00902$export$e7094788287c5e9b.contextType = $33ab27ec71b00902$export$7910e0436ed8d1de;
function $33ab27ec71b00902$var$InnerContentInjector(containerComponent, props) {
    var parentProps = containerComponent.props;
    return (0, $kG1qx.createElement)($33ab27ec71b00902$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $33ab27ec71b00902$var$generateClassNames(classNameGenerator, renderProps) {
    var classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === 'string' ? [
        classNames
    ] : classNames;
}
var $33ab27ec71b00902$export$a3c9165b94390bcd = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(ViewContainer, BaseComponent);
    function ViewContainer() {
        (0, $8MSeJ._)(this, ViewContainer);
        return (0, $4v96Q._)(this, ViewContainer, arguments);
    }
    (0, $gia3M._)(ViewContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var renderProps = {
                    view: context.viewApi
                };
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
                    elRef: props.elRef,
                    elTag: props.elTag || 'div',
                    elAttrs: props.elAttrs,
                    elClasses: (0, $hvZMf._)($33ab27ec71b00902$export$8b22cf2602fb60ce(props.viewSpec)).concat((0, $hvZMf._)(props.elClasses || [])),
                    elStyle: props.elStyle,
                    renderProps: renderProps,
                    classNameGenerator: options.viewClassNames,
                    generatorName: undefined,
                    didMount: options.viewDidMount,
                    willUnmount: options.viewWillUnmount
                }, function() {
                    return props.children;
                });
            }
        }
    ]);
    return ViewContainer;
}($33ab27ec71b00902$export$ef35774e6d314e91);
function $33ab27ec71b00902$export$8b22cf2602fb60ce(viewSpec) {
    return [
        "fc-".concat(viewSpec.type, "-view"),
        'fc-view'
    ];
}
function $33ab27ec71b00902$var$parseRange(input, dateEnv) {
    var start = null;
    var end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $33ab27ec71b00902$var$invertRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var start = constraintRange.start; // the end of the previous range. the start of the new range
    var i;
    var dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($33ab27ec71b00902$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $33ab27ec71b00902$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $33ab27ec71b00902$export$ae1af26003f05816(range0, range1) {
    var start = range0.start, end = range0.end;
    var newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $33ab27ec71b00902$export$7a0bdf7d4a91ea88(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $33ab27ec71b00902$export$c18d01048907ea92(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $33ab27ec71b00902$export$f074adc9fbd50943(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $33ab27ec71b00902$export$2329c99376c9d0a4(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $33ab27ec71b00902$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $33ab27ec71b00902$var$computeAlignedDayRange(timedRange) {
    var dayCnt = Math.floor($33ab27ec71b00902$export$b4d5ecaefe2b27f3(timedRange.start, timedRange.end)) || 1;
    var start = $33ab27ec71b00902$export$9e5f44173e64f162(timedRange.start);
    var end = $33ab27ec71b00902$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $33ab27ec71b00902$export$92108d983e8ee699(timedRange) {
    var nextDayThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $33ab27ec71b00902$export$4368d992c4eafac0(0);
    var startDay = null;
    var endDay = null;
    if (timedRange.end) {
        endDay = $33ab27ec71b00902$export$9e5f44173e64f162(timedRange.end);
        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $33ab27ec71b00902$export$4b170465d7badfa1(nextDayThreshold)) endDay = $33ab27ec71b00902$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $33ab27ec71b00902$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $33ab27ec71b00902$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $33ab27ec71b00902$export$9fa96a7d116ea3ce(range) {
    var visibleRange = $33ab27ec71b00902$export$92108d983e8ee699(range);
    return $33ab27ec71b00902$export$b4d5ecaefe2b27f3(visibleRange.start, visibleRange.end) > 1;
}
function $33ab27ec71b00902$export$28f7fcd39efa255(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') return $33ab27ec71b00902$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), 'year');
    if (largeUnit === 'month') return $33ab27ec71b00902$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), 'month');
    return $33ab27ec71b00902$export$62d08d6fa708df47(date0, date1); // returns a duration
}
var $33ab27ec71b00902$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    "use strict";
    function DateProfileGenerator(props) {
        (0, $8MSeJ._)(this, DateProfileGenerator);
        this.props = props;
        this.initHiddenDays();
    }
    (0, $gia3M._)(DateProfileGenerator, [
        {
            /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
            key: "buildPrev",
            value: function buildPrev(currentDateProfile, currentDate, forceToValid) {
                var dateEnv = this.props.dateEnv;
                var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
                return this.build(prevDate, -1, forceToValid);
            }
        },
        {
            // Builds a structure with info about what the dates/ranges will be for the "next" view.
            key: "buildNext",
            value: function buildNext(currentDateProfile, currentDate, forceToValid) {
                var dateEnv = this.props.dateEnv;
                var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
                return this.build(nextDate, 1, forceToValid);
            }
        },
        {
            // Builds a structure holding dates/ranges for rendering around the given date.
            // Optional direction param indicates whether the date is being incremented/decremented
            // from its previous value. decremented = -1, incremented = 1 (default).
            key: "build",
            value: function build(currentDate, direction) {
                var forceToValid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var props = this.props;
                var validRange;
                var currentInfo;
                var isRangeAllDay;
                var renderRange;
                var activeRange;
                var isValid;
                validRange = this.buildValidRange();
                validRange = this.trimHiddenDays(validRange);
                if (forceToValid) currentDate = $33ab27ec71b00902$var$constrainMarkerToRange(currentDate, validRange);
                currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
                isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
                renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
                renderRange = this.trimHiddenDays(renderRange);
                activeRange = renderRange;
                if (!props.showNonCurrentDates) activeRange = $33ab27ec71b00902$export$ae1af26003f05816(activeRange, currentInfo.range);
                activeRange = this.adjustActiveRange(activeRange);
                activeRange = $33ab27ec71b00902$export$ae1af26003f05816(activeRange, validRange); // might return null
                // it's invalid if the originally requested date is not contained,
                // or if the range is completely outside of the valid range.
                isValid = $33ab27ec71b00902$export$c18d01048907ea92(currentInfo.range, validRange);
                // HACK: constrain to render-range so `currentDate` is more useful to view rendering
                if (!$33ab27ec71b00902$export$2329c99376c9d0a4(renderRange, currentDate)) currentDate = renderRange.start;
                return {
                    currentDate: currentDate,
                    // constraint for where prev/next operations can go and where events can be dragged/resized to.
                    // an object with optional start and end properties.
                    validRange: validRange,
                    // range the view is formally responsible for.
                    // for example, a month view might have 1st-31st, excluding padded dates
                    currentRange: currentInfo.range,
                    // name of largest unit being displayed, like "month" or "week"
                    currentRangeUnit: currentInfo.unit,
                    isRangeAllDay: isRangeAllDay,
                    // dates that display events and accept drag-n-drop
                    // will be `null` if no dates accept events
                    activeRange: activeRange,
                    // date range with a rendered skeleton
                    // includes not-active days that need some sort of DOM
                    renderRange: renderRange,
                    // Duration object that denotes the first visible time of any given day
                    slotMinTime: props.slotMinTime,
                    // Duration object that denotes the exclusive visible end time of any given day
                    slotMaxTime: props.slotMaxTime,
                    isValid: isValid,
                    // how far the current date will move for a prev/next operation
                    dateIncrement: this.buildDateIncrement(currentInfo.duration)
                };
            }
        },
        {
            // Builds an object with optional start/end properties.
            // Indicates the minimum/maximum dates to display.
            // not responsible for trimming hidden days.
            key: "buildValidRange",
            value: function buildValidRange() {
                var input = this.props.validRangeInput;
                var simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
                return this.refineRange(simpleInput) || {
                    start: null,
                    end: null
                }; // completely open-ended
            }
        },
        {
            // Builds a structure with info about the "current" range, the range that is
            // highlighted as being the current month for example.
            // See build() for a description of `direction`.
            // Guaranteed to have `range` and `unit` properties. `duration` is optional.
            key: "buildCurrentRangeInfo",
            value: function buildCurrentRangeInfo(date, direction) {
                var props = this.props;
                var duration = null;
                var unit = null;
                var range = null;
                var dayCount;
                if (props.duration) {
                    duration = props.duration;
                    unit = props.durationUnit;
                    range = this.buildRangeFromDuration(date, direction, duration, unit);
                } else if (dayCount = this.props.dayCount) {
                    unit = 'day';
                    range = this.buildRangeFromDayCount(date, direction, dayCount);
                } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
                else {
                    duration = this.getFallbackDuration();
                    unit = $33ab27ec71b00902$export$db3b6bfb95261072(duration).unit;
                    range = this.buildRangeFromDuration(date, direction, duration, unit);
                }
                return {
                    duration: duration,
                    unit: unit,
                    range: range
                };
            }
        },
        {
            key: "getFallbackDuration",
            value: function getFallbackDuration() {
                return $33ab27ec71b00902$export$4368d992c4eafac0({
                    day: 1
                });
            }
        },
        {
            // Returns a new activeRange to have time values (un-ambiguate)
            // slotMinTime or slotMaxTime causes the range to expand.
            key: "adjustActiveRange",
            value: function adjustActiveRange(range) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, usesMinMaxTime = _this_props.usesMinMaxTime, slotMinTime = _this_props.slotMinTime, slotMaxTime = _this_props.slotMaxTime;
                var start = range.start, end = range.end;
                if (usesMinMaxTime) {
                    // expand active range if slotMinTime is negative (why not when positive?)
                    if ($33ab27ec71b00902$var$asRoughDays(slotMinTime) < 0) {
                        start = $33ab27ec71b00902$export$9e5f44173e64f162(start); // necessary?
                        start = dateEnv.add(start, slotMinTime);
                    }
                    // expand active range if slotMaxTime is beyond one day (why not when negative?)
                    if ($33ab27ec71b00902$var$asRoughDays(slotMaxTime) > 1) {
                        end = $33ab27ec71b00902$export$9e5f44173e64f162(end); // necessary?
                        end = $33ab27ec71b00902$export$625550452a3fa3ec(end, -1);
                        end = dateEnv.add(end, slotMaxTime);
                    }
                }
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            // Builds the "current" range when it is specified as an explicit duration.
            // `unit` is the already-computed greatestDurationDenominator unit of duration.
            key: "buildRangeFromDuration",
            value: function buildRangeFromDuration(date, direction, duration, unit) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, dateAlignment = _this_props.dateAlignment;
                var start;
                var end;
                var res;
                // compute what the alignment should be
                if (!dateAlignment) {
                    var dateIncrement = this.props.dateIncrement;
                    if (dateIncrement) {
                        // use the smaller of the two units
                        if ($33ab27ec71b00902$export$4b170465d7badfa1(dateIncrement) < $33ab27ec71b00902$export$4b170465d7badfa1(duration)) dateAlignment = $33ab27ec71b00902$export$db3b6bfb95261072(dateIncrement).unit;
                        else dateAlignment = unit;
                    } else dateAlignment = unit;
                }
                // if the view displays a single day or smaller
                if ($33ab27ec71b00902$var$asRoughDays(duration) <= 1) {
                    if (this.isHiddenDay(start)) {
                        start = this.skipHiddenDays(start, direction);
                        start = $33ab27ec71b00902$export$9e5f44173e64f162(start);
                    }
                }
                function computeRes() {
                    start = dateEnv.startOf(date, dateAlignment);
                    end = dateEnv.add(start, duration);
                    res = {
                        start: start,
                        end: end
                    };
                }
                computeRes();
                // if range is completely enveloped by hidden days, go past the hidden days
                if (!this.trimHiddenDays(res)) {
                    date = this.skipHiddenDays(date, direction);
                    computeRes();
                }
                return res;
            }
        },
        {
            // Builds the "current" range when a dayCount is specified.
            key: "buildRangeFromDayCount",
            value: function buildRangeFromDayCount(date, direction, dayCount) {
                var _this_props = this.props, dateEnv = _this_props.dateEnv, dateAlignment = _this_props.dateAlignment;
                var runningCount = 0;
                var start = date;
                var end;
                if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
                start = $33ab27ec71b00902$export$9e5f44173e64f162(start);
                start = this.skipHiddenDays(start, direction);
                end = start;
                do {
                    end = $33ab27ec71b00902$export$625550452a3fa3ec(end, 1);
                    if (!this.isHiddenDay(end)) runningCount += 1;
                }while (runningCount < dayCount);
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            // Builds a normalized range object for the "visible" range,
            // which is a way to define the currentRange and activeRange at the same time.
            key: "buildCustomVisibleRange",
            value: function buildCustomVisibleRange(date) {
                var props = this.props;
                var input = props.visibleRangeInput;
                var simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
                var range = this.refineRange(simpleInput);
                if (range && (range.start == null || range.end == null)) return null;
                return range;
            }
        },
        {
            // Computes the range that will represent the element/cells for *rendering*,
            // but which may have voided days/times.
            // not responsible for trimming hidden days.
            key: "buildRenderRange",
            value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
                return currentRange;
            }
        },
        {
            // Compute the duration value that should be added/substracted to the current date
            // when a prev/next operation happens.
            key: "buildDateIncrement",
            value: function buildDateIncrement(fallback) {
                var dateIncrement = this.props.dateIncrement;
                var customAlignment;
                if (dateIncrement) return dateIncrement;
                if (customAlignment = this.props.dateAlignment) return $33ab27ec71b00902$export$4368d992c4eafac0(1, customAlignment);
                if (fallback) return fallback;
                return $33ab27ec71b00902$export$4368d992c4eafac0({
                    days: 1
                });
            }
        },
        {
            key: "refineRange",
            value: function refineRange(rangeInput) {
                if (rangeInput) {
                    var range = $33ab27ec71b00902$var$parseRange(rangeInput, this.props.dateEnv);
                    if (range) range = $33ab27ec71b00902$export$92108d983e8ee699(range);
                    return range;
                }
                return null;
            }
        },
        {
            /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
            key: "initHiddenDays",
            value: function initHiddenDays() {
                var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
                var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
                var dayCnt = 0;
                var i;
                if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
                for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
                if (!dayCnt) throw new Error('invalid hiddenDays'); // all days were hidden? bad.
                this.isHiddenDayHash = isHiddenDayHash;
            }
        },
        {
            // Remove days from the beginning and end of the range that are computed as hidden.
            // If the whole range is trimmed off, returns null
            key: "trimHiddenDays",
            value: function trimHiddenDays(range) {
                var start = range.start, end = range.end;
                if (start) start = this.skipHiddenDays(start);
                if (end) end = this.skipHiddenDays(end, -1, true);
                if (start == null || end == null || start < end) return {
                    start: start,
                    end: end
                };
                return null;
            }
        },
        {
            // Is the current day hidden?
            // `day` is a day-of-week index (0-6), or a Date (used for UTC)
            key: "isHiddenDay",
            value: function isHiddenDay(day) {
                if (day instanceof Date) day = day.getUTCDay();
                return this.isHiddenDayHash[day];
            }
        },
        {
            // Incrementing the current day until it is no longer a hidden day, returning a copy.
            // DOES NOT CONSIDER validRange!
            // If the initial value of `date` is not a hidden day, don't do anything.
            // Pass `isExclusive` as `true` if you are dealing with an end date.
            // `inc` defaults to `1` (increment one day forward each time)
            key: "skipHiddenDays",
            value: function skipHiddenDays(date) {
                var inc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, isExclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $33ab27ec71b00902$export$625550452a3fa3ec(date, inc);
                return date;
            }
        }
    ]);
    return DateProfileGenerator;
}();
function $33ab27ec71b00902$export$995eb9fca571757(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $33ab27ec71b00902$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $33ab27ec71b00902$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(var i = 0; i < recurringTypes.length; i += 1){
        var parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            var allDay = refined.allDay;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $33ab27ec71b00902$var$expandRecurring(eventStore, framingRange, context) {
    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
    var defs = eventStore.defs, instances = eventStore.instances;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $33ab27ec71b00902$export$dda1d9f60106f0e9(instances, function(instance) {
        return !defs[instance.defId].recurringDef;
    });
    for(var defId in defs){
        var def = defs[defId];
        if (def.recurringDef) {
            var duration = def.recurringDef.duration;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            var starts = $33ab27ec71b00902$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = starts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var start = _step.value;
                    var instance = $33ab27ec71b00902$export$995eb9fca571757(defId, {
                        start: start,
                        end: dateEnv.add(start, duration)
                    });
                    instances[instance.instanceId] = instance;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $33ab27ec71b00902$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($33ab27ec71b00902$export$9e5f44173e64f162);
    return markers;
}
var $33ab27ec71b00902$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
var $33ab27ec71b00902$var$EVENT_DATE_REFINERS = {
    start: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    end: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    date: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
var $33ab27ec71b00902$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $33ab27ec71b00902$var$EVENT_NON_DATE_REFINERS), $33ab27ec71b00902$var$EVENT_DATE_REFINERS), {
    extendedProps: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5
});
function $33ab27ec71b00902$var$parseEvent(raw, eventSource, context, allowOpenRange) {
    var refiners = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $33ab27ec71b00902$var$buildEventRefiners(context), defIdMap = arguments.length > 5 ? arguments[5] : void 0, instanceIdMap = arguments.length > 6 ? arguments[6] : void 0;
    var _refineEventDef = $33ab27ec71b00902$export$3b513254972cfc9c(raw, context, refiners), refined = _refineEventDef.refined, extra = _refineEventDef.extra;
    var defaultAllDay = $33ab27ec71b00902$var$computeIsDefaultAllDay(eventSource, context);
    var recurringRes = $33ab27ec71b00902$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        var def = $33ab27ec71b00902$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    var singleRes = $33ab27ec71b00902$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        var def1 = $33ab27ec71b00902$export$f38c853ae54ed474(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        var instance = $33ab27ec71b00902$export$995eb9fca571757(def1.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def1.publicId && instanceIdMap[def1.publicId]) instance.instanceId = instanceIdMap[def1.publicId];
        return {
            def: def1,
            instance: instance
        };
    }
    return null;
}
function $33ab27ec71b00902$export$3b513254972cfc9c(raw, context) {
    var refiners = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $33ab27ec71b00902$var$buildEventRefiners(context);
    return $33ab27ec71b00902$export$ee7c8ad385a60b7b(raw, refiners);
}
function $33ab27ec71b00902$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $33ab27ec71b00902$var$EVENT_UI_REFINERS), $33ab27ec71b00902$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $33ab27ec71b00902$export$f38c853ae54ed474(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    var def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || $33ab27ec71b00902$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $33ab27ec71b00902$export$25ce5a424b770e84(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.eventDefMemberAdders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var memberAdder = _step.value;
            Object.assign(def, memberAdder(refined));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $33ab27ec71b00902$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    var allDay = refined.allDay;
    var startMeta;
    var startMarker = null;
    var hasEnd = false;
    var endMeta;
    var endMarker = null;
    var startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $33ab27ec71b00902$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $33ab27ec71b00902$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $33ab27ec71b00902$var$computeIsDefaultAllDay(eventSource, context) {
    var res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function $33ab27ec71b00902$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    var eventStore = $33ab27ec71b00902$export$7f8ddf7c7c20b3cd();
    var eventRefiners = $33ab27ec71b00902$var$buildEventRefiners(context);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rawEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawEvent = _step.value;
            var tuple = $33ab27ec71b00902$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
            if (tuple) $33ab27ec71b00902$export$317a3d46287192d8(tuple, eventStore);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return eventStore;
}
function $33ab27ec71b00902$export$317a3d46287192d8(tuple) {
    var eventStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $33ab27ec71b00902$export$7f8ddf7c7c20b3cd();
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $33ab27ec71b00902$export$667d3bf0c5f83305(eventStore, instanceId) {
    var instance = eventStore.instances[instanceId];
    if (instance) {
        var def = eventStore.defs[instance.defId];
        // get events/instances with same group
        var newStore = $33ab27ec71b00902$var$filterEventStoreDefs(eventStore, function(lookDef) {
            return $33ab27ec71b00902$var$isEventDefsGrouped(def, lookDef);
        });
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $33ab27ec71b00902$export$7f8ddf7c7c20b3cd();
}
function $33ab27ec71b00902$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $33ab27ec71b00902$export$7f8ddf7c7c20b3cd() {
    return {
        defs: {},
        instances: {}
    };
}
function $33ab27ec71b00902$export$d377dcb2b61d6c4e(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $33ab27ec71b00902$var$filterEventStoreDefs(eventStore, filterFunc) {
    var defs = $33ab27ec71b00902$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    var instances = $33ab27ec71b00902$export$dda1d9f60106f0e9(eventStore.instances, function(instance) {
        return defs[instance.defId] // still exists?
        ;
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $33ab27ec71b00902$var$excludeSubEventStore(master, sub) {
    var defs = master.defs, instances = master.instances;
    var filteredDefs = {};
    var filteredInstances = {};
    for(var defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(var instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $33ab27ec71b00902$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $33ab27ec71b00902$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if ((typeof input === "undefined" ? "undefined" : (0, $1PKUs._)(input)) === 'object' && input) return $33ab27ec71b00902$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $33ab27ec71b00902$export$f96d196f7728bb5(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
var $33ab27ec71b00902$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    overlap: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    allow: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    className: $33ab27ec71b00902$export$f96d196f7728bb5,
    classNames: $33ab27ec71b00902$export$f96d196f7728bb5,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
var $33ab27ec71b00902$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: []
};
function $33ab27ec71b00902$export$25ce5a424b770e84(refined, context) {
    var constraint = $33ab27ec71b00902$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $33ab27ec71b00902$export$1ee57be6f6687d2c(uis) {
    return uis.reduce($33ab27ec71b00902$var$combineTwoEventUis, $33ab27ec71b00902$var$EMPTY_EVENT_UI);
}
function $33ab27ec71b00902$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
var $33ab27ec71b00902$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    failure: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5
};
function $33ab27ec71b00902$export$ffb5f4729a158638(raw, context) {
    var refiners = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $33ab27ec71b00902$export$35e795649ee09318(context);
    var rawObj;
    if (typeof raw === 'string') rawObj = {
        url: raw
    };
    else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if ((typeof raw === "undefined" ? "undefined" : (0, $1PKUs._)(raw)) === 'object' && raw) rawObj = raw;
    if (rawObj) {
        var _refineProps = $33ab27ec71b00902$export$ee7c8ad385a60b7b(rawObj, refiners), refined = _refineProps.refined, extra = _refineProps.extra;
        var metaRes = $33ab27ec71b00902$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: '',
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || '',
            sourceId: $33ab27ec71b00902$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $33ab27ec71b00902$export$25ce5a424b770e84(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $33ab27ec71b00902$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $33ab27ec71b00902$var$EVENT_UI_REFINERS), $33ab27ec71b00902$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $33ab27ec71b00902$var$buildEventSourceMeta(raw, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    for(var i = defs.length - 1; i >= 0; i -= 1){
        var def = defs[i];
        var meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
function $33ab27ec71b00902$export$9bb611d729802a56(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case 'RECEIVE_EVENTS':
            return $33ab27ec71b00902$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'RESET_RAW_EVENTS':
            return $33ab27ec71b00902$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case 'ADD_EVENTS':
            return $33ab27ec71b00902$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS':
            return $33ab27ec71b00902$export$d377dcb2b61d6c4e(eventStore, action.eventStore);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $33ab27ec71b00902$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case 'REMOVE_EVENTS':
            return $33ab27ec71b00902$var$excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return $33ab27ec71b00902$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return $33ab27ec71b00902$var$filterEventStoreDefs(eventStore, function(eventDef) {
                return !eventDef.sourceId // only keep events with no source id
                ;
            });
        case 'REMOVE_ALL_EVENTS':
            return $33ab27ec71b00902$export$7f8ddf7c7c20b3cd();
        default:
            return eventStore;
    }
}
function $33ab27ec71b00902$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        var subset = $33ab27ec71b00902$var$parseEvents($33ab27ec71b00902$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $33ab27ec71b00902$var$expandRecurring(subset, fetchRange, context);
        return $33ab27ec71b00902$export$d377dcb2b61d6c4e($33ab27ec71b00902$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $33ab27ec71b00902$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    var _buildPublicIdMaps = $33ab27ec71b00902$var$buildPublicIdMaps(existingEventStore), defIdMap = _buildPublicIdMaps.defIdMap, instanceIdMap = _buildPublicIdMaps.instanceIdMap;
    var newEventStore = $33ab27ec71b00902$var$parseEvents($33ab27ec71b00902$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $33ab27ec71b00902$var$expandRecurring(newEventStore, activeRange, context);
}
function $33ab27ec71b00902$var$transformRawEvents(rawEvents, eventSource, context) {
    var calEachTransform = context.options.eventDataTransform;
    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $33ab27ec71b00902$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $33ab27ec71b00902$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $33ab27ec71b00902$var$transformEachRawEvent(rawEvents, func) {
    var refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rawEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rawEvent = _step.value;
                var refinedEvent = func(rawEvent);
                if (refinedEvent) refinedEvents.push(refinedEvent);
                else if (refinedEvent == null) refinedEvents.push(rawEvent);
                 // if a different falsy value, do nothing
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return refinedEvents;
}
function $33ab27ec71b00902$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $33ab27ec71b00902$var$expandRecurring(subset, expandRange, context);
    return $33ab27ec71b00902$export$d377dcb2b61d6c4e(eventStore, subset);
}
function $33ab27ec71b00902$export$b4171a6734a65d42(eventStore, oldDateEnv, newDateEnv) {
    var defs = eventStore.defs;
    var instances = $33ab27ec71b00902$export$407448d2b89b1813(eventStore.instances, function(instance) {
        var def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $33ab27ec71b00902$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $33ab27ec71b00902$var$filterEventStoreDefs(eventStore, function(eventDef) {
        return eventDef.sourceId !== sourceId;
    });
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $33ab27ec71b00902$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $33ab27ec71b00902$export$dda1d9f60106f0e9(eventStore.instances, function(instance) {
            return !removals[instance.instanceId];
        })
    };
}
function $33ab27ec71b00902$var$buildPublicIdMaps(eventStore) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var defIdMap = {};
    var instanceIdMap = {};
    for(var defId in defs){
        var def = defs[defId];
        var publicId = def.publicId;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(var instanceId in instances){
        var instance = instances[instanceId];
        var def1 = defs[instance.defId];
        var publicId1 = def1.publicId;
        if (publicId1) instanceIdMap[publicId1] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
var $33ab27ec71b00902$export$d66501df72047452 = /*#__PURE__*/ function() {
    "use strict";
    function Emitter() {
        (0, $8MSeJ._)(this, Emitter);
        this.handlers = {};
        this.thisContext = null;
    }
    (0, $gia3M._)(Emitter, [
        {
            key: "setThisContext",
            value: function setThisContext(thisContext) {
                this.thisContext = thisContext;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
        },
        {
            key: "on",
            value: function on(type, handler) {
                $33ab27ec71b00902$var$addToHash(this.handlers, type, handler);
            }
        },
        {
            key: "off",
            value: function off(type, handler) {
                $33ab27ec71b00902$var$removeFromHash(this.handlers, type, handler);
            }
        },
        {
            key: "trigger",
            value: function trigger(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var attachedHandlers = this.handlers[type] || [];
                var optionHandler = this.options && this.options[type];
                var handlers = [].concat(optionHandler || [], attachedHandlers);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler.apply(this.thisContext, args);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasHandlers",
            value: function hasHandlers(type) {
                return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
            }
        }
    ]);
    return Emitter;
}();
function $33ab27ec71b00902$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $33ab27ec71b00902$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter(function(func) {
            return func !== handler;
        });
    } else delete hash[type]; // remove all handler funcs for this type
}
var $33ab27ec71b00902$var$DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours'
};
/*
TODO: pass around as EventDefHash!!!
*/ function $33ab27ec71b00902$export$3a6d5c9ae78a2c08(input, context) {
    return $33ab27ec71b00902$var$parseEvents($33ab27ec71b00902$var$refineInputs(input), null, context);
}
function $33ab27ec71b00902$var$refineInputs(input) {
    var rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter(function(rawDef) {
        return rawDef.daysOfWeek;
    });
    else if ((typeof input === "undefined" ? "undefined" : (0, $1PKUs._)(input)) === 'object' && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map(function(rawDef) {
        return Object.assign(Object.assign({}, $33ab27ec71b00902$var$DEF_DEFAULTS), rawDef);
    });
    return rawDefs;
}
function $33ab27ec71b00902$export$cbfbec548517f2b6(selection, pev, context) {
    context.emitter.trigger('select', Object.assign(Object.assign({}, $33ab27ec71b00902$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $33ab27ec71b00902$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $33ab27ec71b00902$var$buildDateSpanApiWithContext(dateSpan, context) {
    var props = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.dateSpanTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            Object.assign(props, transform(dateSpan, context));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    Object.assign(props, $33ab27ec71b00902$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $33ab27ec71b00902$export$bde1ed0f60b38f2f(allDay, marker, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var end = marker;
    if (allDay) {
        end = $33ab27ec71b00902$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $33ab27ec71b00902$export$dabba94403d45c8e(eventStore, eventConfigBase, mutation, context) {
    var eventConfigs = $33ab27ec71b00902$var$compileEventUis(eventStore.defs, eventConfigBase);
    var dest = $33ab27ec71b00902$export$7f8ddf7c7c20b3cd();
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        dest.defs[defId] = $33ab27ec71b00902$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def1 = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $33ab27ec71b00902$var$applyMutationToEventInstance(instance, def1, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $33ab27ec71b00902$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    var standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    var copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.eventDefMutationAppliers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var applier = _step.value;
            applier(copy, mutation, context);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $33ab27ec71b00902$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    var dateEnv = context.dateEnv;
    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    var copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $33ab27ec71b00902$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $33ab27ec71b00902$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $33ab27ec71b00902$export$9e5f44173e64f162(copy.range.start),
        end: $33ab27ec71b00902$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $33ab27ec71b00902$export$bde1ed0f60b38f2f(eventDef.allDay, copy.range.start, context);
    return copy;
}
var $33ab27ec71b00902$var$EventSourceImpl = /*#__PURE__*/ function() {
    "use strict";
    function EventSourceImpl(context, internalEventSource) {
        (0, $8MSeJ._)(this, EventSourceImpl);
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    (0, $gia3M._)(EventSourceImpl, [
        {
            key: "remove",
            value: function remove() {
                this.context.dispatch({
                    type: 'REMOVE_EVENT_SOURCE',
                    sourceId: this.internalEventSource.sourceId
                });
            }
        },
        {
            key: "refetch",
            value: function refetch() {
                this.context.dispatch({
                    type: 'FETCH_EVENT_SOURCES',
                    sourceIds: [
                        this.internalEventSource.sourceId
                    ],
                    isRefetch: true
                });
            }
        },
        {
            key: "id",
            get: function get() {
                return this.internalEventSource.publicId;
            }
        },
        {
            key: "url",
            get: function get() {
                return this.internalEventSource.meta.url;
            }
        },
        {
            key: "format",
            get: function get() {
                return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
            }
        }
    ]);
    return EventSourceImpl;
}();
var $33ab27ec71b00902$export$71511d61b312f219 = /*#__PURE__*/ function() {
    "use strict";
    function EventImpl(context, def, instance) {
        (0, $8MSeJ._)(this, EventImpl);
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    (0, $gia3M._)(EventImpl, [
        {
            /*
    TODO: make event struct more responsible for this
    */ key: "setProp",
            value: function setProp(name, val) {
                if (name in $33ab27ec71b00902$var$EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
                else if (name === 'id') {
                    val = $33ab27ec71b00902$var$EVENT_NON_DATE_REFINERS[name](val);
                    this.mutate({
                        standardProps: {
                            publicId: val
                        }
                    });
                } else if (name in $33ab27ec71b00902$var$EVENT_NON_DATE_REFINERS) {
                    val = $33ab27ec71b00902$var$EVENT_NON_DATE_REFINERS[name](val);
                    this.mutate({
                        standardProps: (0, $eSf5K._)({}, name, val)
                    });
                } else if (name in $33ab27ec71b00902$var$EVENT_UI_REFINERS) {
                    var ui = $33ab27ec71b00902$var$EVENT_UI_REFINERS[name](val);
                    if (name === 'color') ui = {
                        backgroundColor: val,
                        borderColor: val
                    };
                    else if (name === 'editable') ui = {
                        startEditable: val,
                        durationEditable: val
                    };
                    else ui = (0, $eSf5K._)({}, name, val);
                    this.mutate({
                        standardProps: {
                            ui: ui
                        }
                    });
                } else console.warn("Could not set prop '".concat(name, "'. Use setExtendedProp instead."));
            }
        },
        {
            key: "setExtendedProp",
            value: function setExtendedProp(name, val) {
                this.mutate({
                    extendedProps: (0, $eSf5K._)({}, name, val)
                });
            }
        },
        {
            key: "setStart",
            value: function setStart(startInput) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var dateEnv = this._context.dateEnv;
                var start = dateEnv.createMarker(startInput);
                if (start && this._instance) {
                    var instanceRange = this._instance.range;
                    var startDelta = $33ab27ec71b00902$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
                    if (options.maintainDuration) this.mutate({
                        datesDelta: startDelta
                    });
                    else this.mutate({
                        startDelta: startDelta
                    });
                }
            }
        },
        {
            key: "setEnd",
            value: function setEnd(endInput) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var dateEnv = this._context.dateEnv;
                var end;
                if (endInput != null) {
                    end = dateEnv.createMarker(endInput);
                    if (!end) return; // TODO: warning if parsed bad
                }
                if (this._instance) {
                    if (end) {
                        var endDelta = $33ab27ec71b00902$export$28f7fcd39efa255(this._instance.range.end, end, dateEnv, options.granularity);
                        this.mutate({
                            endDelta: endDelta
                        });
                    } else this.mutate({
                        standardProps: {
                            hasEnd: false
                        }
                    });
                }
            }
        },
        {
            key: "setDates",
            value: function setDates(startInput, endInput) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var dateEnv = this._context.dateEnv;
                var standardProps = {
                    allDay: options.allDay
                };
                var start = dateEnv.createMarker(startInput);
                var end;
                if (!start) return; // TODO: warning if parsed bad
                if (endInput != null) {
                    end = dateEnv.createMarker(endInput);
                    if (!end) return;
                }
                if (this._instance) {
                    var instanceRange = this._instance.range;
                    // when computing the diff for an event being converted to all-day,
                    // compute diff off of the all-day values the way event-mutation does.
                    if (options.allDay === true) instanceRange = $33ab27ec71b00902$var$computeAlignedDayRange(instanceRange);
                    var startDelta = $33ab27ec71b00902$export$28f7fcd39efa255(instanceRange.start, start, dateEnv, options.granularity);
                    if (end) {
                        var endDelta = $33ab27ec71b00902$export$28f7fcd39efa255(instanceRange.end, end, dateEnv, options.granularity);
                        if ($33ab27ec71b00902$var$durationsEqual(startDelta, endDelta)) this.mutate({
                            datesDelta: startDelta,
                            standardProps: standardProps
                        });
                        else this.mutate({
                            startDelta: startDelta,
                            endDelta: endDelta,
                            standardProps: standardProps
                        });
                    } else {
                        standardProps.hasEnd = false;
                        this.mutate({
                            datesDelta: startDelta,
                            standardProps: standardProps
                        });
                    }
                }
            }
        },
        {
            key: "moveStart",
            value: function moveStart(deltaInput) {
                var delta = $33ab27ec71b00902$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    startDelta: delta
                });
            }
        },
        {
            key: "moveEnd",
            value: function moveEnd(deltaInput) {
                var delta = $33ab27ec71b00902$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    endDelta: delta
                });
            }
        },
        {
            key: "moveDates",
            value: function moveDates(deltaInput) {
                var delta = $33ab27ec71b00902$export$4368d992c4eafac0(deltaInput);
                if (delta) this.mutate({
                    datesDelta: delta
                });
            }
        },
        {
            key: "setAllDay",
            value: function setAllDay(allDay) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var standardProps = {
                    allDay: allDay
                };
                var maintainDuration = options.maintainDuration;
                if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
                if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
                this.mutate({
                    standardProps: standardProps
                });
            }
        },
        {
            key: "formatRange",
            value: function formatRange(formatInput) {
                var dateEnv = this._context.dateEnv;
                var instance = this._instance;
                var formatter = $33ab27ec71b00902$export$d141bba7fdc215a3(formatInput);
                if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
                    forcedStartTzo: instance.forcedStartTzo,
                    forcedEndTzo: instance.forcedEndTzo
                });
                return dateEnv.format(instance.range.start, formatter, {
                    forcedTzo: instance.forcedStartTzo
                });
            }
        },
        {
            key: "mutate",
            value: function mutate(mutation) {
                var instance = this._instance;
                if (instance) {
                    var def = this._def;
                    var context = this._context;
                    var eventStore = context.getCurrentData().eventStore;
                    var relevantEvents = $33ab27ec71b00902$export$667d3bf0c5f83305(eventStore, instance.instanceId);
                    var eventConfigBase = {
                        '': {
                            display: '',
                            startEditable: true,
                            durationEditable: true,
                            constraints: [],
                            overlap: null,
                            allows: [],
                            backgroundColor: '',
                            borderColor: '',
                            textColor: '',
                            classNames: []
                        }
                    };
                    relevantEvents = $33ab27ec71b00902$export$dabba94403d45c8e(relevantEvents, eventConfigBase, mutation, context);
                    var oldEvent = new EventImpl(context, def, instance); // snapshot
                    this._def = relevantEvents.defs[def.defId];
                    this._instance = relevantEvents.instances[instance.instanceId];
                    context.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: relevantEvents
                    });
                    context.emitter.trigger('eventChange', {
                        oldEvent: oldEvent,
                        event: this,
                        relatedEvents: $33ab27ec71b00902$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                        revert: function() {
                            context.dispatch({
                                type: 'RESET_EVENTS',
                                eventStore: eventStore
                            });
                        }
                    });
                }
            }
        },
        {
            key: "remove",
            value: function remove() {
                var context = this._context;
                var asStore = $33ab27ec71b00902$var$eventApiToStore(this);
                context.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: asStore
                });
                context.emitter.trigger('eventRemove', {
                    event: this,
                    relatedEvents: [],
                    revert: function() {
                        context.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: asStore
                        });
                    }
                });
            }
        },
        {
            key: "source",
            get: function get() {
                var sourceId = this._def.sourceId;
                if (sourceId) return new $33ab27ec71b00902$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
                return null;
            }
        },
        {
            key: "start",
            get: function get() {
                return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
            }
        },
        {
            key: "startStr",
            get: function get() {
                var instance = this._instance;
                if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedStartTzo
                });
                return '';
            }
        },
        {
            key: "endStr",
            get: function get() {
                var instance = this._instance;
                if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedEndTzo
                });
                return '';
            }
        },
        {
            key: "id",
            get: // computable props that all access the def
            // TODO: find a TypeScript-compatible way to do this at scale
            function get() {
                return this._def.publicId;
            }
        },
        {
            key: "groupId",
            get: function get() {
                return this._def.groupId;
            }
        },
        {
            key: "allDay",
            get: function get() {
                return this._def.allDay;
            }
        },
        {
            key: "title",
            get: function get() {
                return this._def.title;
            }
        },
        {
            key: "url",
            get: function get() {
                return this._def.url;
            }
        },
        {
            key: "display",
            get: function get() {
                return this._def.ui.display || 'auto';
            } // bad. just normalize the type earlier
        },
        {
            key: "startEditable",
            get: function get() {
                return this._def.ui.startEditable;
            }
        },
        {
            key: "durationEditable",
            get: function get() {
                return this._def.ui.durationEditable;
            }
        },
        {
            key: "constraint",
            get: function get() {
                return this._def.ui.constraints[0] || null;
            }
        },
        {
            key: "overlap",
            get: function get() {
                return this._def.ui.overlap;
            }
        },
        {
            key: "allow",
            get: function get() {
                return this._def.ui.allows[0] || null;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._def.ui.backgroundColor;
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._def.ui.borderColor;
            }
        },
        {
            key: "textColor",
            get: function get() {
                return this._def.ui.textColor;
            }
        },
        {
            key: "classNames",
            get: // NOTE: user can't modify these because Object.freeze was called in event-def parsing
            function get() {
                return this._def.ui.classNames;
            }
        },
        {
            key: "extendedProps",
            get: function get() {
                return this._def.extendedProps;
            }
        },
        {
            key: "toPlainObject",
            value: function toPlainObject() {
                var settings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var def = this._def;
                var ui = def.ui;
                var _this = this, startStr = _this.startStr, endStr = _this.endStr;
                var res = {
                    allDay: def.allDay
                };
                if (def.title) res.title = def.title;
                if (startStr) res.start = startStr;
                if (endStr) res.end = endStr;
                if (def.publicId) res.id = def.publicId;
                if (def.groupId) res.groupId = def.groupId;
                if (def.url) res.url = def.url;
                if (ui.display && ui.display !== 'auto') res.display = ui.display;
                // TODO: what about recurring-event properties???
                // TODO: include startEditable/durationEditable/constraint/overlap/allow
                if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
                else {
                    if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
                    if (ui.borderColor) res.borderColor = ui.borderColor;
                }
                if (ui.textColor) res.textColor = ui.textColor;
                if (ui.classNames.length) res.classNames = ui.classNames;
                if (Object.keys(def.extendedProps).length) {
                    if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
                    else res.extendedProps = def.extendedProps;
                }
                return res;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toPlainObject();
            }
        }
    ]);
    return EventImpl;
}();
function $33ab27ec71b00902$var$eventApiToStore(eventApi) {
    var def = eventApi._def;
    var instance = eventApi._instance;
    return {
        defs: (0, $eSf5K._)({}, def.defId, def),
        instances: instance ? (0, $eSf5K._)({}, instance.instanceId, instance) : {}
    };
}
function $33ab27ec71b00902$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var eventApis = [];
    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for(var id in instances){
        var instance = instances[id];
        var def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $33ab27ec71b00902$export$71511d61b312f219(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $33ab27ec71b00902$export$4c3d22f3d993c33f(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    var inverseBgByGroupId = {};
    var inverseBgByDefId = {};
    var defByGroupId = {};
    var bgRanges = [];
    var fgRanges = [];
    var eventUis = $33ab27ec71b00902$var$compileEventUis(eventStore.defs, eventUiBases);
    for(var defId in eventStore.defs){
        var def = eventStore.defs[defId];
        var ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(var instanceId in eventStore.instances){
        var instance = eventStore.instances[instanceId];
        var def1 = eventStore.defs[instance.defId];
        var ui1 = eventUis[def1.defId];
        var origRange = instance.range;
        var normalRange = !def1.allDay && nextDayThreshold ? $33ab27ec71b00902$export$92108d983e8ee699(origRange, nextDayThreshold) : origRange;
        var slicedRange = $33ab27ec71b00902$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui1.display === 'inverse-background') {
                if (def1.groupId) inverseBgByGroupId[def1.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui1.display !== 'none') (ui1.display === 'background' ? bgRanges : fgRanges).push({
                def: def1,
                ui: ui1,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(var groupId in inverseBgByGroupId){
        var ranges = inverseBgByGroupId[groupId];
        var invertedRanges = $33ab27ec71b00902$var$invertRanges(ranges, framingRange);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = invertedRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var invertedRange = _step.value;
                var def2 = defByGroupId[groupId];
                var ui2 = eventUis[def2.defId];
                bgRanges.push({
                    def: def2,
                    ui: ui2,
                    instance: null,
                    range: invertedRange,
                    isStart: false,
                    isEnd: false
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    for(var defId1 in inverseBgByDefId){
        var ranges1 = inverseBgByDefId[defId1];
        var invertedRanges1 = $33ab27ec71b00902$var$invertRanges(ranges1, framingRange);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = invertedRanges1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var invertedRange1 = _step1.value;
                bgRanges.push({
                    def: eventStore.defs[defId1],
                    ui: eventUis[defId1],
                    instance: null,
                    range: invertedRange1,
                    isStart: false,
                    isEnd: false
                });
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $33ab27ec71b00902$export$45aabb5431c2d04f(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function $33ab27ec71b00902$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $33ab27ec71b00902$export$8743009a87fcb00f(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $33ab27ec71b00902$var$compileEventUis(eventDefs, eventUiBases) {
    return $33ab27ec71b00902$export$407448d2b89b1813(eventDefs, function(eventDef) {
        return $33ab27ec71b00902$var$compileEventUi(eventDef, eventUiBases);
    });
}
function $33ab27ec71b00902$var$compileEventUi(eventDef, eventUiBases) {
    var uis = [];
    if (eventUiBases['']) uis.push(eventUiBases['']);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $33ab27ec71b00902$export$1ee57be6f6687d2c(uis);
}
function $33ab27ec71b00902$export$a91cd623adc48128(segs, eventOrderSpecs) {
    var objs = segs.map($33ab27ec71b00902$var$buildSegCompareObj);
    objs.sort(function(obj0, obj1) {
        return $33ab27ec71b00902$export$306ddfe3a8403e2(obj0, obj1, eventOrderSpecs);
    });
    return objs.map(function(c) {
        return c._seg;
    });
}
// returns a object with all primitive props that can be compared
function $33ab27ec71b00902$var$buildSegCompareObj(seg) {
    var eventRange = seg.eventRange;
    var eventDef = eventRange.def;
    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    var end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $33ab27ec71b00902$var$computeSegDraggable(seg, context) {
    var pluginHooks = context.pluginHooks;
    var transformers = pluginHooks.isDraggableTransformers;
    var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, ui = _seg_eventRange.ui;
    var val = ui.startEditable;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transformer = _step.value;
            val = transformer(val, def, ui, context);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return val;
}
function $33ab27ec71b00902$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $33ab27ec71b00902$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $33ab27ec71b00902$export$2538633961795d6b(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    var dateEnv = context.dateEnv, options = context.options;
    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    var wholeEventStart = eventInstance.range.start;
    var wholeEventEnd = eventInstance.range.end;
    var segStart = startOverride || seg.start || seg.eventRange.range.start;
    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
    var isStartDay = $33ab27ec71b00902$export$9e5f44173e64f162(wholeEventStart).valueOf() === $33ab27ec71b00902$export$9e5f44173e64f162(segStart).valueOf();
    var isEndDay = $33ab27ec71b00902$export$9e5f44173e64f162($33ab27ec71b00902$export$51b138e5a065c2bb(wholeEventEnd, -1)).valueOf() === $33ab27ec71b00902$export$9e5f44173e64f162($33ab27ec71b00902$export$51b138e5a065c2bb(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return '';
}
function $33ab27ec71b00902$export$993a080e5cb62d74(seg, todayRange, nowDate) {
    var segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $33ab27ec71b00902$export$2329c99376c9d0a4(todayRange, segRange.start)
    };
}
function $33ab27ec71b00902$var$getEventClassNames(props) {
    var classNames = [
        'fc-event'
    ];
    if (props.isMirror) classNames.push('fc-event-mirror');
    if (props.isDraggable) classNames.push('fc-event-draggable');
    if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
    if (props.isDragging) classNames.push('fc-event-dragging');
    if (props.isResizing) classNames.push('fc-event-resizing');
    if (props.isSelected) classNames.push('fc-event-selected');
    if (props.isStart) classNames.push('fc-event-start');
    if (props.isEnd) classNames.push('fc-event-end');
    if (props.isPast) classNames.push('fc-event-past');
    if (props.isToday) classNames.push('fc-event-today');
    if (props.isFuture) classNames.push('fc-event-future');
    return classNames;
}
function $33ab27ec71b00902$export$4d522598b426bb73(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : "".concat(eventRange.def.defId, ":").concat(eventRange.range.start.toISOString());
// inverse-background events don't have specific instances. TODO: better solution
}
function $33ab27ec71b00902$export$6dabbe08653f866f(seg, context) {
    var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, instance = _seg_eventRange.instance;
    var url = def.url;
    if (url) return {
        href: url
    };
    var emitter = context.emitter, options = context.options;
    var eventInteractive = options.eventInteractive;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $33ab27ec71b00902$var$createAriaKeyboardAttrs(function(ev) {
        emitter.trigger('eventClick', {
            el: ev.target,
            event: new $33ab27ec71b00902$export$71511d61b312f219(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
var $33ab27ec71b00902$var$STANDARD_PROPS = {
    start: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    end: $33ab27ec71b00902$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $33ab27ec71b00902$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    var span = $33ab27ec71b00902$var$parseOpenDateSpan(raw, dateEnv);
    var range = span.range;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $33ab27ec71b00902$var$parseOpenDateSpan(raw, dateEnv) {
    var _refineProps = $33ab27ec71b00902$export$ee7c8ad385a60b7b(raw, $33ab27ec71b00902$var$STANDARD_PROPS), standardProps = _refineProps.refined, extra = _refineProps.extra;
    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    var allDay = standardProps.allDay;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $33ab27ec71b00902$export$7f557e5eb95176c2(span0, span1) {
    return $33ab27ec71b00902$export$7a0bdf7d4a91ea88(span0.range, span1.range) && span0.allDay === span1.allDay && $33ab27ec71b00902$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $33ab27ec71b00902$var$isSpanPropsEqual(span0, span1) {
    for(var propName in span1)if (propName !== 'range' && propName !== 'allDay') {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(var propName1 in span0){
        if (!(propName1 in span1)) return false;
    }
    return true;
}
function $33ab27ec71b00902$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $33ab27ec71b00902$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $33ab27ec71b00902$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $33ab27ec71b00902$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $33ab27ec71b00902$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $33ab27ec71b00902$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    var res = $33ab27ec71b00902$export$3b513254972cfc9c({
        editable: false
    }, context);
    var def = $33ab27ec71b00902$export$f38c853ae54ed474(res.refined, res.extra, '', dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $33ab27ec71b00902$var$compileEventUi(def, eventUiBases),
        instance: $33ab27ec71b00902$export$995eb9fca571757(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $33ab27ec71b00902$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function wrappedSuccess(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    var wrappedFailure = function wrappedFailure(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
}
var $33ab27ec71b00902$export$f787f51d84a910ad = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $9i7pb._)(JsonRequestError, Error1);
    function JsonRequestError(message, response) {
        (0, $8MSeJ._)(this, JsonRequestError);
        var _this;
        _this = (0, $4v96Q._)(this, JsonRequestError, [
            message
        ]);
        _this.response = response;
        return _this;
    }
    return JsonRequestError;
}((0, $jdjhw._)(Error));
function $33ab27ec71b00902$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    var fetchOptions = {
        method: method
    };
    if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    return fetch(url, fetchOptions).then(function(fetchRes) {
        if (fetchRes.ok) return fetchRes.json().then(function(parsedResponse) {
            return [
                parsedResponse,
                fetchRes
            ];
        }, function() {
            throw new $33ab27ec71b00902$export$f787f51d84a910ad('Failure parsing JSON', fetchRes);
        });
        else throw new $33ab27ec71b00902$export$f787f51d84a910ad('Request failed', fetchRes);
    });
}
var $33ab27ec71b00902$var$canVGrowWithinCell;
function $33ab27ec71b00902$export$738ab4df8bf92ae9() {
    if ($33ab27ec71b00902$var$canVGrowWithinCell == null) $33ab27ec71b00902$var$canVGrowWithinCell = $33ab27ec71b00902$var$computeCanVGrowWithinCell();
    return $33ab27ec71b00902$var$canVGrowWithinCell;
}
function $33ab27ec71b00902$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') return true;
    var el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    var div = el.querySelector('div');
    var possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
var $33ab27ec71b00902$export$a9c996f45e5784d0 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(CalendarRoot, BaseComponent);
    function CalendarRoot() {
        (0, $8MSeJ._)(this, CalendarRoot);
        var _this;
        _this = (0, $4v96Q._)(this, CalendarRoot, arguments);
        _this.state = {
            forPrint: false
        };
        _this.handleBeforePrint = function() {
            $33ab27ec71b00902$export$c3950d9923825c02(function() {
                _this.setState({
                    forPrint: true
                });
            });
        };
        _this.handleAfterPrint = function() {
            $33ab27ec71b00902$export$c3950d9923825c02(function() {
                _this.setState({
                    forPrint: false
                });
            });
        };
        return _this;
    }
    (0, $gia3M._)(CalendarRoot, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var options = props.options;
                var forPrint = this.state.forPrint;
                var isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
                var height = !isHeightAuto && options.height != null ? options.height : '';
                var classNames = [
                    'fc',
                    forPrint ? 'fc-media-print' : 'fc-media-screen',
                    "fc-direction-".concat(options.direction),
                    props.theme.getClass('root')
                ];
                if (!$33ab27ec71b00902$export$738ab4df8bf92ae9()) classNames.push('fc-liquid-hack');
                return props.children(classNames, height, isHeightAuto, forPrint);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var emitter = this.props.emitter;
                emitter.on('_beforeprint', this.handleBeforePrint);
                emitter.on('_afterprint', this.handleAfterPrint);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var emitter = this.props.emitter;
                emitter.off('_beforeprint', this.handleBeforePrint);
                emitter.off('_afterprint', this.handleAfterPrint);
            }
        }
    ]);
    return CalendarRoot;
}($33ab27ec71b00902$export$ef35774e6d314e91);
var $33ab27ec71b00902$export$78acf4525d8a74c4 = /*#__PURE__*/ function() {
    "use strict";
    function Interaction(settings) {
        (0, $8MSeJ._)(this, Interaction);
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    (0, $gia3M._)(Interaction, [
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return Interaction;
}();
function $33ab27ec71b00902$export$efca4cbe5dd06740(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $33ab27ec71b00902$export$381353cf1dd55255(settings) {
    return (0, $eSf5K._)({}, settings.component.uid, settings);
}
// global state
var $33ab27ec71b00902$export$a8550f7dbe79f93a = {};
var $33ab27ec71b00902$export$2e2af4578d910ddf = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $9i7pb._)(NowTimer, Component);
    function NowTimer(props, context) {
        (0, $8MSeJ._)(this, NowTimer);
        var _this;
        _this = (0, $4v96Q._)(this, NowTimer, [
            props,
            context
        ]);
        _this.handleRefresh = function() {
            var timing = _this.computeTiming();
            if (timing.state.nowDate.valueOf() !== _this.state.nowDate.valueOf()) _this.setState(timing.state);
            _this.clearTimeout();
            _this.setTimeout(timing.waitMs);
        };
        _this.handleVisibilityChange = function() {
            if (!document.hidden) _this.handleRefresh();
        };
        _this.state = _this.computeTiming().state;
        return _this;
    }
    (0, $gia3M._)(NowTimer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                return props.children(state.nowDate, state.todayRange);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setTimeout();
                this.context.nowManager.addResetListener(this.handleRefresh);
                // fired tab becomes visible after being hidden
                document.addEventListener('visibilitychange', this.handleVisibilityChange);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.unit !== this.props.unit) {
                    this.clearTimeout();
                    this.setTimeout();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearTimeout();
                this.context.nowManager.removeResetListener(this.handleRefresh);
                document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            }
        },
        {
            key: "computeTiming",
            value: function computeTiming() {
                var _this = this, props = _this.props, context = _this.context;
                var unroundedNow = context.nowManager.getDateMarker();
                var nowIndicatorSnap = context.options.nowIndicatorSnap;
                if (nowIndicatorSnap === 'auto') nowIndicatorSnap = // large unit?
                /year|month|week|day/.test(props.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
                (props.unitValue || 1) === 1;
                var nowDate;
                var waitMs;
                if (nowIndicatorSnap) {
                    nowDate = context.dateEnv.startOf(unroundedNow, props.unit); // aka currentUnitStart
                    var nextUnitStart = context.dateEnv.add(nowDate, $33ab27ec71b00902$export$4368d992c4eafac0(1, props.unit));
                    waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
                } else {
                    nowDate = unroundedNow;
                    waitMs = 60000; // 1 minute
                }
                // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
                // ensure no longer than a day
                waitMs = Math.min(86400000, waitMs);
                return {
                    state: {
                        nowDate: nowDate,
                        todayRange: $33ab27ec71b00902$var$buildDayRange(nowDate)
                    },
                    waitMs: waitMs
                };
            }
        },
        {
            key: "setTimeout",
            value: function setTimeout1() {
                var _this = this;
                var waitMs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.computeTiming().waitMs;
                // NOTE: timeout could take longer than expected if tab sleeps,
                // which is why we listen to 'visibilitychange'
                this.timeoutId = setTimeout(function() {
                    // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
                    // This is why use use same waitMs from computeTiming, so we don't skip an interval while
                    // .setState() is executing
                    var timing = _this.computeTiming();
                    _this.setState(timing.state, function() {
                        _this.setTimeout(timing.waitMs);
                    });
                }, waitMs);
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                if (this.timeoutId) clearTimeout(this.timeoutId);
            }
        }
    ]);
    return NowTimer;
}((0, $kG1qx.Component));
$33ab27ec71b00902$export$2e2af4578d910ddf.contextType = $33ab27ec71b00902$export$e7c866399fa523f5;
function $33ab27ec71b00902$var$buildDayRange(date) {
    var start = $33ab27ec71b00902$export$9e5f44173e64f162(date);
    var end = $33ab27ec71b00902$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
var $33ab27ec71b00902$export$a93c5207d687da10 = /*#__PURE__*/ function() {
    "use strict";
    function CalendarImpl() {
        (0, $8MSeJ._)(this, CalendarImpl);
    }
    (0, $gia3M._)(CalendarImpl, [
        {
            key: "getCurrentData",
            value: function getCurrentData() {
                return this.currentDataManager.getCurrentData();
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.currentDataManager.dispatch(action);
            }
        },
        {
            key: "view",
            get: function get() {
                return this.getCurrentData().viewApi;
            }
        },
        {
            key: "batchRendering",
            value: function batchRendering(callback) {
                callback();
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                this.trigger('_resize', true);
            }
        },
        {
            // Options
            // -----------------------------------------------------------------------------------------------------------------
            key: "setOption",
            value: function setOption(name, val) {
                this.dispatch({
                    type: 'SET_OPTION',
                    optionName: name,
                    rawOptionValue: val
                });
            }
        },
        {
            key: "getOption",
            value: function getOption(name) {
                return this.currentDataManager.currentCalendarOptionsInput[name];
            }
        },
        {
            key: "getAvailableLocaleCodes",
            value: function getAvailableLocaleCodes() {
                return Object.keys(this.getCurrentData().availableRawLocales);
            }
        },
        {
            // Trigger
            // -----------------------------------------------------------------------------------------------------------------
            key: "on",
            value: function on(handlerName, handler) {
                var currentDataManager = this.currentDataManager;
                if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
                else console.warn("Unknown listener name '".concat(handlerName, "'"));
            }
        },
        {
            key: "off",
            value: function off(handlerName, handler) {
                this.currentDataManager.emitter.off(handlerName, handler);
            }
        },
        {
            // not meant for public use
            key: "trigger",
            value: function trigger(handlerName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_currentDataManager_emitter;
                (_this_currentDataManager_emitter = this.currentDataManager.emitter).trigger.apply(_this_currentDataManager_emitter, [
                    handlerName
                ].concat((0, $hvZMf._)(args)));
            }
        },
        {
            // View
            // -----------------------------------------------------------------------------------------------------------------
            key: "changeView",
            value: function changeView(viewType, dateOrRange) {
                var _this = this;
                this.batchRendering(function() {
                    _this.unselect();
                    if (dateOrRange) {
                        if (dateOrRange.start && dateOrRange.end) {
                            _this.dispatch({
                                type: 'CHANGE_VIEW_TYPE',
                                viewType: viewType
                            });
                            _this.dispatch({
                                type: 'SET_OPTION',
                                optionName: 'visibleRange',
                                rawOptionValue: dateOrRange
                            });
                        } else {
                            var dateEnv = _this.getCurrentData().dateEnv;
                            _this.dispatch({
                                type: 'CHANGE_VIEW_TYPE',
                                viewType: viewType,
                                dateMarker: dateEnv.createMarker(dateOrRange)
                            });
                        }
                    } else _this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType
                    });
                });
            }
        },
        {
            // Forces navigation to a view for the given date.
            // `viewType` can be a specific view name or a generic one like "week" or "day".
            // needs to change
            key: "zoomTo",
            value: function zoomTo(dateMarker, viewType) {
                var state = this.getCurrentData();
                var spec;
                viewType = viewType || 'day'; // day is default zoom
                spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
                this.unselect();
                if (spec) this.dispatch({
                    type: 'CHANGE_VIEW_TYPE',
                    viewType: spec.type,
                    dateMarker: dateMarker
                });
                else this.dispatch({
                    type: 'CHANGE_DATE',
                    dateMarker: dateMarker
                });
            }
        },
        {
            // Given a duration singular unit, like "week" or "day", finds a matching view spec.
            // Preference is given to views that have corresponding buttons.
            key: "getUnitViewSpec",
            value: function getUnitViewSpec(unit) {
                var _this_getCurrentData = this.getCurrentData(), viewSpecs = _this_getCurrentData.viewSpecs, toolbarConfig = _this_getCurrentData.toolbarConfig;
                var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
                var i;
                var spec;
                for(var viewType in viewSpecs)viewTypes.push(viewType);
                for(i = 0; i < viewTypes.length; i += 1){
                    spec = viewSpecs[viewTypes[i]];
                    if (spec) {
                        if (spec.singleUnit === unit) return spec;
                    }
                }
                return null;
            }
        },
        {
            // Current Date
            // -----------------------------------------------------------------------------------------------------------------
            key: "prev",
            value: function prev() {
                this.unselect();
                this.dispatch({
                    type: 'PREV'
                });
            }
        },
        {
            key: "next",
            value: function next() {
                this.unselect();
                this.dispatch({
                    type: 'NEXT'
                });
            }
        },
        {
            key: "prevYear",
            value: function prevYear() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: 'CHANGE_DATE',
                    dateMarker: state.dateEnv.addYears(state.currentDate, -1)
                });
            }
        },
        {
            key: "nextYear",
            value: function nextYear() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: 'CHANGE_DATE',
                    dateMarker: state.dateEnv.addYears(state.currentDate, 1)
                });
            }
        },
        {
            key: "today",
            value: function today() {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: 'CHANGE_DATE',
                    dateMarker: state.nowManager.getDateMarker()
                });
            }
        },
        {
            key: "gotoDate",
            value: function gotoDate(zonedDateInput) {
                var state = this.getCurrentData();
                this.unselect();
                this.dispatch({
                    type: 'CHANGE_DATE',
                    dateMarker: state.dateEnv.createMarker(zonedDateInput)
                });
            }
        },
        {
            key: "incrementDate",
            value: function incrementDate(deltaInput) {
                var state = this.getCurrentData();
                var delta = $33ab27ec71b00902$export$4368d992c4eafac0(deltaInput);
                if (delta) {
                    this.unselect();
                    this.dispatch({
                        type: 'CHANGE_DATE',
                        dateMarker: state.dateEnv.add(state.currentDate, delta)
                    });
                }
            }
        },
        {
            key: "getDate",
            value: function getDate() {
                var state = this.getCurrentData();
                return state.dateEnv.toDate(state.currentDate);
            }
        },
        {
            // Date Formatting Utils
            // -----------------------------------------------------------------------------------------------------------------
            key: "formatDate",
            value: function formatDate(d, formatter) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.format(dateEnv.createMarker(d), $33ab27ec71b00902$export$d141bba7fdc215a3(formatter));
            }
        },
        {
            // `settings` is for formatter AND isEndExclusive
            key: "formatRange",
            value: function formatRange(d0, d1, settings) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $33ab27ec71b00902$export$d141bba7fdc215a3(settings), settings);
            }
        },
        {
            key: "formatIso",
            value: function formatIso(d, omitTime) {
                var dateEnv = this.getCurrentData().dateEnv;
                return dateEnv.formatIso(dateEnv.createMarker(d), {
                    omitTime: omitTime
                });
            }
        },
        {
            // Date Selection / Event Selection / DayClick
            // -----------------------------------------------------------------------------------------------------------------
            key: "select",
            value: function select(dateOrObj, endDate) {
                var selectionInput;
                if (endDate == null) {
                    if (dateOrObj.start != null) selectionInput = dateOrObj;
                    else selectionInput = {
                        start: dateOrObj,
                        end: null
                    };
                } else selectionInput = {
                    start: dateOrObj,
                    end: endDate
                };
                var state = this.getCurrentData();
                var selection = $33ab27ec71b00902$var$parseDateSpan(selectionInput, state.dateEnv, $33ab27ec71b00902$export$4368d992c4eafac0({
                    days: 1
                }));
                if (selection) {
                    this.dispatch({
                        type: 'SELECT_DATES',
                        selection: selection
                    });
                    $33ab27ec71b00902$export$cbfbec548517f2b6(selection, null, state);
                }
            }
        },
        {
            key: "unselect",
            value: function unselect(pev) {
                var state = this.getCurrentData();
                if (state.dateSelection) {
                    this.dispatch({
                        type: 'UNSELECT_DATES'
                    });
                    $33ab27ec71b00902$var$triggerDateUnselect(pev, state);
                }
            }
        },
        {
            // Public Events API
            // -----------------------------------------------------------------------------------------------------------------
            key: "addEvent",
            value: function addEvent(eventInput, sourceInput) {
                if (eventInput instanceof $33ab27ec71b00902$export$71511d61b312f219) {
                    var def = eventInput._def;
                    var instance = eventInput._instance;
                    var currentData = this.getCurrentData();
                    // not already present? don't want to add an old snapshot
                    if (!currentData.eventStore.defs[def.defId]) {
                        this.dispatch({
                            type: 'ADD_EVENTS',
                            eventStore: $33ab27ec71b00902$export$317a3d46287192d8({
                                def: def,
                                instance: instance
                            })
                        });
                        this.triggerEventAdd(eventInput);
                    }
                    return eventInput;
                }
                var state = this.getCurrentData();
                var eventSource;
                var ref;
                if (sourceInput instanceof $33ab27ec71b00902$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
                else if (typeof sourceInput === 'boolean') {
                    if (sourceInput) ref = (0, $ar1mO._)($33ab27ec71b00902$export$90a7f3efeed30595(state.eventSources), 1), eventSource = ref[0], ref;
                } else if (sourceInput != null) {
                    var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
                    if (!sourceApi) {
                        console.warn('Could not find an event source with ID "'.concat(sourceInput, '"')); // TODO: test
                        return null;
                    }
                    eventSource = sourceApi.internalEventSource;
                }
                var tuple = $33ab27ec71b00902$var$parseEvent(eventInput, eventSource, state, false);
                if (tuple) {
                    var newEventApi = new $33ab27ec71b00902$export$71511d61b312f219(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
                    this.dispatch({
                        type: 'ADD_EVENTS',
                        eventStore: $33ab27ec71b00902$export$317a3d46287192d8(tuple)
                    });
                    this.triggerEventAdd(newEventApi);
                    return newEventApi;
                }
                return null;
            }
        },
        {
            key: "triggerEventAdd",
            value: function triggerEventAdd(eventApi) {
                var _this = this;
                var emitter = this.getCurrentData().emitter;
                emitter.trigger('eventAdd', {
                    event: eventApi,
                    relatedEvents: [],
                    revert: function() {
                        _this.dispatch({
                            type: 'REMOVE_EVENTS',
                            eventStore: $33ab27ec71b00902$var$eventApiToStore(eventApi)
                        });
                    }
                });
            }
        },
        {
            // TODO: optimize
            key: "getEventById",
            value: function getEventById(id) {
                var state = this.getCurrentData();
                var _state_eventStore = state.eventStore, defs = _state_eventStore.defs, instances = _state_eventStore.instances;
                id = String(id);
                for(var defId in defs){
                    var def = defs[defId];
                    if (def.publicId === id) {
                        if (def.recurringDef) return new $33ab27ec71b00902$export$71511d61b312f219(state, def, null);
                        for(var instanceId in instances){
                            var instance = instances[instanceId];
                            if (instance.defId === def.defId) return new $33ab27ec71b00902$export$71511d61b312f219(state, def, instance);
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "getEvents",
            value: function getEvents() {
                var currentData = this.getCurrentData();
                return $33ab27ec71b00902$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
            }
        },
        {
            key: "removeAllEvents",
            value: function removeAllEvents() {
                this.dispatch({
                    type: 'REMOVE_ALL_EVENTS'
                });
            }
        },
        {
            // Public Event Sources API
            // -----------------------------------------------------------------------------------------------------------------
            key: "getEventSources",
            value: function getEventSources() {
                var state = this.getCurrentData();
                var sourceHash = state.eventSources;
                var sourceApis = [];
                for(var internalId in sourceHash)sourceApis.push(new $33ab27ec71b00902$var$EventSourceImpl(state, sourceHash[internalId]));
                return sourceApis;
            }
        },
        {
            key: "getEventSourceById",
            value: function getEventSourceById(id) {
                var state = this.getCurrentData();
                var sourceHash = state.eventSources;
                id = String(id);
                for(var sourceId in sourceHash){
                    if (sourceHash[sourceId].publicId === id) return new $33ab27ec71b00902$var$EventSourceImpl(state, sourceHash[sourceId]);
                }
                return null;
            }
        },
        {
            key: "addEventSource",
            value: function addEventSource(sourceInput) {
                var state = this.getCurrentData();
                if (sourceInput instanceof $33ab27ec71b00902$var$EventSourceImpl) {
                    // not already present? don't want to add an old snapshot
                    if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                        type: 'ADD_EVENT_SOURCES',
                        sources: [
                            sourceInput.internalEventSource
                        ]
                    });
                    return sourceInput;
                }
                var eventSource = $33ab27ec71b00902$export$ffb5f4729a158638(sourceInput, state);
                if (eventSource) {
                    this.dispatch({
                        type: 'ADD_EVENT_SOURCES',
                        sources: [
                            eventSource
                        ]
                    });
                    return new $33ab27ec71b00902$var$EventSourceImpl(state, eventSource);
                }
                return null;
            }
        },
        {
            key: "removeAllEventSources",
            value: function removeAllEventSources() {
                this.dispatch({
                    type: 'REMOVE_ALL_EVENT_SOURCES'
                });
            }
        },
        {
            key: "refetchEvents",
            value: function refetchEvents() {
                this.dispatch({
                    type: 'FETCH_EVENT_SOURCES',
                    isRefetch: true
                });
            }
        },
        {
            // Scroll
            // -----------------------------------------------------------------------------------------------------------------
            key: "scrollToTime",
            value: function scrollToTime(timeInput) {
                var time = $33ab27ec71b00902$export$4368d992c4eafac0(timeInput);
                if (time) this.trigger('_scrollRequest', {
                    time: time
                });
            }
        }
    ]);
    return CalendarImpl;
}();
function $33ab27ec71b00902$export$24baa2b76016ce0e(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $33ab27ec71b00902$export$890c4ad488842ce7(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $33ab27ec71b00902$export$a33b77bbdbb8366c(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $33ab27ec71b00902$export$158acd800e1ef08b(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $33ab27ec71b00902$export$cf2f7c5792f80b46(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $33ab27ec71b00902$export$53a70dd1ebbae346(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
var $33ab27ec71b00902$var$EMPTY_EVENT_STORE = $33ab27ec71b00902$export$7f8ddf7c7c20b3cd(); // for purecomponents. TODO: keep elsewhere
var $33ab27ec71b00902$export$9d0e2d13d04f7070 = /*#__PURE__*/ function() {
    "use strict";
    function Splitter() {
        (0, $8MSeJ._)(this, Splitter);
        this.getKeysForEventDefs = $33ab27ec71b00902$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $33ab27ec71b00902$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $33ab27ec71b00902$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $33ab27ec71b00902$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $33ab27ec71b00902$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $33ab27ec71b00902$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    (0, $gia3M._)(Splitter, [
        {
            key: "splitProps",
            value: function splitProps(props) {
                var _this = this;
                var keyInfos = this.getKeyInfo(props);
                var defKeys = this.getKeysForEventDefs(props.eventStore);
                var dateSelections = this.splitDateSelection(props.dateSelection);
                var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
                var eventStores = this.splitEventStore(props.eventStore, defKeys);
                var eventDrags = this.splitEventDrag(props.eventDrag);
                var eventResizes = this.splitEventResize(props.eventResize);
                var splitProps = {};
                this.eventUiBuilders = $33ab27ec71b00902$export$407448d2b89b1813(keyInfos, function(info, key) {
                    return _this.eventUiBuilders[key] || $33ab27ec71b00902$export$df995fae86a55f06($33ab27ec71b00902$var$buildEventUiForKey);
                });
                for(var key in keyInfos){
                    var keyInfo = keyInfos[key];
                    var eventStore = eventStores[key] || $33ab27ec71b00902$var$EMPTY_EVENT_STORE;
                    var buildEventUi = this.eventUiBuilders[key];
                    splitProps[key] = {
                        businessHours: keyInfo.businessHours || props.businessHours,
                        dateSelection: dateSelections[key] || null,
                        eventStore: eventStore,
                        eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                        eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                        eventDrag: eventDrags[key] || null,
                        eventResize: eventResizes[key] || null
                    };
                }
                return splitProps;
            }
        },
        {
            key: "_splitDateSpan",
            value: function _splitDateSpan(dateSpan) {
                var dateSpans = {};
                if (dateSpan) {
                    var keys = this.getKeysForDateSpan(dateSpan);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            dateSpans[key] = dateSpan;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return dateSpans;
            }
        },
        {
            key: "_getKeysForEventDefs",
            value: function _getKeysForEventDefs(eventStore) {
                var _this = this;
                return $33ab27ec71b00902$export$407448d2b89b1813(eventStore.defs, function(eventDef) {
                    return _this.getKeysForEventDef(eventDef);
                });
            }
        },
        {
            key: "_splitEventStore",
            value: function _splitEventStore(eventStore, defKeys) {
                var defs = eventStore.defs, instances = eventStore.instances;
                var splitStores = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                for(var defId in defs)try {
                    for(var _iterator = defKeys[defId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!splitStores[key]) splitStores[key] = $33ab27ec71b00902$export$7f8ddf7c7c20b3cd();
                        splitStores[key].defs[defId] = defs[defId];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var instanceId in instances){
                    var instance = instances[instanceId];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = defKeys[instance.defId][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key1 = _step1.value;
                            if (splitStores[key1]) splitStores[key1].instances[instanceId] = instance;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                return splitStores;
            }
        },
        {
            key: "_splitIndividualUi",
            value: function _splitIndividualUi(eventUiBases, defKeys) {
                var splitHashes = {};
                for(var defId in eventUiBases){
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (defId) try {
                        for(var _iterator = defKeys[defId][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (!splitHashes[key]) splitHashes[key] = {};
                            splitHashes[key][defId] = eventUiBases[defId];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return splitHashes;
            }
        },
        {
            key: "_splitInteraction",
            value: function _splitInteraction(interaction) {
                var splitStates = {};
                if (interaction) {
                    var affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
                    // can't rely on defKeys because event data is mutated
                    var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
                    var mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
                    var populate = function(key) {
                        if (!splitStates[key]) splitStates[key] = {
                            affectedEvents: affectedStores[key] || $33ab27ec71b00902$var$EMPTY_EVENT_STORE,
                            mutatedEvents: mutatedStores[key] || $33ab27ec71b00902$var$EMPTY_EVENT_STORE,
                            isEvent: interaction.isEvent
                        };
                    };
                    for(var key in affectedStores)populate(key);
                    for(var key1 in mutatedStores)populate(key1);
                }
                return splitStates;
            }
        }
    ]);
    return Splitter;
}();
function $33ab27ec71b00902$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    var baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    var stuff = {
        '': $33ab27ec71b00902$export$1ee57be6f6687d2c(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $33ab27ec71b00902$export$e171bab687b50e0(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !$33ab27ec71b00902$export$2329c99376c9d0a4(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !$33ab27ec71b00902$export$2329c99376c9d0a4(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $33ab27ec71b00902$export$2329c99376c9d0a4(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $33ab27ec71b00902$export$1a8f5705751d8277(meta, theme) {
    var classNames = [
        'fc-day',
        "fc-day-".concat($33ab27ec71b00902$var$DAY_IDS[meta.dow])
    ];
    if (meta.isDisabled) classNames.push('fc-day-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-day-past');
        if (meta.isFuture) classNames.push('fc-day-future');
        if (meta.isOther) classNames.push('fc-day-other');
    }
    return classNames;
}
function $33ab27ec71b00902$export$527e9aa3390079e9(meta, theme) {
    var classNames = [
        'fc-slot',
        "fc-slot-".concat($33ab27ec71b00902$var$DAY_IDS[meta.dow])
    ];
    if (meta.isDisabled) classNames.push('fc-slot-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-slot-past');
        if (meta.isFuture) classNames.push('fc-slot-future');
    }
    return classNames;
}
var $33ab27ec71b00902$var$DAY_FORMAT = $33ab27ec71b00902$export$d141bba7fdc215a3({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
var $33ab27ec71b00902$var$WEEK_FORMAT = $33ab27ec71b00902$export$d141bba7fdc215a3({
    week: 'long'
});
function $33ab27ec71b00902$export$a17c37559e1db147(context, dateMarker) {
    var viewType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'day', isTabbable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var dateEnv = context.dateEnv, options = context.options, calendarApi = context.calendarApi;
    var dateStr = dateEnv.format(dateMarker, viewType === 'week' ? $33ab27ec71b00902$var$WEEK_FORMAT : $33ab27ec71b00902$var$DAY_FORMAT);
    if (options.navLinks) {
        var zonedDate = dateEnv.toDate(dateMarker);
        var handleInteraction = function(ev) {
            var customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === 'string') viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $33ab27ec71b00902$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            'data-navlink': ''
        }, isTabbable ? $33ab27ec71b00902$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        'aria-label': dateStr
    };
}
var $33ab27ec71b00902$var$_isRtlScrollbarOnLeft = null;
function $33ab27ec71b00902$export$c7ca7e4bc4f8a16e() {
    if ($33ab27ec71b00902$var$_isRtlScrollbarOnLeft === null) $33ab27ec71b00902$var$_isRtlScrollbarOnLeft = $33ab27ec71b00902$var$computeIsRtlScrollbarOnLeft();
    return $33ab27ec71b00902$var$_isRtlScrollbarOnLeft;
}
function $33ab27ec71b00902$var$computeIsRtlScrollbarOnLeft() {
    var outerEl = document.createElement('div');
    $33ab27ec71b00902$export$faec65b429be379(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $33ab27ec71b00902$export$9f4f30ee63539e24(outerEl);
    return res;
}
var $33ab27ec71b00902$var$_scrollbarWidths;
function $33ab27ec71b00902$export$a1edd97dd51cd48d() {
    if (!$33ab27ec71b00902$var$_scrollbarWidths) $33ab27ec71b00902$var$_scrollbarWidths = $33ab27ec71b00902$var$computeScrollbarWidths();
    return $33ab27ec71b00902$var$_scrollbarWidths;
}
function $33ab27ec71b00902$var$computeScrollbarWidths() {
    var el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    var res = $33ab27ec71b00902$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $33ab27ec71b00902$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $33ab27ec71b00902$export$2ec5befb9e6c97d4(el) {
    var getPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var badScrollbarWidths = $33ab27ec71b00902$var$computeScrollbarWidthsForEl(el); // includes border!
    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($33ab27ec71b00902$export$c7ca7e4bc4f8a16e() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $33ab27ec71b00902$export$d29e374196577086(el) {
    var goWithinPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, doFromWindowViewport = arguments.length > 2 ? arguments[2] : void 0;
    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $33ab27ec71b00902$export$39c1cc7c062529d4(el);
    var edges = $33ab27ec71b00902$export$2ec5befb9e6c97d4(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $33ab27ec71b00902$export$39c1cc7c062529d4(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function $33ab27ec71b00902$var$computeClippedClientRect(el) {
    var clippingParents = $33ab27ec71b00902$export$53c86fa97d611818(el);
    var rect = el.getBoundingClientRect();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = clippingParents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var clippingParent = _step.value;
            var intersection = $33ab27ec71b00902$export$890c4ad488842ce7(rect, clippingParent.getBoundingClientRect());
            if (intersection) rect = intersection;
            else return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rect;
}
// does not return window
function $33ab27ec71b00902$export$53c86fa97d611818(el) {
    var parents = [];
    while(el instanceof HTMLElement){
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ var $33ab27ec71b00902$export$ad4aebacdcaf47f8 = /*#__PURE__*/ function() {
    "use strict";
    function PositionCache(originEl, els, isHorizontal, isVertical) {
        (0, $8MSeJ._)(this, PositionCache);
        this.els = els;
        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    (0, $gia3M._)(PositionCache, [
        {
            // Populates the left/right internal coordinate arrays
            key: "buildElHorizontals",
            value: function buildElHorizontals(originClientLeft) {
                var lefts = [];
                var rights = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var rect = el.getBoundingClientRect();
                        lefts.push(rect.left - originClientLeft);
                        rights.push(rect.right - originClientLeft);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.lefts = lefts;
                this.rights = rights;
            }
        },
        {
            // Populates the top/bottom internal coordinate arrays
            key: "buildElVerticals",
            value: function buildElVerticals(originClientTop) {
                var tops = [];
                var bottoms = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var rect = el.getBoundingClientRect();
                        tops.push(rect.top - originClientTop);
                        bottoms.push(rect.bottom - originClientTop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.tops = tops;
                this.bottoms = bottoms;
            }
        },
        {
            // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
            // If no intersection is made, returns undefined.
            key: "leftToIndex",
            value: function leftToIndex(leftPosition) {
                var _this = this, lefts = _this.lefts, rights = _this.rights;
                var len = lefts.length;
                var i;
                for(i = 0; i < len; i += 1){
                    if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
                }
                return undefined; // TODO: better
            }
        },
        {
            // Given a top offset (from document top), returns the index of the el that it vertically intersects.
            // If no intersection is made, returns undefined.
            key: "topToIndex",
            value: function topToIndex(topPosition) {
                var _this = this, tops = _this.tops, bottoms = _this.bottoms;
                var len = tops.length;
                var i;
                for(i = 0; i < len; i += 1){
                    if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
                }
                return undefined; // TODO: better
            }
        },
        {
            // Gets the width of the element at the given index
            key: "getWidth",
            value: function getWidth(leftIndex) {
                return this.rights[leftIndex] - this.lefts[leftIndex];
            }
        },
        {
            // Gets the height of the element at the given index
            key: "getHeight",
            value: function getHeight(topIndex) {
                return this.bottoms[topIndex] - this.tops[topIndex];
            }
        },
        {
            key: "similarTo",
            value: function similarTo(otherCache) {
                return $33ab27ec71b00902$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $33ab27ec71b00902$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $33ab27ec71b00902$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $33ab27ec71b00902$var$similarNumArrays(this.rights || [], otherCache.rights || []);
            }
        }
    ]);
    return PositionCache;
}();
function $33ab27ec71b00902$var$similarNumArrays(a, b) {
    var len = a.length;
    if (len !== b.length) return false;
    for(var i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ var $33ab27ec71b00902$export$4ae495d48253603d = /*#__PURE__*/ function() {
    "use strict";
    function ScrollController() {
        (0, $8MSeJ._)(this, ScrollController);
    }
    (0, $gia3M._)(ScrollController, [
        {
            key: "getMaxScrollTop",
            value: function getMaxScrollTop() {
                return this.getScrollHeight() - this.getClientHeight();
            }
        },
        {
            key: "getMaxScrollLeft",
            value: function getMaxScrollLeft() {
                return this.getScrollWidth() - this.getClientWidth();
            }
        },
        {
            key: "canScrollVertically",
            value: function canScrollVertically() {
                return this.getMaxScrollTop() > 0;
            }
        },
        {
            key: "canScrollHorizontally",
            value: function canScrollHorizontally() {
                return this.getMaxScrollLeft() > 0;
            }
        },
        {
            key: "canScrollUp",
            value: function canScrollUp() {
                return this.getScrollTop() > 0;
            }
        },
        {
            key: "canScrollDown",
            value: function canScrollDown() {
                return this.getScrollTop() < this.getMaxScrollTop();
            }
        },
        {
            key: "canScrollLeft",
            value: function canScrollLeft() {
                return this.getScrollLeft() > 0;
            }
        },
        {
            key: "canScrollRight",
            value: function canScrollRight() {
                return this.getScrollLeft() < this.getMaxScrollLeft();
            }
        }
    ]);
    return ScrollController;
}();
var $33ab27ec71b00902$export$7060da4b5db56fb9 = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $9i7pb._)(ElementScrollController, ScrollController);
    function ElementScrollController(el) {
        (0, $8MSeJ._)(this, ElementScrollController);
        var _this;
        _this = (0, $4v96Q._)(this, ElementScrollController);
        _this.el = el;
        return _this;
    }
    (0, $gia3M._)(ElementScrollController, [
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return this.el.scrollTop;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return this.el.scrollLeft;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(top) {
                this.el.scrollTop = top;
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(left) {
                this.el.scrollLeft = left;
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return this.el.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return this.el.scrollHeight;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return this.el.clientHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return this.el.clientWidth;
            }
        }
    ]);
    return ElementScrollController;
}($33ab27ec71b00902$export$4ae495d48253603d);
var $33ab27ec71b00902$export$c5d1328b37d47994 = /*#__PURE__*/ function(ScrollController) {
    "use strict";
    (0, $9i7pb._)(WindowScrollController, ScrollController);
    function WindowScrollController() {
        (0, $8MSeJ._)(this, WindowScrollController);
        return (0, $4v96Q._)(this, WindowScrollController, arguments);
    }
    (0, $gia3M._)(WindowScrollController, [
        {
            key: "getScrollTop",
            value: function getScrollTop() {
                return window.scrollY;
            }
        },
        {
            key: "getScrollLeft",
            value: function getScrollLeft() {
                return window.scrollX;
            }
        },
        {
            key: "setScrollTop",
            value: function setScrollTop(n) {
                window.scroll(window.scrollX, n);
            }
        },
        {
            key: "setScrollLeft",
            value: function setScrollLeft(n) {
                window.scroll(n, window.scrollY);
            }
        },
        {
            key: "getScrollWidth",
            value: function getScrollWidth() {
                return document.documentElement.scrollWidth;
            }
        },
        {
            key: "getScrollHeight",
            value: function getScrollHeight() {
                return document.documentElement.scrollHeight;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight() {
                return document.documentElement.clientHeight;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth() {
                return document.documentElement.clientWidth;
            }
        }
    ]);
    return WindowScrollController;
}($33ab27ec71b00902$export$4ae495d48253603d);
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ var $33ab27ec71b00902$export$d22783b3c2400a3a = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(DateComponent, BaseComponent);
    function DateComponent() {
        (0, $8MSeJ._)(this, DateComponent);
        var _this;
        _this = (0, $4v96Q._)(this, DateComponent, arguments);
        _this.uid = $33ab27ec71b00902$export$39b482c5e57630a8();
        return _this;
    }
    (0, $gia3M._)(DateComponent, [
        {
            // Hit System
            // -----------------------------------------------------------------------------------------------------------------
            key: "prepareHits",
            value: function prepareHits() {}
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
                return null; // this should be abstract
            }
        },
        {
            // Pointer Interaction Utils
            // -----------------------------------------------------------------------------------------------------------------
            key: "isValidSegDownEl",
            value: function isValidSegDownEl(el) {
                return !this.props.eventDrag && // HACK
                !this.props.eventResize && // HACK
                !$33ab27ec71b00902$export$dc98b0b04f4c7758(el, '.fc-event-mirror');
            }
        },
        {
            key: "isValidDateDownEl",
            value: function isValidDateDownEl(el) {
                return !$33ab27ec71b00902$export$dc98b0b04f4c7758(el, '.fc-event:not(.fc-bg-event)') && !$33ab27ec71b00902$export$dc98b0b04f4c7758(el, '.fc-more-link') && // a "more.." link
                !$33ab27ec71b00902$export$dc98b0b04f4c7758(el, 'a[data-navlink]') && // a clickable nav link
                !$33ab27ec71b00902$export$dc98b0b04f4c7758(el, '.fc-popover'); // hack
            }
        }
    ]);
    return DateComponent;
}($33ab27ec71b00902$export$ef35774e6d314e91);
var $33ab27ec71b00902$export$45d219bdcd8ac53c = function NamedTimeZoneImpl(timeZoneName) {
    "use strict";
    (0, $8MSeJ._)(this, NamedTimeZoneImpl);
    this.timeZoneName = timeZoneName;
};
var $33ab27ec71b00902$export$766bf7dcfb630b6c = /*#__PURE__*/ function() {
    "use strict";
    function SegHierarchy() {
        var getEntryThickness = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(entry) {
            // if no thickness known, assume 1 (if 0, so small it always fits)
            return entry.thickness || 1;
        };
        (0, $8MSeJ._)(this, SegHierarchy);
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    (0, $gia3M._)(SegHierarchy, [
        {
            key: "addSegs",
            value: function addSegs(inputs) {
                var hiddenEntries = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        this.insertEntry(input, hiddenEntries);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return hiddenEntries;
            }
        },
        {
            key: "insertEntry",
            value: function insertEntry(entry, hiddenEntries) {
                var insertion = this.findInsertion(entry);
                if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
                else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
            }
        },
        {
            key: "isInsertionValid",
            value: function isInsertionValid(insertion, entry) {
                return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
            }
        },
        {
            key: "handleInvalidInsertion",
            value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
                if (this.allowReslicing && insertion.touchingEntry) {
                    var hiddenEntry = Object.assign(Object.assign({}, entry), {
                        span: $33ab27ec71b00902$export$b0165a7e514844(entry.span, insertion.touchingEntry.span)
                    });
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
                } else hiddenEntries.push(entry);
            }
        },
        {
            /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ key: "splitEntry",
            value: function splitEntry(entry, barrier, hiddenEntries) {
                var entrySpan = entry.span;
                var barrierSpan = barrier.span;
                if (entrySpan.start < barrierSpan.start) this.insertEntry({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: {
                        start: entrySpan.start,
                        end: barrierSpan.start
                    }
                }, hiddenEntries);
                if (entrySpan.end > barrierSpan.end) this.insertEntry({
                    index: entry.index,
                    thickness: entry.thickness,
                    span: {
                        start: barrierSpan.end,
                        end: entrySpan.end
                    }
                }, hiddenEntries);
            }
        },
        {
            key: "insertEntryAt",
            value: function insertEntryAt(entry, insertion) {
                var _this = this, entriesByLevel = _this.entriesByLevel, levelCoords = _this.levelCoords;
                if (insertion.lateral === -1) {
                    // create a new level
                    $33ab27ec71b00902$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
                    $33ab27ec71b00902$var$insertAt(entriesByLevel, insertion.level, [
                        entry
                    ]);
                } else // insert into existing level
                $33ab27ec71b00902$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
                this.stackCnts[$33ab27ec71b00902$export$674f8f4247a5112e(entry)] = insertion.stackCnt;
            }
        },
        {
            /*
    does not care about limits
    */ key: "findInsertion",
            value: function findInsertion(newEntry) {
                var _this = this, levelCoords = _this.levelCoords, entriesByLevel = _this.entriesByLevel, strictOrder = _this.strictOrder, stackCnts = _this.stackCnts;
                var levelCnt = levelCoords.length;
                var candidateCoord = 0;
                var touchingLevel = -1;
                var touchingLateral = -1;
                var touchingEntry = null;
                var stackCnt = 0;
                for(var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
                    var trackingCoord = levelCoords[trackingLevel];
                    // if the current level is past the placed entry, we have found a good empty space and can stop.
                    // if strictOrder, keep finding more lateral intersections.
                    if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
                    var trackingEntries = entriesByLevel[trackingLevel];
                    var trackingEntry = void 0;
                    var searchRes = $33ab27ec71b00902$export$eb84e45a33f6ba7c(trackingEntries, newEntry.span.start, $33ab27ec71b00902$export$2e63b696b2c9441b); // find first entry after newEntry's end
                    var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
                    while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
                    trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
                    ){
                        var trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                        // intersects into the top of the candidate?
                        if (trackingEntryBottom > candidateCoord) {
                            candidateCoord = trackingEntryBottom;
                            touchingEntry = trackingEntry;
                            touchingLevel = trackingLevel;
                            touchingLateral = lateralIndex;
                        }
                        // butts up against top of candidate? (will happen if just intersected as well)
                        if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                        stackCnt = Math.max(stackCnt, stackCnts[$33ab27ec71b00902$export$674f8f4247a5112e(trackingEntry)] + 1);
                        lateralIndex += 1;
                    }
                }
                // the destination level will be after touchingEntry's level. find it
                var destLevel = 0;
                if (touchingEntry) {
                    destLevel = touchingLevel + 1;
                    while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
                }
                // if adding to an existing level, find where to insert
                var destLateral = -1;
                if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $33ab27ec71b00902$export$eb84e45a33f6ba7c(entriesByLevel[destLevel], newEntry.span.end, $33ab27ec71b00902$export$2e63b696b2c9441b)[0];
                return {
                    touchingLevel: touchingLevel,
                    touchingLateral: touchingLateral,
                    touchingEntry: touchingEntry,
                    stackCnt: stackCnt,
                    levelCoord: candidateCoord,
                    level: destLevel,
                    lateral: destLateral
                };
            }
        },
        {
            // sorted by levelCoord (lowest to highest)
            key: "toRects",
            value: function toRects() {
                var _this = this, entriesByLevel = _this.entriesByLevel, levelCoords = _this.levelCoords;
                var levelCnt = entriesByLevel.length;
                var rects = [];
                for(var level = 0; level < levelCnt; level += 1){
                    var entries = entriesByLevel[level];
                    var levelCoord = levelCoords[level];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            rects.push(Object.assign(Object.assign({}, entry), {
                                thickness: this.getEntryThickness(entry),
                                levelCoord: levelCoord
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return rects;
            }
        }
    ]);
    return SegHierarchy;
}();
function $33ab27ec71b00902$export$2e63b696b2c9441b(entry) {
    return entry.span.end;
}
function $33ab27ec71b00902$export$674f8f4247a5112e(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function $33ab27ec71b00902$export$d76842aa27385215(entries) {
    var merges = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var filteredMerges = [];
            var hungryMerge = {
                span: entry.span,
                entries: [
                    entry
                ]
            };
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = merges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var merge = _step1.value;
                    if ($33ab27ec71b00902$export$b0165a7e514844(merge.span, hungryMerge.span)) hungryMerge = {
                        entries: merge.entries.concat(hungryMerge.entries),
                        span: $33ab27ec71b00902$var$joinSpans(merge.span, hungryMerge.span)
                    };
                    else filteredMerges.push(merge);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            filteredMerges.push(hungryMerge);
            merges = filteredMerges;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merges;
}
function $33ab27ec71b00902$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $33ab27ec71b00902$export$b0165a7e514844(span0, span1) {
    var start = Math.max(span0.start, span1.start);
    var end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $33ab27ec71b00902$export$eb84e45a33f6ba7c(a, searchVal, getItemVal) {
    var startIndex = 0;
    var endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        var middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ var $33ab27ec71b00902$export$b2bcef12bcefba04 = /*#__PURE__*/ function() {
    "use strict";
    function ElementDragging(el, selector) {
        (0, $8MSeJ._)(this, ElementDragging);
        this.emitter = new $33ab27ec71b00902$export$d66501df72047452();
    }
    (0, $gia3M._)(ElementDragging, [
        {
            key: "destroy",
            value: function destroy() {}
        },
        {
            key: "setMirrorIsVisible",
            value: function setMirrorIsVisible(bool) {
            // optional if subclass doesn't want to support a mirror
            }
        },
        {
            key: "setMirrorNeedsRevert",
            value: function setMirrorNeedsRevert(bool) {
            // optional if subclass doesn't want to support a mirror
            }
        },
        {
            key: "setAutoScrollEnabled",
            value: function setAutoScrollEnabled(bool) {
            // optional
            }
        }
    ]);
    return ElementDragging;
}();
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
var $33ab27ec71b00902$export$aff10ba49ece4b91 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ var $33ab27ec71b00902$var$DRAG_META_REFINERS = {
    startTime: $33ab27ec71b00902$export$4368d992c4eafac0,
    duration: $33ab27ec71b00902$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $33ab27ec71b00902$export$60bb826a6acf3081(raw) {
    var _refineProps = $33ab27ec71b00902$export$ee7c8ad385a60b7b(raw, $33ab27ec71b00902$var$DRAG_META_REFINERS), refined = _refineProps.refined, extra = _refineProps.extra;
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $33ab27ec71b00902$export$1abb261478089fe6(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $33ab27ec71b00902$export$d141bba7fdc215a3({
        weekday: 'short'
    }); // "Sat"
    if (dayCnt > 1) return $33ab27ec71b00902$export$d141bba7fdc215a3({
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
    }); // "Sat 11/12"
    return $33ab27ec71b00902$export$d141bba7fdc215a3({
        weekday: 'long'
    }); // "Saturday"
}
var $33ab27ec71b00902$var$CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function $33ab27ec71b00902$var$renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
var $33ab27ec71b00902$export$ebc5e65867841cbe = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(TableDateCell, BaseComponent);
    function TableDateCell() {
        (0, $8MSeJ._)(this, TableDateCell);
        return (0, $4v96Q._)(this, TableDateCell, arguments);
    }
    (0, $gia3M._)(TableDateCell, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, dateEnv = _this_context.dateEnv, options = _this_context.options, theme = _this_context.theme, viewApi = _this_context.viewApi;
                var props = this.props;
                var date = props.date, dateProfile = props.dateProfile;
                var dayMeta = $33ab27ec71b00902$export$e171bab687b50e0(date, props.todayRange, null, dateProfile);
                var classNames = [
                    $33ab27ec71b00902$var$CLASS_NAME
                ].concat($33ab27ec71b00902$export$1a8f5705751d8277(dayMeta, theme));
                var text = dateEnv.format(date, props.dayHeaderFormat);
                // if colCnt is 1, we are already in a day-view and don't need a navlink
                var navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $33ab27ec71b00902$export$a17c37559e1db147(this.context, date) : {};
                var publicDate = dateEnv.toDate(date);
                // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
                // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
                if (dateEnv.namedTimeZoneImpl) publicDate = $33ab27ec71b00902$export$51b138e5a065c2bb(publicDate, 3600000); // add an hour
                var renderProps = Object.assign(Object.assign(Object.assign({
                    date: publicDate,
                    view: viewApi
                }, props.extraRenderProps), {
                    text: text
                }), dayMeta);
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
                    elTag: "th",
                    elClasses: classNames,
                    elAttrs: Object.assign({
                        role: 'columnheader',
                        colSpan: props.colSpan,
                        'data-date': !dayMeta.isDisabled ? $33ab27ec71b00902$export$56350196709588fc(date) : undefined
                    }, props.extraDataAttrs),
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $33ab27ec71b00902$var$renderInner$1,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContainer) {
                    return (0, $kG1qx.createElement)("div", {
                        className: "fc-scrollgrid-sync-inner"
                    }, !dayMeta.isDisabled && (0, $kG1qx.createElement)(InnerContainer, {
                        elTag: "a",
                        elAttrs: navLinkAttrs,
                        elClasses: [
                            'fc-col-header-cell-cushion',
                            props.isSticky && 'fc-sticky'
                        ]
                    }));
                });
            }
        }
    ]);
    return TableDateCell;
}($33ab27ec71b00902$export$ef35774e6d314e91);
var $33ab27ec71b00902$var$WEEKDAY_FORMAT = $33ab27ec71b00902$export$d141bba7fdc215a3({
    weekday: 'long'
});
var $33ab27ec71b00902$export$1ddf2d01943a3512 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(TableDowCell, BaseComponent);
    function TableDowCell() {
        (0, $8MSeJ._)(this, TableDowCell);
        return (0, $4v96Q._)(this, TableDowCell, arguments);
    }
    (0, $gia3M._)(TableDowCell, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this_context = this.context, dateEnv = _this_context.dateEnv, theme = _this_context.theme, viewApi = _this_context.viewApi, options = _this_context.options;
                var date = $33ab27ec71b00902$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
                var dateMeta = {
                    dow: props.dow,
                    isDisabled: false,
                    isFuture: false,
                    isPast: false,
                    isToday: false,
                    isOther: false
                };
                var text = dateEnv.format(date, props.dayHeaderFormat);
                var renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
                    date: date
                }, dateMeta), {
                    view: viewApi
                }), props.extraRenderProps), {
                    text: text
                });
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
                    elTag: "th",
                    elClasses: [
                        $33ab27ec71b00902$var$CLASS_NAME
                    ].concat((0, $hvZMf._)($33ab27ec71b00902$export$1a8f5705751d8277(dateMeta, theme)), (0, $hvZMf._)(props.extraClassNames || [])),
                    elAttrs: Object.assign({
                        role: 'columnheader',
                        colSpan: props.colSpan
                    }, props.extraDataAttrs),
                    renderProps: renderProps,
                    generatorName: "dayHeaderContent",
                    customGenerator: options.dayHeaderContent,
                    defaultGenerator: $33ab27ec71b00902$var$renderInner$1,
                    classNameGenerator: options.dayHeaderClassNames,
                    didMount: options.dayHeaderDidMount,
                    willUnmount: options.dayHeaderWillUnmount
                }, function(InnerContent) {
                    return (0, $kG1qx.createElement)("div", {
                        className: "fc-scrollgrid-sync-inner"
                    }, (0, $kG1qx.createElement)(InnerContent, {
                        elTag: "a",
                        elClasses: [
                            'fc-col-header-cell-cushion',
                            props.isSticky && 'fc-sticky'
                        ],
                        elAttrs: {
                            'aria-label': dateEnv.format(date, $33ab27ec71b00902$var$WEEKDAY_FORMAT)
                        }
                    }));
                });
            }
        }
    ]);
    return TableDowCell;
}($33ab27ec71b00902$export$ef35774e6d314e91);
var $33ab27ec71b00902$export$27d1aff6bea49709 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(DayHeader, BaseComponent);
    function DayHeader() {
        (0, $8MSeJ._)(this, DayHeader);
        var _this;
        _this = (0, $4v96Q._)(this, DayHeader, arguments);
        _this.createDayHeaderFormatter = $33ab27ec71b00902$export$df995fae86a55f06($33ab27ec71b00902$var$createDayHeaderFormatter);
        return _this;
    }
    (0, $gia3M._)(DayHeader, [
        {
            key: "render",
            value: function render() {
                var context = this.context;
                var _this_props = this.props, dates = _this_props.dates, dateProfile = _this_props.dateProfile, datesRepDistinctDays = _this_props.datesRepDistinctDays, renderIntro = _this_props.renderIntro;
                var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$2e2af4578d910ddf, {
                    unit: "day"
                }, function(nowDate, todayRange) {
                    return (0, $kG1qx.createElement)("tr", {
                        role: "row"
                    }, renderIntro && renderIntro('day'), dates.map(function(date) {
                        return datesRepDistinctDays ? (0, $kG1qx.createElement)($33ab27ec71b00902$export$ebc5e65867841cbe, {
                            key: date.toISOString(),
                            date: date,
                            dateProfile: dateProfile,
                            todayRange: todayRange,
                            colCnt: dates.length,
                            dayHeaderFormat: dayHeaderFormat
                        }) : (0, $kG1qx.createElement)($33ab27ec71b00902$export$1ddf2d01943a3512, {
                            key: date.getUTCDay(),
                            dow: date.getUTCDay(),
                            dayHeaderFormat: dayHeaderFormat
                        });
                    }));
                });
            }
        }
    ]);
    return DayHeader;
}($33ab27ec71b00902$export$ef35774e6d314e91);
function $33ab27ec71b00902$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $33ab27ec71b00902$export$1abb261478089fe6(datesRepDistinctDays, dateCnt);
}
var $33ab27ec71b00902$export$ebb8f7cd71856fb9 = /*#__PURE__*/ function() {
    "use strict";
    function DaySeriesModel(range, dateProfileGenerator) {
        (0, $8MSeJ._)(this, DaySeriesModel);
        var date = range.start;
        var end = range.end;
        var indices = [];
        var dates = [];
        var dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $33ab27ec71b00902$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    (0, $gia3M._)(DaySeriesModel, [
        {
            key: "sliceRange",
            value: function sliceRange(range) {
                var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
                var lastIndex = this.getDateDayIndex($33ab27ec71b00902$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
                var clippedFirstIndex = Math.max(0, firstIndex);
                var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
                // deal with in-between indices
                clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
                clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
                if (clippedFirstIndex <= clippedLastIndex) return {
                    firstIndex: clippedFirstIndex,
                    lastIndex: clippedLastIndex,
                    isStart: firstIndex === clippedFirstIndex,
                    isEnd: lastIndex === clippedLastIndex
                };
                return null;
            }
        },
        {
            // Given a date, returns its chronolocial cell-index from the first cell of the grid.
            // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
            // If before the first offset, returns a negative number.
            // If after the last offset, returns an offset past the last cell offset.
            // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
            key: "getDateDayIndex",
            value: function getDateDayIndex(date) {
                var indices = this.indices;
                var dayOffset = Math.floor($33ab27ec71b00902$export$b4d5ecaefe2b27f3(this.dates[0], date));
                if (dayOffset < 0) return indices[0] - 1;
                if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
                return indices[dayOffset];
            }
        }
    ]);
    return DaySeriesModel;
}();
var $33ab27ec71b00902$export$1314441b8d04e1d5 = /*#__PURE__*/ function() {
    "use strict";
    function DayTableModel(daySeries, breakOnWeeks) {
        (0, $8MSeJ._)(this, DayTableModel);
        var dates = daySeries.dates;
        var daysPerRow;
        var firstDay;
        var rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    (0, $gia3M._)(DayTableModel, [
        {
            key: "buildCells",
            value: function buildCells() {
                var rows = [];
                for(var row = 0; row < this.rowCnt; row += 1){
                    var cells = [];
                    for(var col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
                    rows.push(cells);
                }
                return rows;
            }
        },
        {
            key: "buildCell",
            value: function buildCell(row, col) {
                var date = this.daySeries.dates[row * this.colCnt + col];
                return {
                    key: date.toISOString(),
                    date: date
                };
            }
        },
        {
            key: "buildHeaderDates",
            value: function buildHeaderDates() {
                var dates = [];
                for(var col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
                return dates;
            }
        },
        {
            key: "sliceRange",
            value: function sliceRange(range) {
                var colCnt = this.colCnt;
                var seriesSeg = this.daySeries.sliceRange(range);
                var segs = [];
                if (seriesSeg) {
                    var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
                    var index = firstIndex;
                    while(index <= lastIndex){
                        var row = Math.floor(index / colCnt);
                        var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                        segs.push({
                            row: row,
                            firstCol: index % colCnt,
                            lastCol: (nextIndex - 1) % colCnt,
                            isStart: seriesSeg.isStart && index === firstIndex,
                            isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                        });
                        index = nextIndex;
                    }
                }
                return segs;
            }
        }
    ]);
    return DayTableModel;
}();
var $33ab27ec71b00902$export$e0c3a065614c6254 = /*#__PURE__*/ function() {
    "use strict";
    function Slicer() {
        (0, $8MSeJ._)(this, Slicer);
        this.sliceBusinessHours = $33ab27ec71b00902$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $33ab27ec71b00902$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $33ab27ec71b00902$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $33ab27ec71b00902$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $33ab27ec71b00902$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    (0, $gia3M._)(Slicer, [
        {
            key: "sliceProps",
            value: function sliceProps(props, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                var eventUiBases = props.eventUiBases;
                var eventSegs = this.sliceEventStore.apply(this, [
                    props.eventStore,
                    eventUiBases,
                    dateProfile,
                    nextDayThreshold
                ].concat((0, $hvZMf._)(extraArgs)));
                return {
                    dateSelectionSegs: this.sliceDateSelection.apply(this, [
                        props.dateSelection,
                        dateProfile,
                        nextDayThreshold,
                        eventUiBases,
                        context
                    ].concat((0, $hvZMf._)(extraArgs))),
                    businessHourSegs: this.sliceBusinessHours.apply(this, [
                        props.businessHours,
                        dateProfile,
                        nextDayThreshold,
                        context
                    ].concat((0, $hvZMf._)(extraArgs))),
                    fgEventSegs: eventSegs.fg,
                    bgEventSegs: eventSegs.bg,
                    eventDrag: this.sliceEventDrag.apply(this, [
                        props.eventDrag,
                        eventUiBases,
                        dateProfile,
                        nextDayThreshold
                    ].concat((0, $hvZMf._)(extraArgs))),
                    eventResize: this.sliceEventResize.apply(this, [
                        props.eventResize,
                        eventUiBases,
                        dateProfile,
                        nextDayThreshold
                    ].concat((0, $hvZMf._)(extraArgs))),
                    eventSelection: props.eventSelection
                }; // TODO: give interactionSegs?
            }
        },
        {
            key: "sliceNowDate",
            value: function sliceNowDate(date, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                return this._sliceDateSpan.apply(this, [
                    {
                        range: {
                            start: date,
                            end: $33ab27ec71b00902$export$51b138e5a065c2bb(date, 1)
                        },
                        allDay: false
                    },
                    dateProfile,
                    nextDayThreshold,
                    {},
                    context
                ].concat((0, $hvZMf._)(extraArgs)));
            }
        },
        {
            key: "_sliceBusinessHours",
            value: function _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (!businessHours) return [];
                return this._sliceEventStore.apply(this, [
                    $33ab27ec71b00902$var$expandRecurring(businessHours, $33ab27ec71b00902$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
                    {},
                    dateProfile,
                    nextDayThreshold
                ].concat((0, $hvZMf._)(extraArgs))).bg;
            }
        },
        {
            key: "_sliceEventStore",
            value: function _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (eventStore) {
                    var rangeRes = $33ab27ec71b00902$export$4c3d22f3d993c33f(eventStore, eventUiBases, $33ab27ec71b00902$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                    return {
                        bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                        fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
                    };
                }
                return {
                    bg: [],
                    fg: []
                };
            }
        },
        {
            key: "_sliceInteraction",
            value: function _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
                    extraArgs[_key - 4] = arguments[_key];
                }
                if (!interaction) return null;
                var rangeRes = $33ab27ec71b00902$export$4c3d22f3d993c33f(interaction.mutatedEvents, eventUiBases, $33ab27ec71b00902$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
                return {
                    segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
                    affectedInstances: interaction.affectedEvents.instances,
                    isEvent: interaction.isEvent
                };
            }
        },
        {
            key: "_sliceDateSpan",
            value: function _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context) {
                for(var _len = arguments.length, extraArgs = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++){
                    extraArgs[_key - 5] = arguments[_key];
                }
                if (!dateSpan) return [];
                var activeRange = $33ab27ec71b00902$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
                var activeDateSpanRange = $33ab27ec71b00902$export$ae1af26003f05816(dateSpan.range, activeRange);
                if (activeDateSpanRange) {
                    dateSpan = Object.assign(Object.assign({}, dateSpan), {
                        range: activeDateSpanRange
                    });
                    var eventRange = $33ab27ec71b00902$var$fabricateEventRange(dateSpan, eventUiBases, context);
                    var segs = this.sliceRange.apply(this, [
                        dateSpan.range
                    ].concat((0, $hvZMf._)(extraArgs)));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var seg = _step.value;
                            seg.eventRange = eventRange;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return segs;
                }
                return [];
            }
        },
        {
            /*
    "complete" seg means it has component and eventRange
    */ key: "sliceEventRanges",
            value: function sliceEventRanges(eventRanges, extraArgs) {
                var _segs;
                var segs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = eventRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventRange = _step.value;
                        (_segs = segs).push.apply(_segs, (0, $hvZMf._)(this.sliceEventRange(eventRange, extraArgs)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        },
        {
            /*
    "complete" seg means it has component and eventRange
    */ key: "sliceEventRange",
            value: function sliceEventRange(eventRange, extraArgs) {
                var dateRange = eventRange.range;
                // hack to make multi-day events that are being force-displayed as list-items to take up only one day
                if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
                    start: dateRange.start,
                    end: $33ab27ec71b00902$export$625550452a3fa3ec(dateRange.start, 1)
                };
                var segs = this.sliceRange.apply(this, [
                    dateRange
                ].concat((0, $hvZMf._)(extraArgs)));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var seg = _step.value;
                        seg.eventRange = eventRange;
                        seg.isStart = eventRange.isStart && seg.isStart;
                        seg.isEnd = eventRange.isEnd && seg.isEnd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return segs;
            }
        }
    ]);
    return Slicer;
}();
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $33ab27ec71b00902$var$computeActiveRange(dateProfile, isComponentAllDay) {
    var range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $33ab27ec71b00902$export$51b138e5a065c2bb(range.start, dateProfile.slotMinTime.milliseconds),
        end: $33ab27ec71b00902$export$51b138e5a065c2bb(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$export$6d1e945284085e64(interaction, dateProfile, context) {
    var instances = interaction.mutatedEvents.instances;
    for(var instanceId in instances){
        if (!$33ab27ec71b00902$export$f074adc9fbd50943(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $33ab27ec71b00902$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $33ab27ec71b00902$export$545a72cc0d3f00b0(dateSelection, dateProfile, context) {
    if (!$33ab27ec71b00902$export$f074adc9fbd50943(dateProfile.validRange, dateSelection.range)) return false;
    return $33ab27ec71b00902$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $33ab27ec71b00902$var$isNewPropsValid(newProps, context) {
    var calendarState = context.getCurrentData();
    var props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: '',
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: '',
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $33ab27ec71b00902$export$6b179bb11f7fd3a0)(props, context);
}
function $33ab27ec71b00902$export$6b179bb11f7fd3a0(state, context) {
    var dateSpanMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, filterConfig = arguments.length > 3 ? arguments[3] : void 0;
    if (state.eventDrag && !$33ab27ec71b00902$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$33ab27ec71b00902$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var currentState = context.getCurrentData();
    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    var subjectEventStore = interaction.mutatedEvents;
    var subjectDefs = subjectEventStore.defs;
    var subjectInstances = subjectEventStore.instances;
    var subjectConfigs = $33ab27ec71b00902$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        '': currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $33ab27ec71b00902$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    var otherEventStore = $33ab27ec71b00902$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    var otherDefs = otherEventStore.defs;
    var otherInstances = otherEventStore.instances;
    var otherConfigs = $33ab27ec71b00902$var$compileEventUis(otherDefs, state.eventUiBases);
    for(var subjectInstanceId in subjectInstances){
        var subjectInstance = subjectInstances[subjectInstanceId];
        var subjectRange = subjectInstance.range;
        var subjectConfig = subjectConfigs[subjectInstance.defId];
        var subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$33ab27ec71b00902$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        var eventOverlap = context.options.eventOverlap;
        var eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for(var otherInstanceId in otherInstances){
            var otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($33ab27ec71b00902$export$c18d01048907ea92(subjectRange, otherInstance.range)) {
                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $33ab27ec71b00902$export$71511d61b312f219(context, otherDefs[otherInstance.defId], otherInstance), new $33ab27ec71b00902$export$71511d61b312f219(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = subjectConfig.allows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var subjectAllow = _step.value;
                var subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                    range: subjectInstance.range,
                    allDay: subjectDef.allDay
                });
                var origDef = calendarEventStore.defs[subjectDef.defId];
                var origInstance = calendarEventStore.instances[subjectInstanceId];
                var eventApi = void 0;
                if (origDef) eventApi = new $33ab27ec71b00902$export$71511d61b312f219(context, origDef, origInstance);
                else eventApi = new $33ab27ec71b00902$export$71511d61b312f219(context, subjectDef); // no instance, because had no dates
                if (!subjectAllow($33ab27ec71b00902$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var relevantEventStore = state.eventStore;
    var relevantDefs = relevantEventStore.defs;
    var relevantInstances = relevantEventStore.instances;
    var selection = state.dateSelection;
    var selectionRange = selection.range;
    var selectionConfig = context.getCurrentData().selectionConfig;
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$33ab27ec71b00902$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    var selectOverlap = context.options.selectOverlap;
    var selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for(var relevantInstanceId in relevantInstances){
        var relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($33ab27ec71b00902$export$c18d01048907ea92(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $33ab27ec71b00902$export$71511d61b312f219(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // allow (a function)
        for(var _iterator = selectionConfig.allows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selectionAllow = _step.value;
            var fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
            if (!selectionAllow($33ab27ec71b00902$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $33ab27ec71b00902$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = constraints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var constraint = _step.value;
            if (!$33ab27ec71b00902$var$anyRangesContainRange($33ab27ec71b00902$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $33ab27ec71b00902$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === 'businessHours') return $33ab27ec71b00902$var$eventStoreToRanges($33ab27ec71b00902$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === 'string') return $33ab27ec71b00902$var$eventStoreToRanges($33ab27ec71b00902$var$filterEventStoreDefs(otherEventStore, function(eventDef) {
        return eventDef.groupId === constraint;
    }));
    if ((typeof constraint === "undefined" ? "undefined" : (0, $1PKUs._)(constraint)) === 'object' && constraint) return $33ab27ec71b00902$var$eventStoreToRanges($33ab27ec71b00902$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $33ab27ec71b00902$var$eventStoreToRanges(eventStore) {
    var instances = eventStore.instances;
    var ranges = [];
    for(var instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $33ab27ec71b00902$var$anyRangesContainRange(outerRanges, innerRange) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = outerRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var outerRange = _step.value;
            if ($33ab27ec71b00902$export$f074adc9fbd50943(outerRange, innerRange)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var $33ab27ec71b00902$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
var $33ab27ec71b00902$export$54c4fabc2291e9c0 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(Scroller, BaseComponent);
    function Scroller() {
        (0, $8MSeJ._)(this, Scroller);
        var _this;
        _this = (0, $4v96Q._)(this, Scroller, arguments);
        _this.handleEl = function(el) {
            _this.el = el;
            $33ab27ec71b00902$export$71cec2538cb2c617(_this.props.elRef, el);
        };
        return _this;
    }
    (0, $gia3M._)(Scroller, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
                var isAbsolute = liquid && liquidIsAbsolute;
                var className = [
                    'fc-scroller'
                ];
                if (liquid) {
                    if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
                    else className.push('fc-scroller-liquid');
                }
                return (0, $kG1qx.createElement)("div", {
                    ref: this.handleEl,
                    className: className.join(' '),
                    style: {
                        overflowX: props.overflowX,
                        overflowY: props.overflowY,
                        left: isAbsolute && -(props.overcomeLeft || 0) || '',
                        right: isAbsolute && -(props.overcomeRight || 0) || '',
                        bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                        marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                        marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                        marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                        maxHeight: props.maxHeight || ''
                    }
                }, props.children);
            }
        },
        {
            key: "needsXScrolling",
            value: function needsXScrolling() {
                if ($33ab27ec71b00902$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
                // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
                // much more reliable to see if children are taller than the scroller, even tho doesn't account for
                // inner-child margins and absolute positioning
                var el = this.el;
                var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
                var children = el.children;
                for(var i = 0; i < children.length; i += 1){
                    var childEl = children[i];
                    if (childEl.getBoundingClientRect().width > realClientWidth) return true;
                }
                return false;
            }
        },
        {
            key: "needsYScrolling",
            value: function needsYScrolling() {
                if ($33ab27ec71b00902$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
                // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
                // much more reliable to see if children are taller than the scroller, even tho doesn't account for
                // inner-child margins and absolute positioning
                var el = this.el;
                var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
                var children = el.children;
                for(var i = 0; i < children.length; i += 1){
                    var childEl = children[i];
                    if (childEl.getBoundingClientRect().height > realClientHeight) return true;
                }
                return false;
            }
        },
        {
            key: "getXScrollbarWidth",
            value: function getXScrollbarWidth() {
                if ($33ab27ec71b00902$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
                return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
            }
        },
        {
            key: "getYScrollbarWidth",
            value: function getYScrollbarWidth() {
                if ($33ab27ec71b00902$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
                return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
            }
        }
    ]);
    return Scroller;
}($33ab27ec71b00902$export$ef35774e6d314e91);
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ var $33ab27ec71b00902$export$807f1ba34db587c7 = /*#__PURE__*/ function() {
    "use strict";
    function RefMap(masterCallback) {
        var _this = this;
        (0, $8MSeJ._)(this, RefMap);
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = function(val, key) {
            var depths = _this.depths, currentMap = _this.currentMap;
            var removed = false;
            var added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete _this.callbackMap[key];
                    removed = true;
                }
            }
            if (_this.masterCallback) {
                if (removed) _this.masterCallback(null, String(key));
                if (added) _this.masterCallback(val, String(key));
            }
        };
    }
    (0, $gia3M._)(RefMap, [
        {
            key: "createRef",
            value: function createRef(key) {
                var _this = this;
                var refCallback = this.callbackMap[key];
                if (!refCallback) refCallback = this.callbackMap[key] = function(val) {
                    _this.handleValue(val, String(key));
                };
                return refCallback;
            }
        },
        {
            // TODO: check callers that don't care about order. should use getAll instead
            // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
            // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
            key: "collect",
            value: function collect(startIndex, endIndex, step) {
                return $33ab27ec71b00902$export$a05254e7c3aeba6e(this.currentMap, startIndex, endIndex, step);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return $33ab27ec71b00902$export$90a7f3efeed30595(this.currentMap);
            }
        }
    ]);
    return RefMap;
}();
function $33ab27ec71b00902$export$7fe88b5920ffddd2(chunkEls) {
    var shrinkCells = $33ab27ec71b00902$export$23ebac1979863676(chunkEls, '.fc-scrollgrid-shrink');
    var largestWidth = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = shrinkCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var shrinkCell = _step.value;
            largestWidth = Math.max(largestWidth, $33ab27ec71b00902$var$computeSmallestCellWidth(shrinkCell));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $33ab27ec71b00902$export$60e660859c376841(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $33ab27ec71b00902$export$df838d0240c938cf(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $33ab27ec71b00902$export$60e660859c376841(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $33ab27ec71b00902$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, arg, isHeader) {
    var expandRows = arg.expandRows;
    var content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, $kG1qx.createElement)('table', {
        role: 'presentation',
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
        ].join(' '),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ''
        }
    }, arg.tableColGroupNode, (0, $kG1qx.createElement)(isHeader ? 'thead' : 'tbody', {
        role: 'presentation'
    }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $33ab27ec71b00902$export$f5339a28e56d1baf(cols0, cols1) {
    return $33ab27ec71b00902$export$23f2a1d2818174ef(cols0, cols1, $33ab27ec71b00902$export$a9c23c6ac3fc3eca);
}
function $33ab27ec71b00902$export$add49c223b9ce4ea(cols, shrinkWidth) {
    var colNodes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for(var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var colProps = _step.value;
            var span = colProps.span || 1;
            for(var i = 0; i < span; i += 1)colNodes.push((0, $kG1qx.createElement)("col", {
                style: {
                    width: colProps.width === 'shrink' ? $33ab27ec71b00902$export$df7c425476ed4f2(shrinkWidth) : colProps.width || '',
                    minWidth: colProps.minWidth || ''
                }
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $kG1qx.createElement).apply(void 0, [
        'colgroup',
        {}
    ].concat((0, $hvZMf._)(colNodes)));
}
function $33ab27ec71b00902$export$df7c425476ed4f2(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $33ab27ec71b00902$export$c69d65aa55814164(cols) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var col = _step.value;
            if (col.width === 'shrink') return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $33ab27ec71b00902$export$65ab0ebced932b79(liquid, context) {
    var classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table')
    ];
    if (liquid) classNames.push('fc-scrollgrid-liquid');
    return classNames;
}
function $33ab27ec71b00902$export$101619b11a34a0bd(sectionConfig, wholeTableVGrow) {
    var classNames = [
        'fc-scrollgrid-section',
        "fc-scrollgrid-section-".concat(sectionConfig.type),
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
    if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
    return classNames;
}
function $33ab27ec71b00902$export$1ec7a8278ebd1290(arg) {
    return (0, $kG1qx.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $33ab27ec71b00902$export$89e9012e902952b6(options) {
    var stickyHeaderDates = options.stickyHeaderDates;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyHeaderDates;
}
function $33ab27ec71b00902$export$4ad369a19af21c23(options) {
    var stickyFooterScrollbar = options.stickyFooterScrollbar;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyFooterScrollbar;
}
var $33ab27ec71b00902$export$c667925124dac624 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(SimpleScrollGrid, BaseComponent);
    function SimpleScrollGrid() {
        (0, $8MSeJ._)(this, SimpleScrollGrid);
        var _this;
        _this = (0, $4v96Q._)(this, SimpleScrollGrid, arguments);
        _this.processCols = $33ab27ec71b00902$export$df995fae86a55f06(function(a) {
            return a;
        }, $33ab27ec71b00902$export$f5339a28e56d1baf); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        _this.renderMicroColGroup = $33ab27ec71b00902$export$df995fae86a55f06($33ab27ec71b00902$export$add49c223b9ce4ea);
        _this.scrollerRefs = new $33ab27ec71b00902$export$807f1ba34db587c7();
        _this.scrollerElRefs = new $33ab27ec71b00902$export$807f1ba34db587c7(_this._handleScrollerEl.bind(_this));
        _this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        _this.handleSizing = function() {
            _this.safeSetState(Object.assign({
                shrinkWidth: _this.computeShrinkWidth()
            }, _this.computeScrollerDims()));
        };
        return _this;
    }
    (0, $gia3M._)(SimpleScrollGrid, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state, context = _this.context;
                var sectionConfigs = props.sections || [];
                var cols = this.processCols(props.cols);
                var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
                var classNames = $33ab27ec71b00902$export$65ab0ebced932b79(props.liquid, context);
                if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
                // TODO: make DRY
                var configCnt = sectionConfigs.length;
                var configI = 0;
                var currentConfig;
                var headSectionNodes = [];
                var bodySectionNodes = [];
                var footSectionNodes = [];
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
                    headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                    configI += 1;
                }
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
                    bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
                    configI += 1;
                }
                while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
                    footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
                    configI += 1;
                }
                // firefox bug: when setting height on table and there is a thead or tfoot,
                // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
                // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
                // if so, use a simpler dom structure, jam everything into a lone tbody.
                var isBuggy = !$33ab27ec71b00902$export$738ab4df8bf92ae9();
                var roleAttrs = {
                    role: 'rowgroup'
                };
                return (0, $kG1qx.createElement)('table', {
                    role: 'grid',
                    className: classNames.join(' '),
                    style: {
                        height: props.height
                    }
                }, Boolean(!isBuggy && headSectionNodes.length) && (0, $kG1qx.createElement).apply(void 0, [
                    'thead',
                    roleAttrs
                ].concat((0, $hvZMf._)(headSectionNodes))), Boolean(!isBuggy && bodySectionNodes.length) && (0, $kG1qx.createElement).apply(void 0, [
                    'tbody',
                    roleAttrs
                ].concat((0, $hvZMf._)(bodySectionNodes))), Boolean(!isBuggy && footSectionNodes.length) && (0, $kG1qx.createElement).apply(void 0, [
                    'tfoot',
                    roleAttrs
                ].concat((0, $hvZMf._)(footSectionNodes))), isBuggy && (0, $kG1qx.createElement).apply(void 0, [
                    'tbody',
                    roleAttrs
                ].concat((0, $hvZMf._)(headSectionNodes), (0, $hvZMf._)(bodySectionNodes), (0, $hvZMf._)(footSectionNodes))));
            }
        },
        {
            key: "renderSection",
            value: function renderSection(sectionConfig, microColGroupNode, isHeader) {
                if ('outerContent' in sectionConfig) return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), {
                    key: sectionConfig.key
                }, sectionConfig.outerContent);
                return (0, $kG1qx.createElement)("tr", {
                    key: sectionConfig.key,
                    role: "presentation",
                    className: $33ab27ec71b00902$export$101619b11a34a0bd(sectionConfig, this.props.liquid).join(' ')
                }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
            }
        },
        {
            key: "renderChunkTd",
            value: function renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
                if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
                var props = this.props;
                var _this_state = this.state, forceYScrollbars = _this_state.forceYScrollbars, scrollerClientWidths = _this_state.scrollerClientWidths, scrollerClientHeights = _this_state.scrollerClientHeights;
                var needsYScrolling = $33ab27ec71b00902$export$df838d0240c938cf(props, sectionConfig); // TODO: do lazily. do in section config?
                var isLiquid = $33ab27ec71b00902$export$60e660859c376841(props, sectionConfig);
                // for `!props.liquid` - is WHOLE scrollgrid natural height?
                // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
                var overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
                var sectionKey = sectionConfig.key;
                var content = $33ab27ec71b00902$export$4f33f238a5c1ad77(sectionConfig, chunkConfig, {
                    tableColGroupNode: microColGroupNode,
                    tableMinWidth: '',
                    clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
                    clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
                    expandRows: sectionConfig.expandRows,
                    syncRowHeights: false,
                    rowSyncHeights: [],
                    reportRowHeightChange: function() {}
                }, isHeader);
                return (0, $kG1qx.createElement)(isHeader ? 'th' : 'td', {
                    ref: chunkConfig.elRef,
                    role: 'presentation'
                }, (0, $kG1qx.createElement)("div", {
                    className: "fc-scroller-harness".concat(isLiquid ? ' fc-scroller-harness-liquid' : '')
                }, (0, $kG1qx.createElement)($33ab27ec71b00902$export$54c4fabc2291e9c0, {
                    ref: this.scrollerRefs.createRef(sectionKey),
                    elRef: this.scrollerElRefs.createRef(sectionKey),
                    overflowY: overflowY,
                    overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */ ,
                    maxHeight: sectionConfig.maxHeight,
                    liquid: isLiquid,
                    liquidIsAbsolute: true
                }, content)));
            }
        },
        {
            key: "_handleScrollerEl",
            value: function _handleScrollerEl(scrollerEl, key) {
                var section = $33ab27ec71b00902$var$getSectionByKey(this.props.sections, key);
                if (section) $33ab27ec71b00902$export$71cec2538cb2c617(section.chunk.scrollerElRef, scrollerEl);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.handleSizing();
                this.context.addResizeHandler(this.handleSizing);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                // TODO: need better solution when state contains non-sizing things
                this.handleSizing();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleSizing);
            }
        },
        {
            key: "computeShrinkWidth",
            value: function computeShrinkWidth1() {
                return $33ab27ec71b00902$export$c69d65aa55814164(this.props.cols) ? $33ab27ec71b00902$export$7fe88b5920ffddd2(this.scrollerElRefs.getAll()) : 0;
            }
        },
        {
            key: "computeScrollerDims",
            value: function computeScrollerDims() {
                var scrollbarWidth = $33ab27ec71b00902$export$a1edd97dd51cd48d();
                var _this = this, scrollerRefs = _this.scrollerRefs, scrollerElRefs = _this.scrollerElRefs;
                var forceYScrollbars = false;
                var scrollerClientWidths = {};
                var scrollerClientHeights = {};
                for(var sectionKey in scrollerRefs.currentMap){
                    var scroller = scrollerRefs.currentMap[sectionKey];
                    if (scroller && scroller.needsYScrolling()) {
                        forceYScrollbars = true;
                        break;
                    }
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.props.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        var sectionKey1 = section.key;
                        var scrollerEl = scrollerElRefs.currentMap[sectionKey1];
                        if (scrollerEl) {
                            var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                            scrollerClientWidths[sectionKey1] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                             : 0));
                            scrollerClientHeights[sectionKey1] = Math.floor(harnessEl.getBoundingClientRect().height);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    forceYScrollbars: forceYScrollbars,
                    scrollerClientWidths: scrollerClientWidths,
                    scrollerClientHeights: scrollerClientHeights
                };
            }
        }
    ]);
    return SimpleScrollGrid;
}($33ab27ec71b00902$export$ef35774e6d314e91);
$33ab27ec71b00902$export$c667925124dac624.addStateEquality({
    scrollerClientWidths: $33ab27ec71b00902$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $33ab27ec71b00902$export$a9c23c6ac3fc3eca
});
function $33ab27ec71b00902$var$getSectionByKey(sections, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var section = _step.value;
            if (section.key === key) return section;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var $33ab27ec71b00902$export$c1df809846363ebe = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(EventContainer, BaseComponent);
    function EventContainer() {
        (0, $8MSeJ._)(this, EventContainer);
        var _this;
        _this = (0, $4v96Q._)(this, EventContainer, arguments);
        // memo
        _this.buildPublicEvent = $33ab27ec71b00902$export$df995fae86a55f06(function(context, eventDef, eventInstance) {
            return new $33ab27ec71b00902$export$71511d61b312f219(context, eventDef, eventInstance);
        });
        _this.handleEl = function(el) {
            _this.el = el;
            $33ab27ec71b00902$export$71cec2538cb2c617(_this.props.elRef, el);
            if (el) $33ab27ec71b00902$var$setElSeg(el, _this.props.seg);
        };
        return _this;
    }
    (0, $gia3M._)(EventContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var eventRange = seg.eventRange;
                var ui = eventRange.ui;
                var renderProps = {
                    event: this.buildPublicEvent(context, eventRange.def, eventRange.instance),
                    view: context.viewApi,
                    timeText: props.timeText,
                    textColor: ui.textColor,
                    backgroundColor: ui.backgroundColor,
                    borderColor: ui.borderColor,
                    isDraggable: !props.disableDragging && $33ab27ec71b00902$var$computeSegDraggable(seg, context),
                    isStartResizable: !props.disableResizing && $33ab27ec71b00902$var$computeSegStartResizable(seg, context),
                    isEndResizable: !props.disableResizing && $33ab27ec71b00902$var$computeSegEndResizable(seg),
                    isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
                    isStart: Boolean(seg.isStart),
                    isEnd: Boolean(seg.isEnd),
                    isPast: Boolean(props.isPast),
                    isFuture: Boolean(props.isFuture),
                    isToday: Boolean(props.isToday),
                    isSelected: Boolean(props.isSelected),
                    isDragging: Boolean(props.isDragging),
                    isResizing: Boolean(props.isResizing)
                };
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
                    elRef: this.handleEl,
                    elTag: props.elTag,
                    elAttrs: props.elAttrs,
                    elClasses: (0, $hvZMf._)($33ab27ec71b00902$var$getEventClassNames(renderProps)).concat((0, $hvZMf._)(seg.eventRange.ui.classNames), (0, $hvZMf._)(props.elClasses || [])),
                    elStyle: props.elStyle,
                    renderProps: renderProps,
                    generatorName: "eventContent",
                    customGenerator: options.eventContent,
                    defaultGenerator: props.defaultGenerator,
                    classNameGenerator: options.eventClassNames,
                    didMount: options.eventDidMount,
                    willUnmount: options.eventWillUnmount
                }, props.children);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.el && this.props.seg !== prevProps.seg) $33ab27ec71b00902$var$setElSeg(this.el, this.props.seg);
            }
        }
    ]);
    return EventContainer;
}($33ab27ec71b00902$export$ef35774e6d314e91);
// should not be a purecomponent
var $33ab27ec71b00902$export$6735ce526161c7bd = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(StandardEvent, BaseComponent);
    function StandardEvent() {
        (0, $8MSeJ._)(this, StandardEvent);
        return (0, $4v96Q._)(this, StandardEvent, arguments);
    }
    (0, $gia3M._)(StandardEvent, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var seg = props.seg;
                var ui = seg.eventRange.ui;
                var timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
                var timeText = $33ab27ec71b00902$export$2538633961795d6b(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$c1df809846363ebe, Object.assign({}, props /* includes elRef */ , {
                    elTag: "a",
                    elStyle: {
                        borderColor: ui.borderColor,
                        backgroundColor: ui.backgroundColor
                    },
                    elAttrs: $33ab27ec71b00902$export$6dabbe08653f866f(seg, context),
                    defaultGenerator: $33ab27ec71b00902$var$renderInnerContent$1,
                    timeText: timeText
                }), function(InnerContent, eventContentArg) {
                    return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, (0, $kG1qx.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            'fc-event-main'
                        ],
                        elStyle: {
                            color: eventContentArg.textColor
                        }
                    }), Boolean(eventContentArg.isStartResizable) && (0, $kG1qx.createElement)("div", {
                        className: "fc-event-resizer fc-event-resizer-start"
                    }), Boolean(eventContentArg.isEndResizable) && (0, $kG1qx.createElement)("div", {
                        className: "fc-event-resizer fc-event-resizer-end"
                    }));
                });
            }
        }
    ]);
    return StandardEvent;
}($33ab27ec71b00902$export$ef35774e6d314e91);
$33ab27ec71b00902$export$6735ce526161c7bd.addPropsEquality({
    seg: $33ab27ec71b00902$export$a9c23c6ac3fc3eca
});
function $33ab27ec71b00902$var$renderInnerContent$1(innerProps) {
    return (0, $kG1qx.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $kG1qx.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $kG1qx.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, $kG1qx.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, "\u00A0"))));
}
var $33ab27ec71b00902$export$6e4b1d19c6e2e012 = function(props) {
    return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7c866399fa523f5.Consumer, null, function(context) {
        var options = context.options;
        var renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
};
var $33ab27ec71b00902$var$DAY_NUM_FORMAT = $33ab27ec71b00902$export$d141bba7fdc215a3({
    day: 'numeric'
});
var $33ab27ec71b00902$export$c5d7c1ac98841e53 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(DayCellContainer, BaseComponent);
    function DayCellContainer() {
        (0, $8MSeJ._)(this, DayCellContainer);
        var _this;
        _this = (0, $4v96Q._)(this, DayCellContainer, arguments);
        _this.refineRenderProps = $33ab27ec71b00902$export$ebd11618f299a286($33ab27ec71b00902$var$refineRenderProps);
        return _this;
    }
    (0, $gia3M._)(DayCellContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, context = _this.context;
                var options = context.options;
                var renderProps = this.refineRenderProps({
                    date: props.date,
                    dateProfile: props.dateProfile,
                    todayRange: props.todayRange,
                    isMonthStart: props.isMonthStart || false,
                    showDayNumber: props.showDayNumber,
                    extraRenderProps: props.extraRenderProps,
                    viewApi: context.viewApi,
                    dateEnv: context.dateEnv,
                    monthStartFormat: options.monthStartFormat
                });
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
                    elRef: props.elRef,
                    elTag: props.elTag,
                    elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                        'data-date': $33ab27ec71b00902$export$56350196709588fc(props.date)
                    }),
                    elClasses: (0, $hvZMf._)($33ab27ec71b00902$export$1a8f5705751d8277(renderProps, context.theme)).concat((0, $hvZMf._)(props.elClasses || [])),
                    elStyle: props.elStyle,
                    renderProps: renderProps,
                    generatorName: "dayCellContent",
                    customGenerator: options.dayCellContent,
                    defaultGenerator: props.defaultGenerator,
                    classNameGenerator: // don't use custom classNames if disabled
                    renderProps.isDisabled ? undefined : options.dayCellClassNames,
                    didMount: options.dayCellDidMount,
                    willUnmount: options.dayCellWillUnmount
                }, props.children);
            }
        }
    ]);
    return DayCellContainer;
}($33ab27ec71b00902$export$ef35774e6d314e91);
function $33ab27ec71b00902$export$d92db8a7dc823bb0(options) {
    return Boolean(options.dayCellContent || $33ab27ec71b00902$var$hasCustomRenderingHandler('dayCellContent', options));
}
function $33ab27ec71b00902$var$refineRenderProps(raw) {
    var date = raw.date, dateEnv = raw.dateEnv, dateProfile = raw.dateProfile, isMonthStart = raw.isMonthStart;
    var dayMeta = $33ab27ec71b00902$export$e171bab687b50e0(date, raw.todayRange, null, dateProfile);
    var dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $33ab27ec71b00902$var$DAY_NUM_FORMAT) : '';
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
var $33ab27ec71b00902$export$b02498c06ddfef28 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(BgEvent, BaseComponent);
    function BgEvent() {
        (0, $8MSeJ._)(this, BgEvent);
        return (0, $4v96Q._)(this, BgEvent, arguments);
    }
    (0, $gia3M._)(BgEvent, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var seg = props.seg;
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$c1df809846363ebe, {
                    elTag: "div",
                    elClasses: [
                        'fc-bg-event'
                    ],
                    elStyle: {
                        backgroundColor: seg.eventRange.ui.backgroundColor
                    },
                    defaultGenerator: $33ab27ec71b00902$var$renderInnerContent,
                    seg: seg,
                    timeText: "",
                    isDragging: false,
                    isResizing: false,
                    isDateSelecting: false,
                    isSelected: false,
                    isPast: props.isPast,
                    isFuture: props.isFuture,
                    isToday: props.isToday,
                    disableDragging: true,
                    disableResizing: true
                });
            }
        }
    ]);
    return BgEvent;
}($33ab27ec71b00902$export$ef35774e6d314e91);
function $33ab27ec71b00902$var$renderInnerContent(props) {
    var title = props.event.title;
    return title && (0, $kG1qx.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $33ab27ec71b00902$export$b975d55abac2bbe3(fillType) {
    return (0, $kG1qx.createElement)("div", {
        className: "fc-".concat(fillType)
    });
}
var $33ab27ec71b00902$export$1343a74baacb0543 = function(props) {
    return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7c866399fa523f5.Consumer, null, function(context) {
        var dateEnv = context.dateEnv, options = context.options;
        var date = props.date;
        var format = options.weekNumberFormat || props.defaultFormat;
        var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        var text = dateEnv.format(date, format);
        var renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $33ab27ec71b00902$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
};
function $33ab27ec71b00902$var$renderInner(innerProps) {
    return innerProps.text;
}
var $33ab27ec71b00902$var$PADDING_FROM_VIEWPORT = 10;
var $33ab27ec71b00902$var$Popover = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(Popover, BaseComponent);
    function Popover() {
        (0, $8MSeJ._)(this, Popover);
        var _this;
        _this = (0, $4v96Q._)(this, Popover, arguments);
        _this.state = {
            titleId: $33ab27ec71b00902$export$6559d589eb85fbb6()
        };
        _this.handleRootEl = function(el) {
            _this.rootEl = el;
            if (_this.props.elRef) $33ab27ec71b00902$export$71cec2538cb2c617(_this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        _this.handleDocumentMouseDown = function(ev) {
            // only hide the popover if the click happened outside the popover
            var target = $33ab27ec71b00902$export$2ed0fc6709e59212(ev);
            if (!_this.rootEl.contains(target)) _this.handleCloseClick();
        };
        _this.handleDocumentKeyDown = function(ev) {
            if (ev.key === 'Escape') _this.handleCloseClick();
        };
        _this.handleCloseClick = function() {
            var onClose = _this.props.onClose;
            if (onClose) onClose();
        };
        return _this;
    }
    (0, $gia3M._)(Popover, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, theme = _this_context.theme, options = _this_context.options;
                var _this = this, props = _this.props, state = _this.state;
                var classNames = [
                    'fc-popover',
                    theme.getClass('popover')
                ].concat(props.extraClassNames || []);
                return (0, $8IBTv.createPortal)((0, $kG1qx.createElement)("div", Object.assign({}, props.extraAttrs, {
                    id: props.id,
                    className: classNames.join(' '),
                    "aria-labelledby": state.titleId,
                    ref: this.handleRootEl
                }), (0, $kG1qx.createElement)("div", {
                    className: 'fc-popover-header ' + theme.getClass('popoverHeader')
                }, (0, $kG1qx.createElement)("span", {
                    className: "fc-popover-title",
                    id: state.titleId
                }, props.title), (0, $kG1qx.createElement)("span", {
                    className: 'fc-popover-close ' + theme.getIconClass('close'),
                    title: options.closeHint,
                    onClick: this.handleCloseClick
                })), (0, $kG1qx.createElement)("div", {
                    className: 'fc-popover-body ' + theme.getClass('popoverContent')
                }, props.children)), props.parentEl);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('mousedown', this.handleDocumentMouseDown);
                document.addEventListener('keydown', this.handleDocumentKeyDown);
                this.updateSize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('mousedown', this.handleDocumentMouseDown);
                document.removeEventListener('keydown', this.handleDocumentKeyDown);
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                var isRtl = this.context.isRtl;
                var _this_props = this.props, alignmentEl = _this_props.alignmentEl, alignGridTop = _this_props.alignGridTop;
                var rootEl = this.rootEl;
                var alignmentRect = $33ab27ec71b00902$var$computeClippedClientRect(alignmentEl);
                if (alignmentRect) {
                    var popoverDims = rootEl.getBoundingClientRect();
                    // position relative to viewport
                    var popoverTop = alignGridTop ? $33ab27ec71b00902$export$dc98b0b04f4c7758(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
                    var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
                    // constrain
                    popoverTop = Math.max(popoverTop, $33ab27ec71b00902$var$PADDING_FROM_VIEWPORT);
                    popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $33ab27ec71b00902$var$PADDING_FROM_VIEWPORT - popoverDims.width);
                    popoverLeft = Math.max(popoverLeft, $33ab27ec71b00902$var$PADDING_FROM_VIEWPORT);
                    var origin = rootEl.offsetParent.getBoundingClientRect();
                    $33ab27ec71b00902$export$faec65b429be379(rootEl, {
                        top: popoverTop - origin.top,
                        left: popoverLeft - origin.left
                    });
                }
            }
        }
    ]);
    return Popover;
}($33ab27ec71b00902$export$ef35774e6d314e91);
var $33ab27ec71b00902$var$MorePopover = /*#__PURE__*/ function(DateComponent) {
    "use strict";
    (0, $9i7pb._)(MorePopover, DateComponent);
    function MorePopover() {
        (0, $8MSeJ._)(this, MorePopover);
        var _this;
        _this = (0, $4v96Q._)(this, MorePopover, arguments);
        _this.handleRootEl = function(rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) _this.context.registerInteractiveComponent(_this, {
                el: rootEl,
                useEventCenter: false
            });
            else _this.context.unregisterInteractiveComponent(_this);
        };
        return _this;
    }
    (0, $gia3M._)(MorePopover, [
        {
            key: "render",
            value: function render() {
                var _this_context = this.context, options = _this_context.options, dateEnv = _this_context.dateEnv;
                var props = this.props;
                var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
                var title = dateEnv.format(startDate, options.dayPopoverFormat);
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$c5d7c1ac98841e53, {
                    elRef: this.handleRootEl,
                    date: startDate,
                    dateProfile: dateProfile,
                    todayRange: todayRange
                }, function(InnerContent, renderProps, elAttrs) {
                    return (0, $kG1qx.createElement)($33ab27ec71b00902$var$Popover, {
                        elRef: elAttrs.ref,
                        id: props.id,
                        title: title,
                        extraClassNames: [
                            'fc-more-popover'
                        ].concat(elAttrs.className || []),
                        extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                        parentEl: props.parentEl,
                        alignmentEl: props.alignmentEl,
                        alignGridTop: props.alignGridTop,
                        onClose: props.onClose
                    }, $33ab27ec71b00902$export$d92db8a7dc823bb0(options) && (0, $kG1qx.createElement)(InnerContent, {
                        elTag: "div",
                        elClasses: [
                            'fc-more-popover-misc'
                        ]
                    }), props.children);
                });
            }
        },
        {
            key: "queryHit",
            value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
                var _this = this, rootEl = _this.rootEl, props = _this.props;
                if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
                    dateProfile: props.dateProfile,
                    dateSpan: Object.assign({
                        allDay: !props.forceTimed,
                        range: {
                            start: props.startDate,
                            end: props.endDate
                        }
                    }, props.extraDateSpan),
                    dayEl: rootEl,
                    rect: {
                        left: 0,
                        top: 0,
                        right: elWidth,
                        bottom: elHeight
                    },
                    layer: 1
                };
                return null;
            }
        }
    ]);
    return MorePopover;
}($33ab27ec71b00902$export$d22783b3c2400a3a);
var $33ab27ec71b00902$export$87b6ab1c2cb8b955 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(MoreLinkContainer, BaseComponent);
    function MoreLinkContainer() {
        (0, $8MSeJ._)(this, MoreLinkContainer);
        var _this;
        _this = (0, $4v96Q._)(this, MoreLinkContainer, arguments);
        _this.state = {
            isPopoverOpen: false,
            popoverId: $33ab27ec71b00902$export$6559d589eb85fbb6()
        };
        _this.handleLinkEl = function(linkEl) {
            _this.linkEl = linkEl;
            if (_this.props.elRef) $33ab27ec71b00902$export$71cec2538cb2c617(_this.props.elRef, linkEl);
        };
        _this.handleClick = function(ev) {
            var buildPublicSeg = function buildPublicSeg(seg) {
                var _seg_eventRange = seg.eventRange, def = _seg_eventRange.def, instance = _seg_eventRange.instance, range = _seg_eventRange.range;
                return {
                    event: new $33ab27ec71b00902$export$71511d61b312f219(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            };
            var props = _this.props, context = _this.context;
            var moreLinkClick = context.options.moreLinkClick;
            var date = $33ab27ec71b00902$var$computeRange(props).start;
            if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === 'popover') _this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
        };
        _this.handlePopoverClose = function() {
            _this.setState({
                isPopoverOpen: false
            });
        };
        return _this;
    }
    (0, $gia3M._)(MoreLinkContainer, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this1 = this, props = _this1.props, state = _this1.state;
                return (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7c866399fa523f5.Consumer, null, function(context) {
                    var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
                    var moreLinkText = options.moreLinkText;
                    var moreCnt = props.moreCnt;
                    var range = $33ab27ec71b00902$var$computeRange(props);
                    var text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
                     ? moreLinkText.call(calendarApi, moreCnt) : "+".concat(moreCnt, " ").concat(moreLinkText);
                    var hint = $33ab27ec71b00902$export$342063e11d6c3cad(options.moreLinkHint, [
                        moreCnt
                    ], text);
                    var renderProps = {
                        num: moreCnt,
                        shortText: "+".concat(moreCnt),
                        text: text,
                        view: viewApi
                    };
                    return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, Boolean(props.moreCnt) && (0, $kG1qx.createElement)($33ab27ec71b00902$export$e7094788287c5e9b, {
                        elTag: props.elTag || 'a',
                        elRef: _this.handleLinkEl,
                        elClasses: (0, $hvZMf._)(props.elClasses || []).concat([
                            'fc-more-link'
                        ]),
                        elStyle: props.elStyle,
                        elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $33ab27ec71b00902$var$createAriaClickAttrs(_this.handleClick)), {
                            title: hint,
                            'aria-expanded': state.isPopoverOpen,
                            'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                        }),
                        renderProps: renderProps,
                        generatorName: "moreLinkContent",
                        customGenerator: options.moreLinkContent,
                        defaultGenerator: props.defaultGenerator || $33ab27ec71b00902$var$renderMoreLinkInner,
                        classNameGenerator: options.moreLinkClassNames,
                        didMount: options.moreLinkDidMount,
                        willUnmount: options.moreLinkWillUnmount
                    }, props.children), state.isPopoverOpen && (0, $kG1qx.createElement)($33ab27ec71b00902$var$MorePopover, {
                        id: state.popoverId,
                        startDate: range.start,
                        endDate: range.end,
                        dateProfile: props.dateProfile,
                        todayRange: props.todayRange,
                        extraDateSpan: props.extraDateSpan,
                        parentEl: _this.parentEl,
                        alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : _this.linkEl,
                        alignGridTop: props.alignGridTop,
                        forceTimed: props.forceTimed,
                        onClose: _this.handlePopoverClose
                    }, props.popoverContent()));
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateParentEl();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateParentEl();
            }
        },
        {
            key: "updateParentEl",
            value: function updateParentEl() {
                if (this.linkEl) this.parentEl = $33ab27ec71b00902$export$dc98b0b04f4c7758(this.linkEl, '.fc-view-harness');
            }
        }
    ]);
    return MoreLinkContainer;
}($33ab27ec71b00902$export$ef35774e6d314e91);
function $33ab27ec71b00902$var$renderMoreLinkInner(props) {
    return props.text;
}
function $33ab27ec71b00902$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $33ab27ec71b00902$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    var hiddenSegs = props.hiddenSegs;
    return {
        start: $33ab27ec71b00902$export$cd571ca6d1702b73(hiddenSegs),
        end: $33ab27ec71b00902$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $33ab27ec71b00902$export$cd571ca6d1702b73(segs) {
    return segs.reduce($33ab27ec71b00902$var$pickEarliestStart).eventRange.range.start;
}
function $33ab27ec71b00902$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $33ab27ec71b00902$var$computeLatestSegEnd(segs) {
    return segs.reduce($33ab27ec71b00902$var$pickLatestEnd).eventRange.range.end;
}
function $33ab27ec71b00902$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
var $33ab27ec71b00902$var$Store = /*#__PURE__*/ function() {
    "use strict";
    function Store() {
        (0, $8MSeJ._)(this, Store);
        this.handlers = [];
    }
    (0, $gia3M._)(Store, [
        {
            key: "set",
            value: function set(value) {
                this.currentValue = value;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        handler(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(handler) {
                this.handlers.push(handler);
                if (this.currentValue !== undefined) handler(this.currentValue);
            }
        }
    ]);
    return Store;
}();
/*
Subscribers will get a LIST of CustomRenderings
*/ var $33ab27ec71b00902$export$1776704b6532a19a = /*#__PURE__*/ function(Store) {
    "use strict";
    (0, $9i7pb._)(CustomRenderingStore, Store);
    function CustomRenderingStore() {
        (0, $8MSeJ._)(this, CustomRenderingStore);
        var _this;
        _this = (0, $4v96Q._)(this, CustomRenderingStore, arguments);
        _this.map = new Map();
        return _this;
    }
    (0, $gia3M._)(CustomRenderingStore, [
        {
            // for consistent order
            key: "handle",
            value: function handle(customRendering) {
                var map = this.map;
                var updated = false;
                if (customRendering.isActive) {
                    map.set(customRendering.id, customRendering);
                    updated = true;
                } else if (map.has(customRendering.id)) {
                    map["delete"](customRendering.id);
                    updated = true;
                }
                if (updated) this.set(map);
            }
        }
    ]);
    return CustomRenderingStore;
}($33ab27ec71b00902$var$Store);

});
parcelRegister("ar1mO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $798d7c73146ff5b0$export$71511d61b312f219; });

var $ez4xQ = parcelRequire("ez4xQ");

var $5KqGt = parcelRequire("5KqGt");

var $3vHqq = parcelRequire("3vHqq");

var $537SV = parcelRequire("537SV");
function $798d7c73146ff5b0$export$71511d61b312f219(arr, i) {
    return (0, $ez4xQ._)(arr) || (0, $5KqGt._)(arr, i) || (0, $537SV._)(arr, i) || (0, $3vHqq._)();
}

});
parcelRegister("ez4xQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a9a7dc1bbc11f75d$export$71511d61b312f219; });
function $a9a7dc1bbc11f75d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("5KqGt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42f5f2843e5c87bd$export$71511d61b312f219; });
function $42f5f2843e5c87bd$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("3vHqq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $28e5f3b48d8a9e3b$export$71511d61b312f219; });
function $28e5f3b48d8a9e3b$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jdjhw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dfce30299f5af98c$export$71511d61b312f219; });

var $ktekx = parcelRequire("ktekx");

var $TCtnO = parcelRequire("TCtnO");

var $lgMaG = parcelRequire("lgMaG");

var $8oGuN = parcelRequire("8oGuN");
function $dfce30299f5af98c$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $dfce30299f5af98c$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $lgMaG._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $ktekx._)(Class, arguments, (0, $TCtnO._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $8oGuN._)(Wrapper, Class);
    };
    return $dfce30299f5af98c$export$71511d61b312f219(Class);
}

});
parcelRegister("ktekx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee71a1c7a8d81f71$export$71511d61b312f219; });

var $avISP = parcelRequire("avISP");

var $8oGuN = parcelRequire("8oGuN");
function $ee71a1c7a8d81f71$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $avISP._)()) $ee71a1c7a8d81f71$export$71511d61b312f219 = Reflect.construct;
    else $ee71a1c7a8d81f71$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $8oGuN._)(instance, Class.prototype);
        return instance;
    };
    return $ee71a1c7a8d81f71$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("lgMaG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7c075689404a918$export$71511d61b312f219; });
function $f7c075689404a918$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("kG1qx", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $f0d8d644469380c1$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "isValidElement", function () { return $f0d8d644469380c1$export$a8257692ac88316c; });
$parcel$export(module.exports, "createElement", function () { return $f0d8d644469380c1$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $f0d8d644469380c1$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $f0d8d644469380c1$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $f0d8d644469380c1$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $f0d8d644469380c1$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $f0d8d644469380c1$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $f0d8d644469380c1$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $f0d8d644469380c1$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $f0d8d644469380c1$export$fd42f52fd3ae1109; });

var $1PKUs = parcelRequire("1PKUs");
var $f0d8d644469380c1$var$n, $f0d8d644469380c1$export$41c562ebe57d11e2, $f0d8d644469380c1$var$u, $f0d8d644469380c1$export$a8257692ac88316c, $f0d8d644469380c1$var$t, $f0d8d644469380c1$var$r, $f0d8d644469380c1$var$o, $f0d8d644469380c1$var$f, $f0d8d644469380c1$var$e, $f0d8d644469380c1$var$c = {}, $f0d8d644469380c1$var$s = [], $f0d8d644469380c1$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $f0d8d644469380c1$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $f0d8d644469380c1$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $f0d8d644469380c1$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $f0d8d644469380c1$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $f0d8d644469380c1$var$p(l, f, t, r, null);
}
function $f0d8d644469380c1$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$f0d8d644469380c1$var$u : o
    };
    return null == o && null != $f0d8d644469380c1$export$41c562ebe57d11e2.vnode && $f0d8d644469380c1$export$41c562ebe57d11e2.vnode(f), f;
}
function $f0d8d644469380c1$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $f0d8d644469380c1$export$ffb0004e005737fa(n) {
    return n.children;
}
function $f0d8d644469380c1$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $f0d8d644469380c1$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $f0d8d644469380c1$var$g(n, r, l[r], u[r], i);
}
function $f0d8d644469380c1$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $f0d8d644469380c1$var$a.test(l) ? u : u + "px";
}
function $f0d8d644469380c1$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $f0d8d644469380c1$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $f0d8d644469380c1$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $f0d8d644469380c1$var$w : $f0d8d644469380c1$var$m, r) : n.removeEventListener(l, r ? $f0d8d644469380c1$var$w : $f0d8d644469380c1$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $f0d8d644469380c1$var$m(n) {
    $f0d8d644469380c1$var$t = !0;
    try {
        return this.l[n.type + !1]($f0d8d644469380c1$export$41c562ebe57d11e2.event ? $f0d8d644469380c1$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $f0d8d644469380c1$var$t = !1;
    }
}
function $f0d8d644469380c1$var$w(n) {
    $f0d8d644469380c1$var$t = !0;
    try {
        return this.l[n.type + !0]($f0d8d644469380c1$export$41c562ebe57d11e2.event ? $f0d8d644469380c1$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $f0d8d644469380c1$var$t = !1;
    }
}
function $f0d8d644469380c1$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $f0d8d644469380c1$var$A(n, l) {
    if (null == l) return n.__ ? $f0d8d644469380c1$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $f0d8d644469380c1$var$A(n) : null;
}
function $f0d8d644469380c1$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $f0d8d644469380c1$var$P(n);
    }
}
function $f0d8d644469380c1$var$C(n) {
    $f0d8d644469380c1$var$t ? setTimeout(n) : $f0d8d644469380c1$var$f(n);
}
function $f0d8d644469380c1$var$T(n) {
    (!n.__d && (n.__d = !0) && $f0d8d644469380c1$var$r.push(n) && !$f0d8d644469380c1$var$$.__r++ || $f0d8d644469380c1$var$o !== $f0d8d644469380c1$export$41c562ebe57d11e2.debounceRendering) && (($f0d8d644469380c1$var$o = $f0d8d644469380c1$export$41c562ebe57d11e2.debounceRendering) || $f0d8d644469380c1$var$C)($f0d8d644469380c1$var$$);
}
function $f0d8d644469380c1$var$$() {
    var n, l, u, i, t, o, f, e;
    for($f0d8d644469380c1$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $f0d8d644469380c1$var$r.shift();)n.__d && (l = $f0d8d644469380c1$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $f0d8d644469380c1$var$h({}, o)).__v = o.__v + 1, $f0d8d644469380c1$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $f0d8d644469380c1$var$A(o) : f, o.__h), $f0d8d644469380c1$var$N(i, o), o.__e != f && $f0d8d644469380c1$var$P(o)), $f0d8d644469380c1$var$r.length > l && $f0d8d644469380c1$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $f0d8d644469380c1$var$$.__r = 0;
}
function $f0d8d644469380c1$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $f0d8d644469380c1$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == (typeof d === "undefined" ? "undefined" : (0, $1PKUs._)(d)) ? $f0d8d644469380c1$var$p(null, d, null, null, d) : Array.isArray(d) ? $f0d8d644469380c1$var$p($f0d8d644469380c1$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $f0d8d644469380c1$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $f0d8d644469380c1$var$M(n, d, y = y || $f0d8d644469380c1$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $f0d8d644469380c1$var$I(d, e, n) : e = $f0d8d644469380c1$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $f0d8d644469380c1$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $f0d8d644469380c1$var$L(i).nextSibling), $f0d8d644469380c1$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$f0d8d644469380c1$var$S(g[h], g[++h], g[++h]);
}
function $f0d8d644469380c1$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $f0d8d644469380c1$var$I(i, l, u) : $f0d8d644469380c1$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $f0d8d644469380c1$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $f0d8d644469380c1$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $f0d8d644469380c1$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $f0d8d644469380c1$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $f0d8d644469380c1$var$L(u))) return i;
    }
    return null;
}
function $f0d8d644469380c1$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, _$$ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $f0d8d644469380c1$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof _$$) {
            if (b = u.props, g = (s = _$$.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in _$$ && _$$.prototype.render ? u.__c = a = new _$$(b, m) : (u.__c = a = new $f0d8d644469380c1$export$16fa2f45be04daa8(b, m), a.constructor = _$$, a.render = $f0d8d644469380c1$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != _$$.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $f0d8d644469380c1$var$h({}, a.__s)), $f0d8d644469380c1$var$h(a.__s, _$$.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == _$$.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == _$$.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $f0d8d644469380c1$export$41c562ebe57d11e2.__r, P = 0, "prototype" in _$$ && _$$.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $f0d8d644469380c1$var$h($f0d8d644469380c1$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $f0d8d644469380c1$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $f0d8d644469380c1$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $f0d8d644469380c1$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $f0d8d644469380c1$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $f0d8d644469380c1$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $f0d8d644469380c1$var$N(n, u) {
    $f0d8d644469380c1$export$41c562ebe57d11e2.__c && $f0d8d644469380c1$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $f0d8d644469380c1$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $f0d8d644469380c1$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _$_ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _$_ < o.length; _$_++)if ((s = o[_$_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_$_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $f0d8d644469380c1$var$n.call(l.childNodes), a = (y = i.props || $f0d8d644469380c1$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _$_ = 0; _$_ < l.attributes.length; _$_++)y[l.attributes[_$_].name] = l.attributes[_$_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($f0d8d644469380c1$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_$_ = u.props.children, $f0d8d644469380c1$var$H(l, Array.isArray(_$_) ? _$_ : [
            _$_
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $f0d8d644469380c1$var$A(i, 0), e), null != o) for(_$_ = o.length; _$_--;)null != o[_$_] && $f0d8d644469380c1$var$v(o[_$_]);
        e || ("value" in p && void 0 !== (_$_ = p.value) && (_$_ !== l.value || "progress" === d && !_$_ || "option" === d && _$_ !== y.value) && $f0d8d644469380c1$var$g(l, "value", _$_, y.value, !1), "checked" in p && void 0 !== (_$_ = p.checked) && _$_ !== l.checked && $f0d8d644469380c1$var$g(l, "checked", _$_, y.checked, !1));
    }
    return l;
}
function $f0d8d644469380c1$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $f0d8d644469380c1$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $f0d8d644469380c1$var$q(n, u, i) {
    var t, r;
    if ($f0d8d644469380c1$export$41c562ebe57d11e2.unmount && $f0d8d644469380c1$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $f0d8d644469380c1$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $f0d8d644469380c1$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $f0d8d644469380c1$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $f0d8d644469380c1$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $f0d8d644469380c1$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $f0d8d644469380c1$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $f0d8d644469380c1$export$41c562ebe57d11e2.__ && $f0d8d644469380c1$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $f0d8d644469380c1$var$M(i, u = (!r && t || i).__k = $f0d8d644469380c1$export$c8a8987d4410bf2d($f0d8d644469380c1$export$ffb0004e005737fa, null, [
        u
    ]), o || $f0d8d644469380c1$var$c, $f0d8d644469380c1$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $f0d8d644469380c1$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $f0d8d644469380c1$var$N(f, u);
}
function $f0d8d644469380c1$export$fa8d919ba61d84db(n, l) {
    $f0d8d644469380c1$export$b3890eb0ae9dca99(n, l, $f0d8d644469380c1$export$fa8d919ba61d84db);
}
function $f0d8d644469380c1$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $f0d8d644469380c1$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $f0d8d644469380c1$var$n.call(arguments, 2) : i), $f0d8d644469380c1$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $f0d8d644469380c1$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $f0d8d644469380c1$var$e++,
        __: n,
        Consumer: function Consumer(n, l) {
            return n.children(l);
        },
        Provider: function Provider(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $f0d8d644469380c1$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var _$l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), _$l && _$l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$f0d8d644469380c1$var$n = $f0d8d644469380c1$var$s.slice, $f0d8d644469380c1$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $f0d8d644469380c1$var$u = 0, $f0d8d644469380c1$export$a8257692ac88316c = function i(n) {
    return null != n && void 0 === n.constructor;
}, $f0d8d644469380c1$var$t = !1, $f0d8d644469380c1$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $f0d8d644469380c1$var$h({}, this.state), "function" == typeof n && (n = n($f0d8d644469380c1$var$h({}, u), this.props)), n && $f0d8d644469380c1$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $f0d8d644469380c1$var$T(this));
}, $f0d8d644469380c1$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $f0d8d644469380c1$var$T(this));
}, $f0d8d644469380c1$export$16fa2f45be04daa8.prototype.render = $f0d8d644469380c1$export$ffb0004e005737fa, $f0d8d644469380c1$var$r = [], $f0d8d644469380c1$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $f0d8d644469380c1$var$$.__r = 0, $f0d8d644469380c1$var$e = 0;

});

parcelRegister("8IBTv", function(module, exports) {

$parcel$export(module.exports, "createPortal", function () { return $658fd3d1a83cac40$export$d39a5bbd09211389; });

var $1PKUs = parcelRequire("1PKUs");

var $kG1qx = parcelRequire("kG1qx");

var $aRRsa = parcelRequire("aRRsa");
function $658fd3d1a83cac40$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $658fd3d1a83cac40$var$C(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $658fd3d1a83cac40$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $658fd3d1a83cac40$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $658fd3d1a83cac40$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : $658fd3d1a83cac40$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $kG1qx.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($658fd3d1a83cac40$export$221d75b3f55bb0bd.prototype = new (0, $kG1qx.Component)).isPureReactComponent = !0, $658fd3d1a83cac40$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $658fd3d1a83cac40$var$C(this.props, n) || $658fd3d1a83cac40$var$C(this.state, t);
};
var $658fd3d1a83cac40$var$x = (0, $kG1qx.options).__b;
(0, $kG1qx.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $658fd3d1a83cac40$var$x && $658fd3d1a83cac40$var$x(n);
};
var $658fd3d1a83cac40$var$N = "undefined" != typeof Symbol && Symbol["for"] && Symbol["for"]("react.forward_ref") || 3911;
function $658fd3d1a83cac40$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $658fd3d1a83cac40$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $658fd3d1a83cac40$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $658fd3d1a83cac40$var$A = function A(n, t) {
    return null == n ? null : (0, $kG1qx.toChildArray)((0, $kG1qx.toChildArray)(n).map(t));
}, $658fd3d1a83cac40$export$dca3b0875bd9a954 = {
    map: $658fd3d1a83cac40$var$A,
    forEach: $658fd3d1a83cac40$var$A,
    count: function count(n) {
        return n ? (0, $kG1qx.toChildArray)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $kG1qx.toChildArray)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $kG1qx.toChildArray)
}, $658fd3d1a83cac40$var$T = (0, $kG1qx.options).__e;
(0, $kG1qx.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $658fd3d1a83cac40$var$T(n, t, e, r);
};
var $658fd3d1a83cac40$var$I = (0, $kG1qx.options).unmount;
function $658fd3d1a83cac40$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $658fd3d1a83cac40$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $658fd3d1a83cac40$var$L(n, t, e);
    })), n;
}
function $658fd3d1a83cac40$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $658fd3d1a83cac40$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $658fd3d1a83cac40$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $658fd3d1a83cac40$var$F(n) {
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $658fd3d1a83cac40$export$488013bae63b21da(n) {
    var _$e, _$r, _$u;
    function o(o) {
        if (_$e || (_$e = n()).then(function(n) {
            _$r = n["default"] || n;
        }, function(n) {
            _$u = n;
        }), _$u) throw _$u;
        if (!_$r) throw _$e;
        return (0, $kG1qx.createElement)(_$r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $658fd3d1a83cac40$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $kG1qx.options).unmount = function(n) {
    var _$t = n.__c;
    _$t && _$t.__R && _$t.__R(), _$t && !0 === n.__h && (n.type = null), $658fd3d1a83cac40$var$I && $658fd3d1a83cac40$var$I(n);
}, ($658fd3d1a83cac40$export$74bf444e3cd11ea5.prototype = new (0, $kG1qx.Component)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.t && (_$r.t = []), _$r.t.push(_$e);
    var _$u = $658fd3d1a83cac40$var$F(_$r.__v), o = !1, i = function i() {
        o || (o = !0, _$e.__R = null, _$u ? _$u(_$l) : _$l());
    };
    _$e.__R = i;
    var _$l = function l() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $658fd3d1a83cac40$var$U(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.t.pop();)_$t.forceUpdate();
        }
    }, _$c = !0 === t.__h;
    _$r.__u++ || _$c || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $658fd3d1a83cac40$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $658fd3d1a83cac40$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $658fd3d1a83cac40$var$L(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $658fd3d1a83cac40$var$W = function W(n, t, e) {
    if (++e[1] === e[0] && n.o["delete"](t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $658fd3d1a83cac40$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $658fd3d1a83cac40$var$$(n) {
    var _$e = this, _$r = n.i;
    _$e.componentWillUnmount = function() {
        (0, $kG1qx.render)(null, _$e.l), _$e.l = null, _$e.i = null;
    }, _$e.i && _$e.i !== _$r && _$e.componentWillUnmount(), n.__v ? (_$e.l || (_$e.i = _$r, _$e.l = {
        nodeType: 1,
        parentNode: _$r,
        childNodes: [],
        appendChild: function appendChild(n) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        insertBefore: function insertBefore(n, t) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        removeChild: function removeChild(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.i.removeChild(n);
        }
    }), (0, $kG1qx.render)((0, $kG1qx.createElement)($658fd3d1a83cac40$var$P, {
        context: _$e.context
    }, n.__v), _$e.l)) : _$e.l && _$e.componentWillUnmount();
}
function $658fd3d1a83cac40$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $kG1qx.createElement)($658fd3d1a83cac40$var$$, {
        __v: n,
        i: e
    });
    return _$r.containerInfo = e, _$r;
}
($658fd3d1a83cac40$export$998bcd577473dd93.prototype = new (0, $kG1qx.Component)).__a = function(n) {
    var _$t = this, _$e = $658fd3d1a83cac40$var$F(_$t.__v), _$r = _$t.o.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $658fd3d1a83cac40$var$W(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $658fd3d1a83cac40$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var _$t = (0, $kG1qx.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.o.set(_$t[_$e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $658fd3d1a83cac40$export$998bcd577473dd93.prototype.componentDidUpdate = $658fd3d1a83cac40$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.o.forEach(function(t, e) {
        $658fd3d1a83cac40$var$W(_$n, e, t);
    });
};
var $658fd3d1a83cac40$var$z = "undefined" != typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103, $658fd3d1a83cac40$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $658fd3d1a83cac40$var$H = "undefined" != typeof document, $658fd3d1a83cac40$var$Z = function Z(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $1PKUs._)(Symbol()) ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $658fd3d1a83cac40$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $kG1qx.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $658fd3d1a83cac40$export$fa8d919ba61d84db(n, t, e) {
    return (0, $kG1qx.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $kG1qx.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $kG1qx.Component).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $658fd3d1a83cac40$var$G = (0, $kG1qx.options).event;
function $658fd3d1a83cac40$var$J() {}
function $658fd3d1a83cac40$var$K() {
    return this.cancelBubble;
}
function $658fd3d1a83cac40$var$Q() {
    return this.defaultPrevented;
}
(0, $kG1qx.options).event = function(n) {
    return $658fd3d1a83cac40$var$G && (n = $658fd3d1a83cac40$var$G(n)), n.persist = $658fd3d1a83cac40$var$J, n.isPropagationStopped = $658fd3d1a83cac40$var$K, n.isDefaultPrevented = $658fd3d1a83cac40$var$Q, n.nativeEvent = n;
};
var $658fd3d1a83cac40$var$X, $658fd3d1a83cac40$var$nn = {
    configurable: !0,
    get: function get() {
        return this["class"];
    }
}, $658fd3d1a83cac40$var$tn = (0, $kG1qx.options).vnode;
(0, $kG1qx.options).vnode = function(n) {
    var _$t = n.type, _$e = n.props, _$u = _$e;
    if ("string" == typeof _$t) {
        var o = -1 === _$t.indexOf("-");
        for(var i in _$u = {}, _$e){
            var _$l = _$e[i];
            $658fd3d1a83cac40$var$H && "children" === i && "noscript" === _$t || "value" === i && "defaultValue" in _$e && null == _$l || ("defaultValue" === i && "value" in _$e && null == _$e.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + _$t) && !$658fd3d1a83cac40$var$Z(_$e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $658fd3d1a83cac40$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === _$l && (_$l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), _$u[i] && (i = "oninputCapture")), _$u[i] = _$l);
        }
        "select" == _$t && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $kG1qx.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$t && null != _$u.defaultValue && (_$u.value = (0, $kG1qx.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), n.props = _$u, _$e["class"] != _$e.className && ($658fd3d1a83cac40$var$nn.enumerable = "className" in _$e, null != _$e.className && (_$u["class"] = _$e.className), Object.defineProperty(_$u, "className", $658fd3d1a83cac40$var$nn));
    }
    n.$$typeof = $658fd3d1a83cac40$var$z, $658fd3d1a83cac40$var$tn && $658fd3d1a83cac40$var$tn(n);
};
var $658fd3d1a83cac40$var$en = (0, $kG1qx.options).__r;
(0, $kG1qx.options).__r = function(n) {
    $658fd3d1a83cac40$var$en && $658fd3d1a83cac40$var$en(n), $658fd3d1a83cac40$var$X = n.__c;
};
var $658fd3d1a83cac40$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $658fd3d1a83cac40$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $658fd3d1a83cac40$export$83d89fbfd8236492 = "17.0.2";
function $658fd3d1a83cac40$export$d38cd72104c1f0e9(n) {
    return (0, $kG1qx.createElement).bind(null, n);
}
function $658fd3d1a83cac40$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $658fd3d1a83cac40$var$z;
}
function $658fd3d1a83cac40$export$e530037191fcd5d7(n) {
    return $658fd3d1a83cac40$export$a8257692ac88316c(n) ? (0, $kG1qx.cloneElement).apply(null, arguments) : n;
}
function $658fd3d1a83cac40$export$502457920280e6be(n) {
    return !!n.__k && ((0, $kG1qx.render)(null, n), !0);
}
function $658fd3d1a83cac40$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $658fd3d1a83cac40$export$c78a37762a8d58e1 = function sn(n, t) {
    return n(t);
}, $658fd3d1a83cac40$export$cd75ccfd720a3cd4 = function hn(n, t) {
    return n(t);
}, $658fd3d1a83cac40$export$5f8d39834fd61797 = (0, $kG1qx.Fragment);
function $658fd3d1a83cac40$export$7568632d0d33d16d(n) {
    n();
}
function $658fd3d1a83cac40$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $658fd3d1a83cac40$export$7b286972b8d8ccbf() {
    return [
        !1,
        $658fd3d1a83cac40$export$7568632d0d33d16d
    ];
}
var $658fd3d1a83cac40$export$aaabe4eda9ed9969 = (0, $aRRsa.useLayoutEffect);
function $658fd3d1a83cac40$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $aRRsa.useState)({
        h: {
            __: _$e,
            v: t
        }
    }), _$u = _$r[0].h, o = _$r[1];
    return (0, $aRRsa.useLayoutEffect)(function() {
        _$u.__ = _$e, _$u.v = t, $658fd3d1a83cac40$var$E(_$u.__, t()) || o({
            h: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $aRRsa.useEffect)(function() {
        return $658fd3d1a83cac40$var$E(_$u.__, _$u.v()) || o({
            h: _$u
        }), n(function() {
            $658fd3d1a83cac40$var$E(_$u.__, _$u.v()) || o({
                h: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
var $658fd3d1a83cac40$export$2e2bcd8739ae039 = {
    useState: (0, $aRRsa.useState),
    useId: (0, $aRRsa.useId),
    useReducer: (0, $aRRsa.useReducer),
    useEffect: (0, $aRRsa.useEffect),
    useLayoutEffect: (0, $aRRsa.useLayoutEffect),
    useInsertionEffect: $658fd3d1a83cac40$export$aaabe4eda9ed9969,
    useTransition: $658fd3d1a83cac40$export$7b286972b8d8ccbf,
    useDeferredValue: $658fd3d1a83cac40$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $658fd3d1a83cac40$export$306c0aa65ff9ec16,
    startTransition: $658fd3d1a83cac40$export$7568632d0d33d16d,
    useRef: (0, $aRRsa.useRef),
    useImperativeHandle: (0, $aRRsa.useImperativeHandle),
    useMemo: (0, $aRRsa.useMemo),
    useCallback: (0, $aRRsa.useCallback),
    useContext: (0, $aRRsa.useContext),
    useDebugValue: (0, $aRRsa.useDebugValue),
    version: "17.0.2",
    Children: $658fd3d1a83cac40$export$dca3b0875bd9a954,
    render: $658fd3d1a83cac40$export$b3890eb0ae9dca99,
    hydrate: $658fd3d1a83cac40$export$fa8d919ba61d84db,
    unmountComponentAtNode: $658fd3d1a83cac40$export$502457920280e6be,
    createPortal: $658fd3d1a83cac40$export$d39a5bbd09211389,
    createElement: (0, $kG1qx.createElement),
    createContext: (0, $kG1qx.createContext),
    createFactory: $658fd3d1a83cac40$export$d38cd72104c1f0e9,
    cloneElement: $658fd3d1a83cac40$export$e530037191fcd5d7,
    createRef: (0, $kG1qx.createRef),
    Fragment: (0, $kG1qx.Fragment),
    isValidElement: $658fd3d1a83cac40$export$a8257692ac88316c,
    findDOMNode: $658fd3d1a83cac40$export$466bfc07425424d5,
    Component: (0, $kG1qx.Component),
    PureComponent: $658fd3d1a83cac40$export$221d75b3f55bb0bd,
    memo: $658fd3d1a83cac40$export$7c73462e0d25e514,
    forwardRef: $658fd3d1a83cac40$export$257a8862b851cb5b,
    flushSync: $658fd3d1a83cac40$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $658fd3d1a83cac40$export$c78a37762a8d58e1,
    StrictMode: $658fd3d1a83cac40$export$5f8d39834fd61797,
    Suspense: $658fd3d1a83cac40$export$74bf444e3cd11ea5,
    SuspenseList: $658fd3d1a83cac40$export$998bcd577473dd93,
    lazy: $658fd3d1a83cac40$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $658fd3d1a83cac40$export$ae55be85d98224ed
};

});
parcelRegister("aRRsa", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $7e985154376cdbaf$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $7e985154376cdbaf$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $7e985154376cdbaf$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $7e985154376cdbaf$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $7e985154376cdbaf$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $7e985154376cdbaf$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $7e985154376cdbaf$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $7e985154376cdbaf$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $7e985154376cdbaf$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $7e985154376cdbaf$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useId", function () { return $7e985154376cdbaf$export$f680877a34711e37; });

var $kG1qx = parcelRequire("kG1qx");
var $7e985154376cdbaf$var$t, $7e985154376cdbaf$var$r, $7e985154376cdbaf$var$u, $7e985154376cdbaf$var$i, $7e985154376cdbaf$var$o = 0, $7e985154376cdbaf$var$f = [], $7e985154376cdbaf$var$c = [], $7e985154376cdbaf$var$e = (0, $kG1qx.options).__b, $7e985154376cdbaf$var$a = (0, $kG1qx.options).__r, $7e985154376cdbaf$var$v = (0, $kG1qx.options).diffed, $7e985154376cdbaf$var$l = (0, $kG1qx.options).__c, $7e985154376cdbaf$var$m = (0, $kG1qx.options).unmount;
function $7e985154376cdbaf$var$d(t, u) {
    (0, $kG1qx.options).__h && (0, $kG1qx.options).__h($7e985154376cdbaf$var$r, t, $7e985154376cdbaf$var$o || u), $7e985154376cdbaf$var$o = 0;
    var i = $7e985154376cdbaf$var$r.__H || ($7e985154376cdbaf$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $7e985154376cdbaf$var$c
    }), i.__[t];
}
function $7e985154376cdbaf$export$60241385465d0a34(n) {
    return $7e985154376cdbaf$var$o = 1, $7e985154376cdbaf$export$13e3392192263954($7e985154376cdbaf$var$B, n);
}
function $7e985154376cdbaf$export$13e3392192263954(n, u, i) {
    var o = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $7e985154376cdbaf$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $7e985154376cdbaf$var$r, !$7e985154376cdbaf$var$r.u)) {
        $7e985154376cdbaf$var$r.u = !0;
        var f = $7e985154376cdbaf$var$r.shouldComponentUpdate;
        $7e985154376cdbaf$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var _$i = !1;
            return _$u.forEach(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), !(!_$i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $7e985154376cdbaf$export$6d9c69b0de29b591(u, i) {
    var o = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 3);
    !(0, $kG1qx.options).__s && $7e985154376cdbaf$var$z(o.__H, i) && (o.__ = u, o.i = i, $7e985154376cdbaf$var$r.__H.__h.push(o));
}
function $7e985154376cdbaf$export$e5c5a5f917a5871c(u, i) {
    var o = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 4);
    !(0, $kG1qx.options).__s && $7e985154376cdbaf$var$z(o.__H, i) && (o.__ = u, o.i = i, $7e985154376cdbaf$var$r.__h.push(o));
}
function $7e985154376cdbaf$export$b8f5890fc79d6aca(n) {
    return $7e985154376cdbaf$var$o = 5, $7e985154376cdbaf$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $7e985154376cdbaf$export$d5a552a76deda3c2(n, t, r) {
    $7e985154376cdbaf$var$o = 6, $7e985154376cdbaf$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $7e985154376cdbaf$export$1538c33de8887b59(n, r) {
    var u = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 7);
    return $7e985154376cdbaf$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $7e985154376cdbaf$export$35808ee640e87ca7(n, t) {
    return $7e985154376cdbaf$var$o = 8, $7e985154376cdbaf$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $7e985154376cdbaf$export$fae74005e78b1a27(n) {
    var u = $7e985154376cdbaf$var$r.context[n.__c], i = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($7e985154376cdbaf$var$r)), u.props.value) : n.__;
}
function $7e985154376cdbaf$export$dc8fbce3eb94dc1e(t, r) {
    (0, $kG1qx.options).useDebugValue && (0, $kG1qx.options).useDebugValue(r ? r(t) : t);
}
function $7e985154376cdbaf$export$c052f6604b7d51fe(n) {
    var u = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 10), i = $7e985154376cdbaf$export$60241385465d0a34();
    return u.__ = n, $7e985154376cdbaf$var$r.componentDidCatch || ($7e985154376cdbaf$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $7e985154376cdbaf$export$f680877a34711e37() {
    var _$n = $7e985154376cdbaf$var$d($7e985154376cdbaf$var$t++, 11);
    if (!_$n.__) {
        for(var u = $7e985154376cdbaf$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $7e985154376cdbaf$var$b() {
    for(var t; t = $7e985154376cdbaf$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($7e985154376cdbaf$var$k), t.__H.__h.forEach($7e985154376cdbaf$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $kG1qx.options).__e(r, t.__v);
    }
}
(0, $kG1qx.options).__b = function(n) {
    $7e985154376cdbaf$var$r = null, $7e985154376cdbaf$var$e && $7e985154376cdbaf$var$e(n);
}, (0, $kG1qx.options).__r = function(n) {
    $7e985154376cdbaf$var$a && $7e985154376cdbaf$var$a(n), $7e985154376cdbaf$var$t = 0;
    var i = ($7e985154376cdbaf$var$r = n.__c).__H;
    i && ($7e985154376cdbaf$var$u === $7e985154376cdbaf$var$r ? (i.__h = [], $7e985154376cdbaf$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $7e985154376cdbaf$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($7e985154376cdbaf$var$k), i.__h.forEach($7e985154376cdbaf$var$w), i.__h = [])), $7e985154376cdbaf$var$u = $7e985154376cdbaf$var$r;
}, (0, $kG1qx.options).diffed = function(t) {
    $7e985154376cdbaf$var$v && $7e985154376cdbaf$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $7e985154376cdbaf$var$f.push(o) && $7e985154376cdbaf$var$i === (0, $kG1qx.options).requestAnimationFrame || (($7e985154376cdbaf$var$i = (0, $kG1qx.options).requestAnimationFrame) || $7e985154376cdbaf$var$j)($7e985154376cdbaf$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $7e985154376cdbaf$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $7e985154376cdbaf$var$c;
    })), $7e985154376cdbaf$var$u = $7e985154376cdbaf$var$r = null;
}, (0, $kG1qx.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($7e985154376cdbaf$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $7e985154376cdbaf$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $kG1qx.options).__e(u, t.__v);
        }
    }), $7e985154376cdbaf$var$l && $7e985154376cdbaf$var$l(t, r);
}, (0, $kG1qx.options).unmount = function(t) {
    $7e985154376cdbaf$var$m && $7e985154376cdbaf$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $7e985154376cdbaf$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $kG1qx.options).__e(r, u.__v));
};
var $7e985154376cdbaf$var$g = "function" == typeof requestAnimationFrame;
function $7e985154376cdbaf$var$j(n) {
    var t, r = function r() {
        clearTimeout(u), $7e985154376cdbaf$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $7e985154376cdbaf$var$g && (t = requestAnimationFrame(r));
}
function $7e985154376cdbaf$var$k(n) {
    var t = $7e985154376cdbaf$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $7e985154376cdbaf$var$r = t;
}
function $7e985154376cdbaf$var$w(n) {
    var t = $7e985154376cdbaf$var$r;
    n.__c = n.__(), $7e985154376cdbaf$var$r = t;
}
function $7e985154376cdbaf$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $7e985154376cdbaf$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});




parcelRegister("LCZef", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $5e37999a99b848cc$export$57bf213be019eeb0; });
$parcel$export(module.exports, "hide", function () { return $5e37999a99b848cc$export$fe8985bb6374093c; });
$parcel$export(module.exports, "fadeIn", function () { return $5e37999a99b848cc$export$82e6205b15e6c637; });
$parcel$export(module.exports, "fadeOut", function () { return $5e37999a99b848cc$export$c091916f1530334c; });
$parcel$export(module.exports, "slideUp", function () { return $5e37999a99b848cc$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $5e37999a99b848cc$export$abdd11a06a163232; });
$parcel$export(module.exports, "slideIn", function () { return $5e37999a99b848cc$export$d08c54023c399c9c; });
$parcel$export(module.exports, "slideOut", function () { return $5e37999a99b848cc$export$388d063d19975bb; });
$parcel$export(module.exports, "isVisible", function () { return $5e37999a99b848cc$export$795910f5f15a9633; });

var $hvZMf = parcelRequire("hvZMf");
var $5e37999a99b848cc$export$57bf213be019eeb0 = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        element.offsetHeight;
    }
};
var $5e37999a99b848cc$export$fe8985bb6374093c = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.display = 'none';
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
    }
};
var $5e37999a99b848cc$export$82e6205b15e6c637 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display === 'none')) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.opacity = '0';
        element.style.visibility = 'hidden';
        element.style.display = display === 'none' ? 'block' : display;
        // Force CSS Reflow
        element.offsetHeight;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.visibility = 'visible';
        element.style.opacity = '1';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('opacity');
            element.style.removeProperty('visibility');
            element.style.removeProperty('transition');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$c091916f1530334c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display !== 'none')) {
        var _element_classList, _element_classList1;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.opacity = '0';
        // Force CSS Reflow
        element.offsetHeight;
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('transition');
            element.style.removeProperty('opacity');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$75d3d2c72ecccf9b = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$82e6205b15e6c637(element, duration, options);
        else return $5e37999a99b848cc$export$c091916f1530334c(element, duration, options);
    }
};
var $5e37999a99b848cc$export$deed561b1a0ff1ea = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = element.offsetHeight + 'px';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$abdd11a06a163232 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        var height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$715de50cedc228a8 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$abdd11a06a163232(element, duration, options);
        else return $5e37999a99b848cc$export$deed561b1a0ff1ea(element, duration, options);
    }
};
var $5e37999a99b848cc$export$d08c54023c399c9c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = 'none';
        element.style.removeProperty('display');
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = display === 'none' ? 'block' : display;
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = (options === null || options === void 0 ? void 0 : options.distance) !== undefined ? "".concat(options.distance, "px") : '';
        document.documentElement.classList.add('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _element_querySelector, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            (_element_querySelector = element.querySelector('a, button')) === null || _element_querySelector === void 0 ? void 0 : _element_querySelector.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$388d063d19975bb = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        var distance = "-".concat(window.getComputedStyle(element).width);
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = distance;
        document.documentElement.classList.remove('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_toggle, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            element.style.display = 'none';
            options === null || options === void 0 ? void 0 : (_options_toggle = options.toggle) === null || _options_toggle === void 0 ? void 0 : _options_toggle.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$795910f5f15a9633 = function(element) {
    if (!element || !element.isConnected) return false;
    if (element.getClientRects().length === 0) return false;
    var style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    var rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (style.opacity === '0') return false;
    return true;
};

});


var $k1CNB = parcelRequire("k1CNB");

var $9qD8b = parcelRequire("9qD8b");

var $4v96Q = parcelRequire("4v96Q");

var $8MSeJ = parcelRequire("8MSeJ");

var $gia3M = parcelRequire("gia3M");

var $eSf5K = parcelRequire("eSf5K");

var $bFyls = parcelRequire("bFyls");

var $TCtnO = parcelRequire("TCtnO");

var $9i7pb = parcelRequire("9i7pb");

var $ar1mO = parcelRequire("ar1mO");

var $hvZMf = parcelRequire("hvZMf");

var $1PKUs = parcelRequire("1PKUs");

var $4r1TJ = parcelRequire("4r1TJ");

var $kG1qx = parcelRequire("kG1qx");
parcelRequire("8IBTv");
var $25f9ba4cb990a500$export$794e7bef9c0b12d9 = [];
var $25f9ba4cb990a500$var$MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list'
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display'
};
var $25f9ba4cb990a500$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $25f9ba4cb990a500$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today: function(buttonText, unit) {
            return unit === 'day' ? 'Today' : "This ".concat(buttonText);
        }
    },
    viewHint: '$0 view',
    navLinkHint: 'Go to $0',
    moreLinkHint: function(eventCnt) {
        return "Show ".concat(eventCnt, " more event").concat(eventCnt === 1 ? '' : 's');
    }
});
function $25f9ba4cb990a500$var$organizeRawLocales(explicitRawLocales) {
    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    var allRawLocales = $25f9ba4cb990a500$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    var rawLocaleMap = {
        en: $25f9ba4cb990a500$var$RAW_EN_LOCALE
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allRawLocales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawLocale = _step.value;
            rawLocaleMap[rawLocale.code] = rawLocale;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $25f9ba4cb990a500$var$buildLocale(inputSingular, available) {
    if ((typeof inputSingular === "undefined" ? "undefined" : (0, $1PKUs._)(inputSingular)) === 'object' && !Array.isArray(inputSingular)) return $25f9ba4cb990a500$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $25f9ba4cb990a500$var$queryLocale(inputSingular, available);
}
function $25f9ba4cb990a500$var$queryLocale(codeArg, available) {
    var codes = [].concat(codeArg || []); // will convert to array
    var raw = $25f9ba4cb990a500$var$queryRawLocale(codes, available) || $25f9ba4cb990a500$var$RAW_EN_LOCALE;
    return $25f9ba4cb990a500$var$parseLocale(codeArg, codes, raw);
}
function $25f9ba4cb990a500$var$queryRawLocale(codes, available) {
    for(var i = 0; i < codes.length; i += 1){
        var parts = codes[i].toLocaleLowerCase().split('-');
        for(var j = parts.length; j > 0; j -= 1){
            var simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $25f9ba4cb990a500$var$parseLocale(codeArg, codes, raw) {
    var merged = (0, $4r1TJ.m)([
        $25f9ba4cb990a500$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        'buttonText'
    ]);
    delete merged.code; // don't want this part of the options
    var week = merged.week;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $25f9ba4cb990a500$export$ae829ec7b2625219(input) {
    return {
        id: (0, $4r1TJ.g)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $25f9ba4cb990a500$var$buildPluginHooks(pluginDefs, globalDefs) {
    var currentPluginIds = {};
    var hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = defs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var def = _step.value;
                var pluginName = def.name;
                var currentId = currentPluginIds[pluginName];
                if (currentId === undefined) {
                    currentPluginIds[pluginName] = def.id;
                    addDefs(def.deps);
                    hooks = $25f9ba4cb990a500$var$combineHooks(hooks, def);
                } else if (currentId !== def.id) // different ID than the one already added
                console.warn("Duplicate plugin '".concat(pluginName, "'"));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $25f9ba4cb990a500$var$buildBuildPluginHooks() {
    var currentOverrideDefs = [];
    var currentGlobalDefs = [];
    var currentHooks;
    return function(overrideDefs, globalDefs) {
        if (!currentHooks || !(0, $4r1TJ.i)(overrideDefs, currentOverrideDefs) || !(0, $4r1TJ.i)(globalDefs, currentGlobalDefs)) currentHooks = $25f9ba4cb990a500$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $25f9ba4cb990a500$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $25f9ba4cb990a500$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $25f9ba4cb990a500$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
var $25f9ba4cb990a500$var$StandardTheme = /*#__PURE__*/ function(Theme) {
    "use strict";
    (0, $9i7pb._)(StandardTheme, Theme);
    function StandardTheme() {
        (0, $8MSeJ._)(this, StandardTheme);
        return (0, $4v96Q._)(this, StandardTheme, arguments);
    }
    return StandardTheme;
}((0, $4r1TJ.T));
$25f9ba4cb990a500$var$StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active'
};
$25f9ba4cb990a500$var$StandardTheme.prototype.baseIconClass = 'fc-icon';
$25f9ba4cb990a500$var$StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right'
};
$25f9ba4cb990a500$var$StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left'
};
$25f9ba4cb990a500$var$StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
$25f9ba4cb990a500$var$StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
$25f9ba4cb990a500$var$StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
function $25f9ba4cb990a500$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    var hash = {};
    var viewType;
    for(viewType in defaultConfigs)$25f9ba4cb990a500$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$25f9ba4cb990a500$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $25f9ba4cb990a500$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    var viewDef = $25f9ba4cb990a500$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $25f9ba4cb990a500$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    var defaultConfig = defaultConfigs[viewType];
    var overrideConfig = overrideConfigs[viewType];
    var queryProp = function(name) {
        return defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    };
    var theComponent = queryProp('component');
    var superType = queryProp('superType');
    var superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
        superDef = $25f9ba4cb990a500$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $25f9ba4cb990a500$var$parseViewConfigs(inputs) {
    return (0, $4r1TJ.a)(inputs, $25f9ba4cb990a500$var$parseViewConfig);
}
function $25f9ba4cb990a500$var$parseViewConfig(input) {
    var rawOptions = typeof input === 'function' ? {
        component: input
    } : input;
    var component = rawOptions.component;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $25f9ba4cb990a500$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $4r1TJ.B))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $25f9ba4cb990a500$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $25f9ba4cb990a500$var$createViewHookComponent(options) {
    return function(viewProps) {
        return (0, $kG1qx.createElement)((0, $4r1TJ.V).Consumer, null, function(context) {
            return (0, $kG1qx.createElement)((0, $4r1TJ.C), {
                elTag: "div",
                elClasses: (0, $4r1TJ.b)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            });
        });
    };
}
function $25f9ba4cb990a500$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var defaultConfigs = $25f9ba4cb990a500$var$parseViewConfigs(defaultInputs);
    var overrideConfigs = $25f9ba4cb990a500$var$parseViewConfigs(optionOverrides.views);
    var viewDefs = $25f9ba4cb990a500$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $4r1TJ.a)(viewDefs, function(viewDef) {
        return $25f9ba4cb990a500$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults);
    });
}
function $25f9ba4cb990a500$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    var duration = null;
    var durationUnit = '';
    var singleUnit = '';
    var singleUnitOverrides = {};
    if (durationInput) {
        duration = $25f9ba4cb990a500$var$createDurationCached(durationInput);
        if (duration) {
            var denom = (0, $4r1TJ.c)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    var queryButtonText = function(optionsSubset) {
        var buttonTextMap = optionsSubset.buttonText || {};
        var buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    var queryButtonTitle = function(optionsSubset) {
        var buttonHints = optionsSubset.buttonHints || {};
        var buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $4r1TJ.e)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $4r1TJ.e))
    };
}
// hack to get memoization working
var $25f9ba4cb990a500$var$durationInputMap = {};
function $25f9ba4cb990a500$var$createDurationCached(durationInput) {
    var json = JSON.stringify(durationInput);
    var res = $25f9ba4cb990a500$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $4r1TJ.d)(durationInput);
        $25f9ba4cb990a500$var$durationInputMap[json] = res;
    }
    return res;
}
function $25f9ba4cb990a500$var$reduceViewType(viewType, action) {
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}
function $25f9ba4cb990a500$var$reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function $25f9ba4cb990a500$var$getInitialDate(options, dateEnv, nowManager) {
    var initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function $25f9ba4cb990a500$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case 'SET_OPTION':
            return Object.assign(Object.assign({}, dynamicOptionOverrides), (0, $eSf5K._)({}, action.optionName, action.rawOptionValue));
        default:
            return dynamicOptionOverrides;
    }
}
function $25f9ba4cb990a500$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    var dp;
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $25f9ba4cb990a500$var$initEventSources(calendarOptions, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null;
    return $25f9ba4cb990a500$var$addSources({}, $25f9ba4cb990a500$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $25f9ba4cb990a500$var$reduceEventSources(eventSources, action, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case 'ADD_EVENT_SOURCES':
            return $25f9ba4cb990a500$var$addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return $25f9ba4cb990a500$var$removeSource(eventSources, action.sourceId);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return $25f9ba4cb990a500$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return $25f9ba4cb990a500$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $4r1TJ.f)(action.sourceIds) : $25f9ba4cb990a500$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return $25f9ba4cb990a500$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function $25f9ba4cb990a500$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $25f9ba4cb990a500$var$fetchSourcesByIds(eventSources, $25f9ba4cb990a500$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $25f9ba4cb990a500$var$computeEventSourcesLoading(eventSources) {
    for(var sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $25f9ba4cb990a500$var$addSources(eventSourceHash, sources, fetchRange, context) {
    var hash = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            hash[source.sourceId] = source;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (fetchRange) hash = $25f9ba4cb990a500$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $25f9ba4cb990a500$var$removeSource(eventSourceHash, sourceId) {
    return (0, $4r1TJ.h)(eventSourceHash, function(eventSource) {
        return eventSource.sourceId !== sourceId;
    });
}
function $25f9ba4cb990a500$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $25f9ba4cb990a500$var$fetchSourcesByIds(sourceHash, (0, $4r1TJ.h)(sourceHash, function(eventSource) {
        return $25f9ba4cb990a500$var$isSourceDirty(eventSource, fetchRange, context);
    }), fetchRange, false, context);
}
function $25f9ba4cb990a500$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$25f9ba4cb990a500$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $25f9ba4cb990a500$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    var nextSources = {};
    for(var sourceId in prevSources){
        var source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $25f9ba4cb990a500$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $25f9ba4cb990a500$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    var options = context.options, calendarApi = context.calendarApi;
    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    var fetchId = (0, $4r1TJ.g)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, function(res) {
        var rawEvents = res.rawEvents;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, function(error) {
        var errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $25f9ba4cb990a500$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    var eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), (0, $eSf5K._)({}, sourceId, Object.assign(Object.assign({}, eventSource), {
        isFetching: false,
        fetchRange: fetchRange
    })));
    return sourceHash;
}
function $25f9ba4cb990a500$var$excludeStaticSources(eventSources, context) {
    return (0, $4r1TJ.h)(eventSources, function(eventSource) {
        return $25f9ba4cb990a500$var$doesSourceNeedRange(eventSource, context);
    });
}
function $25f9ba4cb990a500$var$parseInitialSources(rawOptions, context) {
    var refiners = (0, $4r1TJ.j)(context);
    var rawSources = [].concat(rawOptions.eventSources || []);
    var sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rawSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawSource = _step.value;
            var source = (0, $4r1TJ.p)(rawSource, context, refiners);
            if (source) sources.push(source);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sources;
}
function $25f9ba4cb990a500$var$doesSourceNeedRange(eventSource, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $25f9ba4cb990a500$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}
function $25f9ba4cb990a500$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $25f9ba4cb990a500$var$reduceEventDrag(currentDrag, action) {
    var newDrag;
    switch(action.type){
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $25f9ba4cb990a500$var$reduceEventResize(currentResize, action) {
    var newResize;
    switch(action.type){
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $25f9ba4cb990a500$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var header = calendarOptions.headerToolbar ? $25f9ba4cb990a500$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    var footer = calendarOptions.footerToolbar ? $25f9ba4cb990a500$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $25f9ba4cb990a500$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var sectionWidgets = {};
    var viewsWithButtons = [];
    var hasTitle = false;
    for(var sectionName in sectionStrHash){
        var _viewsWithButtons;
        var sectionStr = sectionStrHash[sectionName];
        var sectionRes = $25f9ba4cb990a500$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        (_viewsWithButtons = viewsWithButtons).push.apply(_viewsWithButtons, (0, $hvZMf._)(sectionRes.viewsWithButtons));
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $25f9ba4cb990a500$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var isRtl = calendarOptions.direction === 'rtl';
    var calendarCustomButtons = calendarOptions.customButtons || {};
    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    var calendarButtonText = calendarOptions.buttonText || {};
    var calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    var calendarButtonHints = calendarOptions.buttonHints || {};
    var sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    var viewsWithButtons = [];
    var hasTitle = false;
    var widgets = sectionSubstrs.map(function(buttonGroupStr) {
        return buttonGroupStr.split(',').map(function(buttonName) {
            if (buttonName === 'title') {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            var customButtonProps;
            var viewSpec;
            var buttonClick;
            var buttonIcon; // only one of these will be set
            var buttonText; // "
            var buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = function(ev) {
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = function() {
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                var textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $4r1TJ.k)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = function() {
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                    var prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                    buttonHint = (0, $4r1TJ.k)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || 'year',
                        'year'
                    ], calendarButtonText[buttonName]);
                } else buttonHint = function(navUnit) {
                    return (0, $4r1TJ.k)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
                };
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        });
    });
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
var $25f9ba4cb990a500$var$ViewImpl = /*#__PURE__*/ function() {
    "use strict";
    function ViewImpl(type, getCurrentData, dateEnv) {
        (0, $8MSeJ._)(this, ViewImpl);
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    (0, $gia3M._)(ViewImpl, [
        {
            key: "calendar",
            get: function get() {
                return this.getCurrentData().calendarApi;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.getCurrentData().viewTitle;
            }
        },
        {
            key: "activeStart",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
            }
        },
        {
            key: "activeEnd",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
            }
        },
        {
            key: "currentStart",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
            }
        },
        {
            key: "currentEnd",
            get: function get() {
                return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
            }
        },
        {
            key: "getOption",
            value: function getOption(name) {
                return this.getCurrentData().options[name]; // are the view-specific options
            }
        }
    ]);
    return ViewImpl;
}();
var $25f9ba4cb990a500$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta: function(refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch: function(arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
var $25f9ba4cb990a500$var$arrayEventSourcePlugin = $25f9ba4cb990a500$export$ae829ec7b2625219({
    name: 'array-event-source',
    eventSourceDefs: [
        $25f9ba4cb990a500$var$eventSourceDef$2
    ]
});
var $25f9ba4cb990a500$var$eventSourceDef$1 = {
    parseMeta: function(refined) {
        if (typeof refined.events === 'function') return refined.events;
        return null;
    },
    fetch: function(arg, successCallback, errorCallback) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.eventSource.meta;
        (0, $4r1TJ.u)(func.bind(null, (0, $4r1TJ.l)(arg.range, dateEnv)), function(rawEvents) {
            return successCallback({
                rawEvents: rawEvents
            });
        }, errorCallback);
    }
};
var $25f9ba4cb990a500$var$funcEventSourcePlugin = $25f9ba4cb990a500$export$ae829ec7b2625219({
    name: 'func-event-source',
    eventSourceDefs: [
        $25f9ba4cb990a500$var$eventSourceDef$1
    ]
});
var $25f9ba4cb990a500$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $4r1TJ.n),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
var $25f9ba4cb990a500$var$eventSourceDef = {
    parseMeta: function(refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) return {
            url: refined.url,
            format: 'json',
            method: (refined.method || 'GET').toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch: function(arg, successCallback, errorCallback) {
        var meta = arg.eventSource.meta;
        var requestParams = $25f9ba4cb990a500$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $4r1TJ.r)(meta.method, meta.url, requestParams).then(function(param) {
            var _param = (0, $ar1mO._)(param, 2), rawEvents = _param[0], response = _param[1];
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
var $25f9ba4cb990a500$var$jsonFeedEventSourcePlugin = $25f9ba4cb990a500$export$ae829ec7b2625219({
    name: 'json-event-source',
    eventSourceRefiners: $25f9ba4cb990a500$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $25f9ba4cb990a500$var$eventSourceDef
    ]
});
function $25f9ba4cb990a500$var$buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
var $25f9ba4cb990a500$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $4r1TJ.n),
    startTime: (0, $4r1TJ.d),
    endTime: (0, $4r1TJ.d),
    duration: (0, $4r1TJ.d),
    startRecur: (0, $4r1TJ.n),
    endRecur: (0, $4r1TJ.n)
};
var $25f9ba4cb990a500$var$recurring = {
    parse: function(refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            var recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv: dateEnv
            };
            var duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $4r1TJ.s)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand: function(typeData, framingRange, dateEnv) {
        var clippedFramingRange = (0, $4r1TJ.o)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $25f9ba4cb990a500$var$expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
var $25f9ba4cb990a500$var$simpleRecurringEventsPlugin = $25f9ba4cb990a500$export$ae829ec7b2625219({
    name: 'simple-recurring-event',
    recurringTypes: [
        $25f9ba4cb990a500$var$recurring
    ],
    eventRefiners: $25f9ba4cb990a500$var$SIMPLE_RECURRING_REFINERS
});
function $25f9ba4cb990a500$var$expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    var dowHash = daysOfWeek ? (0, $4r1TJ.f)(daysOfWeek) : null;
    var dayMarker = (0, $4r1TJ.q)(framingRange.start);
    var endMarker = framingRange.end;
    var instanceStarts = [];
    // https://github.com/fullcalendar/fullcalendar/issues/7934
    if (startTime) {
        if (startTime.milliseconds < 0) // possible for next-day to have negative business hours that go into current day
        endMarker = (0, $4r1TJ.t)(endMarker, 1);
        else if (startTime.milliseconds >= 86400000) // possible for prev-day to have >24hr business hours that go into current day
        dayMarker = (0, $4r1TJ.t)(dayMarker, -1);
    }
    while(dayMarker < endMarker){
        var instanceStart = void 0;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, $4r1TJ.t)(dayMarker, 1);
    }
    return instanceStarts;
}
var $25f9ba4cb990a500$var$changeHandlerPlugin = $25f9ba4cb990a500$export$ae829ec7b2625219({
    name: 'change-handler',
    optionChangeHandlers: {
        events: function(events, context) {
            $25f9ba4cb990a500$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $25f9ba4cb990a500$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $25f9ba4cb990a500$var$handleEventSources(inputs, context) {
    var unfoundSources = (0, $4r1TJ.v)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: 'RESET_RAW_EVENTS',
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    var newInputs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var inputFound = false;
            for(var i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
                unfoundSources.splice(i, 1); // delete
                inputFound = true;
                break;
            }
            if (!inputFound) newInputs.push(input);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = unfoundSources[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var unfoundSource = _step1.value;
            context.dispatch({
                type: 'REMOVE_EVENT_SOURCE',
                sourceId: unfoundSource.sourceId
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = newInputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var newInput = _step2.value;
            context.calendarApi.addEventSource(newInput);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
function $25f9ba4cb990a500$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, $4r1TJ.l)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $25f9ba4cb990a500$var$handleEventStore(eventStore, context) {
    var emitter = context.emitter;
    if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, $4r1TJ.w)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ var $25f9ba4cb990a500$export$905153d94e0757fa = [
    $25f9ba4cb990a500$var$arrayEventSourcePlugin,
    $25f9ba4cb990a500$var$funcEventSourcePlugin,
    $25f9ba4cb990a500$var$jsonFeedEventSourcePlugin,
    $25f9ba4cb990a500$var$simpleRecurringEventsPlugin,
    $25f9ba4cb990a500$var$changeHandlerPlugin,
    $25f9ba4cb990a500$export$ae829ec7b2625219({
        name: 'misc',
        isLoadingFuncs: [
            function(state) {
                return $25f9ba4cb990a500$var$computeEventSourcesLoading(state.eventSources);
            }
        ],
        propSetHandlers: {
            dateProfile: $25f9ba4cb990a500$var$handleDateProfile,
            eventStore: $25f9ba4cb990a500$var$handleEventStore
        }
    })
];
var $25f9ba4cb990a500$var$TaskRunner = /*#__PURE__*/ function() {
    "use strict";
    function TaskRunner(runTaskOption, drainedOption) {
        (0, $8MSeJ._)(this, TaskRunner);
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $4r1TJ.D)(this.drain.bind(this));
    }
    (0, $gia3M._)(TaskRunner, [
        {
            key: "request",
            value: function request(task, delay) {
                this.queue.push(task);
                this.delayedRunner.request(delay);
            }
        },
        {
            key: "pause",
            value: function pause(scope) {
                this.delayedRunner.pause(scope);
            }
        },
        {
            key: "resume",
            value: function resume(scope, force) {
                this.delayedRunner.resume(scope, force);
            }
        },
        {
            key: "drain",
            value: function drain() {
                var queue = this.queue;
                while(queue.length){
                    var completedTasks = [];
                    var task = void 0;
                    while(task = queue.shift()){
                        this.runTask(task);
                        completedTasks.push(task);
                    }
                    this.drained(completedTasks);
                } // keep going, in case new tasks were added in the drained handler
            }
        },
        {
            key: "runTask",
            value: function runTask(task) {
                if (this.runTaskOption) this.runTaskOption(task);
            }
        },
        {
            key: "drained",
            value: function drained(completedTasks) {
                if (this.drainedOption) this.drainedOption(completedTasks);
            }
        }
    ]);
    return TaskRunner;
}();
// Computes what the title at the top of the calendarApi should be for this view
function $25f9ba4cb990a500$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    var range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $4r1TJ.x)(viewOptions.titleFormat || $25f9ba4cb990a500$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $25f9ba4cb990a500$var$buildTitleFormat(dateProfile) {
    var currentRangeUnit = dateProfile.currentRangeUnit;
    if (currentRangeUnit === 'year') return {
        year: 'numeric'
    };
    if (currentRangeUnit === 'month') return {
        year: 'numeric',
        month: 'long'
    }; // like "September 2014"
    var days = (0, $4r1TJ.y)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    // one day. longer, like "September 9 2014"
    return {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ var $25f9ba4cb990a500$var$CalendarNowManager = /*#__PURE__*/ function() {
    "use strict";
    function CalendarNowManager() {
        (0, $8MSeJ._)(this, CalendarNowManager);
        this.resetListeners = new Set();
    }
    (0, $gia3M._)(CalendarNowManager, [
        {
            key: "handleInput",
            value: function handleInput(dateEnv, nowInput) {
                var oldDateEnv = this.dateEnv;
                if (dateEnv !== oldDateEnv) {
                    if (typeof nowInput === 'function') this.nowFn = nowInput;
                    else if (!oldDateEnv) {
                        this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                        this.nowAnchorQueried = Date.now();
                    }
                    this.dateEnv = dateEnv;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // not first time? fire reset handlers
                    if (oldDateEnv) try {
                        for(var _iterator = this.resetListeners.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var resetListener = _step.value;
                            resetListener();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "getDateMarker",
            value: function getDateMarker() {
                return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
            }
        },
        {
            key: "addResetListener",
            value: function addResetListener(handler) {
                this.resetListeners.add(handler);
            }
        },
        {
            key: "removeResetListener",
            value: function removeResetListener(handler) {
                this.resetListeners["delete"](handler);
            }
        }
    ]);
    return CalendarNowManager;
}();
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
var $25f9ba4cb990a500$var$CalendarDataManager = /*#__PURE__*/ function() {
    "use strict";
    function CalendarDataManager(props) {
        var _this = this;
        (0, $8MSeJ._)(this, CalendarDataManager);
        this.computeCurrentViewData = (0, $4r1TJ.z)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $4r1TJ.z)($25f9ba4cb990a500$var$organizeRawLocales);
        this.buildLocale = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildLocale);
        this.buildPluginHooks = $25f9ba4cb990a500$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildDateEnv$1);
        this.buildTheme = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildTheme);
        this.parseToolbars = (0, $4r1TJ.z)($25f9ba4cb990a500$var$parseToolbars);
        this.buildViewSpecs = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $4r1TJ.A)($25f9ba4cb990a500$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildViewApi);
        this.buildViewUiProps = (0, $4r1TJ.A)($25f9ba4cb990a500$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildEventUiBySource, (0, $4r1TJ.E));
        this.buildEventUiBases = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $4r1TJ.A)($25f9ba4cb990a500$var$parseContextBusinessHours);
        this.buildTitle = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildTitle);
        this.nowManager = new $25f9ba4cb990a500$var$CalendarNowManager();
        this.emitter = new (0, $4r1TJ.F)();
        this.actionRunner = new $25f9ba4cb990a500$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = function() {
            return _this.data;
        };
        this.dispatch = function(action) {
            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new $25f9ba4cb990a500$var$CalendarNowManager();
        var dynamicOptionOverrides = {};
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        var calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        var currentDate = $25f9ba4cb990a500$var$getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $4r1TJ.G)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // needs to be after setThisContext
            for(var _iterator = optionsData.pluginHooks.contextInit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                callback(calendarContext);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // NOT DRY
        var eventSources = $25f9ba4cb990a500$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        var initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $4r1TJ.H)(),
            renderableEventStore: (0, $4r1TJ.H)(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        var contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = optionsData.pluginHooks.reducers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var reducer = _step1.value;
                Object.assign(initialState, reducer(null, null, contextAndState));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if ($25f9ba4cb990a500$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    (0, $gia3M._)(CalendarDataManager, [
        {
            key: "resetOptions",
            value: function resetOptions(optionOverrides, changedOptionNames) {
                var props = this.props;
                if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
                else {
                    var _this_optionsForRefining;
                    props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
                    (_this_optionsForRefining = this.optionsForRefining).push.apply(_this_optionsForRefining, (0, $hvZMf._)(changedOptionNames));
                }
                if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
                    type: 'NOTHING'
                });
            }
        },
        {
            key: "_handleAction",
            value: function _handleAction(action) {
                var _this = this, props = _this.props, state = _this.state, emitter = _this.emitter;
                var dynamicOptionOverrides = $25f9ba4cb990a500$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
                var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
                var currentViewType = $25f9ba4cb990a500$var$reduceViewType(state.currentViewType, action);
                var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
                // wire things up
                // TODO: not DRY
                props.calendarApi.currentDataManager = this;
                emitter.setThisContext(props.calendarApi);
                emitter.setOptions(currentViewData.options);
                var calendarContext = {
                    nowManager: this.nowManager,
                    dateEnv: optionsData.dateEnv,
                    options: optionsData.calendarOptions,
                    pluginHooks: optionsData.pluginHooks,
                    calendarApi: props.calendarApi,
                    dispatch: this.dispatch,
                    emitter: emitter,
                    getCurrentData: this.getCurrentData
                };
                var currentDate = state.currentDate, dateProfile = state.dateProfile;
                if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
                currentDate = $25f9ba4cb990a500$var$reduceCurrentDate(currentDate, action);
                dateProfile = $25f9ba4cb990a500$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
                if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
                action.type === 'NEXT' || // "
                !(0, $4r1TJ.G)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
                var eventSources = $25f9ba4cb990a500$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
                var eventStore = (0, $4r1TJ.I)(state.eventStore, action, eventSources, dateProfile, calendarContext);
                var isEventsLoading = $25f9ba4cb990a500$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
                var renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
                var _this_buildViewUiProps = this.buildViewUiProps(calendarContext), eventUiSingleBase = _this_buildViewUiProps.eventUiSingleBase, selectionConfig = _this_buildViewUiProps.selectionConfig; // will memoize obj
                var eventUiBySource = this.buildEventUiBySource(eventSources);
                var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
                var newState = {
                    dynamicOptionOverrides: dynamicOptionOverrides,
                    currentViewType: currentViewType,
                    currentDate: currentDate,
                    dateProfile: dateProfile,
                    eventSources: eventSources,
                    eventStore: eventStore,
                    renderableEventStore: renderableEventStore,
                    selectionConfig: selectionConfig,
                    eventUiBases: eventUiBases,
                    businessHours: this.parseContextBusinessHours(calendarContext),
                    dateSelection: $25f9ba4cb990a500$var$reduceDateSelection(state.dateSelection, action),
                    eventSelection: $25f9ba4cb990a500$var$reduceSelectedEvent(state.eventSelection, action),
                    eventDrag: $25f9ba4cb990a500$var$reduceEventDrag(state.eventDrag, action),
                    eventResize: $25f9ba4cb990a500$var$reduceEventResize(state.eventResize, action)
                };
                var contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = optionsData.pluginHooks.reducers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var reducer = _step.value;
                        Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var wasLoading = $25f9ba4cb990a500$var$computeIsLoading(state, calendarContext);
                var isLoading = $25f9ba4cb990a500$var$computeIsLoading(newState, calendarContext);
                // TODO: use propSetHandlers in plugin system
                if (!wasLoading && isLoading) emitter.trigger('loading', true);
                else if (wasLoading && !isLoading) emitter.trigger('loading', false);
                this.state = newState;
                if (props.onAction) props.onAction(action);
            }
        },
        {
            key: "updateData",
            value: function updateData() {
                var _this = this, props = _this.props, state = _this.state;
                var oldData = this.data;
                var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
                var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
                var data = this.data = Object.assign(Object.assign(Object.assign({
                    nowManager: this.nowManager,
                    viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
                    calendarApi: props.calendarApi,
                    dispatch: this.dispatch,
                    emitter: this.emitter,
                    getCurrentData: this.getCurrentData
                }, optionsData), currentViewData), state);
                var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
                var oldCalendarOptions = oldData && oldData.calendarOptions;
                var newCalendarOptions = optionsData.calendarOptions;
                if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
                    if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                        // hack
                        state.eventSources = data.eventSources = $25f9ba4cb990a500$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                        state.eventStore = data.eventStore = (0, $4r1TJ.J)(data.eventStore, oldData.dateEnv, data.dateEnv);
                        state.renderableEventStore = data.renderableEventStore = (0, $4r1TJ.J)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
                    }
                    for(var optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
                }
                this.optionsForHandling = [];
                if (props.onData) props.onData(data);
            }
        },
        {
            key: "computeOptionsData",
            value: function computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
                // TODO: blacklist options that are handled by optionChangeHandlers
                if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
                var _this_processRawCalendarOptions = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _this_processRawCalendarOptions.refinedOptions, pluginHooks = _this_processRawCalendarOptions.pluginHooks, localeDefaults = _this_processRawCalendarOptions.localeDefaults, availableLocaleData = _this_processRawCalendarOptions.availableLocaleData, extra = _this_processRawCalendarOptions.extra;
                $25f9ba4cb990a500$var$warnUnknownOptions(extra);
                var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
                var viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
                var theme = this.buildTheme(refinedOptions, pluginHooks);
                var toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
                return this.stableCalendarOptionsData = {
                    calendarOptions: refinedOptions,
                    pluginHooks: pluginHooks,
                    dateEnv: dateEnv,
                    viewSpecs: viewSpecs,
                    theme: theme,
                    toolbarConfig: toolbarConfig,
                    localeDefaults: localeDefaults,
                    availableRawLocales: availableLocaleData.map
                };
            }
        },
        {
            // always called from behind a memoizer
            key: "processRawCalendarOptions",
            value: function processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
                var _this_optionsForHandling;
                var _mergeRawOptions = (0, $4r1TJ.K)([
                    (0, $4r1TJ.e),
                    optionOverrides,
                    dynamicOptionOverrides
                ]), locales = _mergeRawOptions.locales, locale = _mergeRawOptions.locale;
                var availableLocaleData = this.organizeRawLocales(locales);
                var availableRawLocales = availableLocaleData.map;
                var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
                var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $25f9ba4cb990a500$export$905153d94e0757fa);
                var refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4r1TJ.L)), (0, $4r1TJ.M)), (0, $4r1TJ.N)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
                var extra = {};
                var raw = (0, $4r1TJ.K)([
                    (0, $4r1TJ.e),
                    localeDefaults,
                    optionOverrides,
                    dynamicOptionOverrides
                ]);
                var refined = {};
                var currentRaw = this.currentCalendarOptionsInput;
                var currentRefined = this.currentCalendarOptionsRefined;
                var anyChanges = false;
                for(var optionName in raw){
                    if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $4r1TJ.O)[optionName] && optionName in currentRaw && (0, $4r1TJ.O)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
                    else if (refiners[optionName]) {
                        refined[optionName] = refiners[optionName](raw[optionName]);
                        anyChanges = true;
                    } else extra[optionName] = currentRaw[optionName];
                }
                if (anyChanges) {
                    this.currentCalendarOptionsInput = raw;
                    this.currentCalendarOptionsRefined = refined;
                    this.stableOptionOverrides = optionOverrides;
                    this.stableDynamicOptionOverrides = dynamicOptionOverrides;
                }
                (_this_optionsForHandling = this.optionsForHandling).push.apply(_this_optionsForHandling, (0, $hvZMf._)(this.optionsForRefining));
                this.optionsForRefining = [];
                return {
                    rawOptions: this.currentCalendarOptionsInput,
                    refinedOptions: this.currentCalendarOptionsRefined,
                    pluginHooks: pluginHooks,
                    availableLocaleData: availableLocaleData,
                    localeDefaults: localeDefaults,
                    extra: extra
                };
            }
        },
        {
            key: "_computeCurrentViewData",
            value: function _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
                var viewSpec = optionsData.viewSpecs[viewType];
                if (!viewSpec) throw new Error('viewType "'.concat(viewType, "\" is not available. Please make sure you've loaded all neccessary plugins"));
                var _this_processRawViewOptions = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _this_processRawViewOptions.refinedOptions, extra = _this_processRawViewOptions.extra;
                $25f9ba4cb990a500$var$warnUnknownOptions(extra);
                this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
                var dateProfileGenerator = this.buildDateProfileGenerator({
                    dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
                    nowManager: this.nowManager,
                    duration: viewSpec.duration,
                    durationUnit: viewSpec.durationUnit,
                    usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
                    dateEnv: optionsData.dateEnv,
                    calendarApi: this.props.calendarApi,
                    slotMinTime: refinedOptions.slotMinTime,
                    slotMaxTime: refinedOptions.slotMaxTime,
                    showNonCurrentDates: refinedOptions.showNonCurrentDates,
                    dayCount: refinedOptions.dayCount,
                    dateAlignment: refinedOptions.dateAlignment,
                    dateIncrement: refinedOptions.dateIncrement,
                    hiddenDays: refinedOptions.hiddenDays,
                    weekends: refinedOptions.weekends,
                    validRangeInput: refinedOptions.validRange,
                    visibleRangeInput: refinedOptions.visibleRange,
                    fixedWeekCount: refinedOptions.fixedWeekCount
                });
                var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
                return {
                    viewSpec: viewSpec,
                    options: refinedOptions,
                    dateProfileGenerator: dateProfileGenerator,
                    viewApi: viewApi
                };
            }
        },
        {
            key: "processRawViewOptions",
            value: function processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
                var raw = (0, $4r1TJ.K)([
                    (0, $4r1TJ.e),
                    viewSpec.optionDefaults,
                    localeDefaults,
                    optionOverrides,
                    viewSpec.optionOverrides,
                    dynamicOptionOverrides
                ]);
                var refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4r1TJ.L)), (0, $4r1TJ.M)), (0, $4r1TJ.N)), (0, $4r1TJ.P)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
                var refined = {};
                var currentRaw = this.currentViewOptionsInput;
                var currentRefined = this.currentViewOptionsRefined;
                var anyChanges = false;
                var extra = {};
                for(var optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $4r1TJ.O)[optionName] && (0, $4r1TJ.O)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
                else {
                    if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $4r1TJ.O)[optionName] && (0, $4r1TJ.O)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                        if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
                    } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
                    else extra[optionName] = raw[optionName];
                    anyChanges = true;
                }
                if (anyChanges) {
                    this.currentViewOptionsInput = raw;
                    this.currentViewOptionsRefined = refined;
                }
                return {
                    rawOptions: this.currentViewOptionsInput,
                    refinedOptions: this.currentViewOptionsRefined,
                    extra: extra
                };
            }
        }
    ]);
    return CalendarDataManager;
}();
function $25f9ba4cb990a500$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    var locale = $25f9ba4cb990a500$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $4r1TJ.Q)({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $25f9ba4cb990a500$var$buildTheme(options, pluginHooks) {
    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $25f9ba4cb990a500$var$StandardTheme;
    return new ThemeClass(options);
}
function $25f9ba4cb990a500$var$buildDateProfileGenerator(props) {
    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $4r1TJ.R);
    return new DateProfileGeneratorClass(props);
}
function $25f9ba4cb990a500$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $25f9ba4cb990a500$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $25f9ba4cb990a500$var$buildEventUiBySource(eventSources) {
    return (0, $4r1TJ.a)(eventSources, function(eventSource) {
        return eventSource.ui;
    });
}
function $25f9ba4cb990a500$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    var eventUiBases = {
        '': eventUiSingleBase
    };
    for(var defId in eventDefs){
        var def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $25f9ba4cb990a500$var$buildViewUiProps(calendarContext) {
    var options = calendarContext.options;
    return {
        eventUiSingleBase: (0, $4r1TJ.S)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $4r1TJ.S)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $25f9ba4cb990a500$var$computeIsLoading(state, context) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = context.pluginHooks.isLoadingFuncs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var isLoadingFunc = _step.value;
            if (isLoadingFunc(state)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $25f9ba4cb990a500$var$parseContextBusinessHours(calendarContext) {
    return (0, $4r1TJ.U)(calendarContext.options.businessHours, calendarContext);
}
function $25f9ba4cb990a500$var$warnUnknownOptions(options, viewName) {
    for(var optionName in options)console.warn("Unknown option '".concat(optionName, "'") + (viewName ? " for view '".concat(viewName, "'") : ''));
}
var $25f9ba4cb990a500$var$ToolbarSection = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(ToolbarSection, BaseComponent);
    function ToolbarSection() {
        (0, $8MSeJ._)(this, ToolbarSection);
        return (0, $4v96Q._)(this, ToolbarSection, arguments);
    }
    (0, $gia3M._)(ToolbarSection, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var children = this.props.widgetGroups.map(function(widgetGroup) {
                    return _this.renderWidgetGroup(widgetGroup);
                });
                return (0, $kG1qx.createElement).apply(void 0, [
                    'div',
                    {
                        className: 'fc-toolbar-chunk'
                    }
                ].concat((0, $hvZMf._)(children)));
            }
        },
        {
            key: "renderWidgetGroup",
            value: function renderWidgetGroup(widgetGroup) {
                var props = this.props;
                var theme = this.context.theme;
                var children = [];
                var isOnlyButtons = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = widgetGroup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var widget = _step.value;
                        var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon, buttonHint = widget.buttonHint;
                        if (buttonName === 'title') {
                            isOnlyButtons = false;
                            children.push((0, $kG1qx.createElement)("h2", {
                                className: "fc-toolbar-title",
                                id: props.titleId
                            }, props.title));
                        } else {
                            var isPressed = buttonName === props.activeButton;
                            var isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                            var buttonClasses = [
                                "fc-".concat(buttonName, "-button"),
                                theme.getClass('button')
                            ];
                            if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                            children.push((0, $kG1qx.createElement)("button", {
                                type: "button",
                                title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                                disabled: isDisabled,
                                "aria-pressed": isPressed,
                                className: buttonClasses.join(' '),
                                onClick: buttonClick
                            }, buttonText || (buttonIcon ? (0, $kG1qx.createElement)("span", {
                                className: buttonIcon,
                                role: "img"
                            }) : '')));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (children.length > 1) {
                    var groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
                    return (0, $kG1qx.createElement).apply(void 0, [
                        'div',
                        {
                            className: groupClassName
                        }
                    ].concat((0, $hvZMf._)(children)));
                }
                return children[0];
            }
        }
    ]);
    return ToolbarSection;
}((0, $4r1TJ.B));
var $25f9ba4cb990a500$var$Toolbar = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(Toolbar, BaseComponent);
    function Toolbar() {
        (0, $8MSeJ._)(this, Toolbar);
        return (0, $4v96Q._)(this, Toolbar, arguments);
    }
    (0, $gia3M._)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, model = _this_props.model, extraClassName = _this_props.extraClassName;
                var forceLtr = false;
                var startContent;
                var endContent;
                var sectionWidgets = model.sectionWidgets;
                var centerContent = sectionWidgets.center;
                if (sectionWidgets.left) {
                    forceLtr = true;
                    startContent = sectionWidgets.left;
                } else startContent = sectionWidgets.start;
                if (sectionWidgets.right) {
                    forceLtr = true;
                    endContent = sectionWidgets.right;
                } else endContent = sectionWidgets.end;
                var classNames = [
                    extraClassName || '',
                    'fc-toolbar',
                    forceLtr ? 'fc-toolbar-ltr' : ''
                ];
                return (0, $kG1qx.createElement)("div", {
                    className: classNames.join(' ')
                }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
            }
        },
        {
            key: "renderSection",
            value: function renderSection(key, widgetGroups) {
                var props = this.props;
                return (0, $kG1qx.createElement)($25f9ba4cb990a500$var$ToolbarSection, {
                    key: key,
                    widgetGroups: widgetGroups,
                    title: props.title,
                    navUnit: props.navUnit,
                    activeButton: props.activeButton,
                    isTodayEnabled: props.isTodayEnabled,
                    isPrevEnabled: props.isPrevEnabled,
                    isNextEnabled: props.isNextEnabled,
                    titleId: props.titleId
                });
            }
        }
    ]);
    return Toolbar;
}((0, $4r1TJ.B));
var $25f9ba4cb990a500$var$ViewHarness = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $9i7pb._)(ViewHarness, BaseComponent);
    function ViewHarness() {
        (0, $8MSeJ._)(this, ViewHarness);
        var _this;
        _this = (0, $4v96Q._)(this, ViewHarness, arguments);
        _this.state = {
            availableWidth: null
        };
        _this.handleEl = function(el) {
            _this.el = el;
            (0, $4r1TJ.W)(_this.props.elRef, el);
            _this.updateAvailableWidth();
        };
        _this.handleResize = function() {
            _this.updateAvailableWidth();
        };
        return _this;
    }
    (0, $gia3M._)(ViewHarness, [
        {
            key: "render",
            value: function render() {
                var _this = this, props = _this.props, state = _this.state;
                var aspectRatio = props.aspectRatio;
                var classNames = [
                    'fc-view-harness',
                    aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' // harness controls the height
                     : 'fc-view-harness-passive'
                ];
                var height = '';
                var paddingBottom = '';
                if (aspectRatio) {
                    if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
                    else // while waiting to know availableWidth, we can't set height to *zero*
                    // because will cause lots of unnecessary scrollbars within scrollgrid.
                    // BETTER: don't start rendering ANYTHING yet until we know container width
                    // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
                    paddingBottom = "".concat(1 / aspectRatio * 100, "%");
                } else height = props.height || '';
                return (0, $kG1qx.createElement)("div", {
                    "aria-labelledby": props.labeledById,
                    ref: this.handleEl,
                    className: classNames.join(' '),
                    style: {
                        height: height,
                        paddingBottom: paddingBottom
                    }
                }, props.children);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.context.addResizeHandler(this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.context.removeResizeHandler(this.handleResize);
            }
        },
        {
            key: "updateAvailableWidth",
            value: function updateAvailableWidth() {
                if (this.el && // needed. but why?
                this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
                ) this.setState({
                    availableWidth: this.el.offsetWidth
                });
            }
        }
    ]);
    return ViewHarness;
}((0, $4r1TJ.B));
/*
Detects when the user clicks on an event within a DateComponent
*/ var $25f9ba4cb990a500$var$EventClicking = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $9i7pb._)(EventClicking, Interaction);
    function EventClicking(settings) {
        (0, $8MSeJ._)(this, EventClicking);
        var _this;
        _this = (0, $4v96Q._)(this, EventClicking, [
            settings
        ]);
        _this.handleSegClick = function(ev, segEl) {
            var component = _this.component;
            var context = component.context;
            var seg = (0, $4r1TJ.Y)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                var hasUrlContainer = (0, $4r1TJ.Z)(ev.target, '.fc-event-forced-url');
                var url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new (0, $4r1TJ._)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        _this.destroy = (0, $4r1TJ.$)(settings.el, 'click', '.fc-event', _this.handleSegClick);
        return _this;
    }
    return EventClicking;
}((0, $4r1TJ.X));
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ var $25f9ba4cb990a500$var$EventHovering = /*#__PURE__*/ function(Interaction) {
    "use strict";
    (0, $9i7pb._)(EventHovering, Interaction);
    function EventHovering(settings) {
        (0, $8MSeJ._)(this, EventHovering);
        var _this;
        _this = (0, $4v96Q._)(this, EventHovering, [
            settings
        ]);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        _this.handleEventElRemove = function(el) {
            if (el === _this.currentSegEl) _this.handleSegLeave(null, _this.currentSegEl);
        };
        _this.handleSegEnter = function(ev, segEl) {
            if ((0, $4r1TJ.Y)(segEl)) {
                _this.currentSegEl = segEl;
                _this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        _this.handleSegLeave = function(ev, segEl) {
            if (_this.currentSegEl) {
                _this.currentSegEl = null;
                _this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        _this.removeHoverListeners = (0, $4r1TJ.a0)(settings.el, '.fc-event', _this.handleSegEnter, _this.handleSegLeave);
        return _this;
    }
    (0, $gia3M._)(EventHovering, [
        {
            key: "destroy",
            value: function destroy() {
                this.removeHoverListeners();
            }
        },
        {
            key: "triggerEvent",
            value: function triggerEvent(publicEvName, ev, segEl) {
                var component = this.component;
                var context = component.context;
                var seg = (0, $4r1TJ.Y)(segEl);
                if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
                    el: segEl,
                    event: new (0, $4r1TJ._)(context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
            }
        }
    ]);
    return EventHovering;
}((0, $4r1TJ.X));
var $25f9ba4cb990a500$var$CalendarContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0, $9i7pb._)(CalendarContent, PureComponent);
    function CalendarContent() {
        (0, $8MSeJ._)(this, CalendarContent);
        var _this;
        _this = (0, $4v96Q._)(this, CalendarContent, arguments);
        _this.buildViewContext = (0, $4r1TJ.z)((0, $4r1TJ.a2));
        _this.buildViewPropTransformers = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildViewPropTransformers);
        _this.buildToolbarProps = (0, $4r1TJ.z)($25f9ba4cb990a500$var$buildToolbarProps);
        _this.headerRef = (0, $kG1qx.createRef)();
        _this.footerRef = (0, $kG1qx.createRef)();
        _this.interactionsStore = {};
        // eslint-disable-next-line
        _this.state = {
            viewLabelId: (0, $4r1TJ.a3)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        _this.registerInteractiveComponent = function(component, settingsInput) {
            var settings = (0, $4r1TJ.a4)(component, settingsInput);
            var DEFAULT_INTERACTIONS = [
                $25f9ba4cb990a500$var$EventClicking,
                $25f9ba4cb990a500$var$EventHovering
            ];
            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
            var interactions = interactionClasses.map(function(TheInteractionClass) {
                return new TheInteractionClass(settings);
            });
            _this.interactionsStore[component.uid] = interactions;
            (0, $4r1TJ.a5)[component.uid] = settings;
        };
        _this.unregisterInteractiveComponent = function(component) {
            var listeners = _this.interactionsStore[component.uid];
            if (listeners) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                delete _this.interactionsStore[component.uid];
            }
            delete (0, $4r1TJ.a5)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        _this.resizeRunner = new (0, $4r1TJ.D)(function() {
            _this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            _this.props.emitter.trigger('windowResize', {
                view: _this.props.viewApi
            });
        });
        _this.handleWindowResize = function(ev) {
            var options = _this.props.options;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) _this.resizeRunner.request(options.windowResizeDelay);
        };
        return _this;
    }
    (0, $gia3M._)(CalendarContent, [
        {
            /*
    renders INSIDE of an outer div
    */ key: "render",
            value: function render() {
                var _this = this;
                var props = this.props;
                var toolbarConfig = props.toolbarConfig, options = props.options;
                var viewVGrow = false;
                var viewHeight = '';
                var viewAspectRatio;
                if (props.isHeightAuto || props.forPrint) viewHeight = '';
                else if (options.height != null) viewVGrow = true;
                else if (options.contentHeight != null) viewHeight = options.contentHeight;
                else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
                var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
                var viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
                return (0, $kG1qx.createElement)((0, $4r1TJ.V).Provider, {
                    value: viewContext
                }, (0, $kG1qx.createElement)((0, $4r1TJ.a6), {
                    unit: "day"
                }, function(nowDate) {
                    var toolbarProps = _this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
                    return (0, $kG1qx.createElement)((0, $kG1qx.Fragment), null, toolbarConfig.header && (0, $kG1qx.createElement)($25f9ba4cb990a500$var$Toolbar, Object.assign({
                        ref: _this.headerRef,
                        extraClassName: "fc-header-toolbar",
                        model: toolbarConfig.header,
                        titleId: viewLabelId
                    }, toolbarProps)), (0, $kG1qx.createElement)($25f9ba4cb990a500$var$ViewHarness, {
                        liquid: viewVGrow,
                        height: viewHeight,
                        aspectRatio: viewAspectRatio,
                        labeledById: viewLabelId
                    }, _this.renderView(props), _this.buildAppendContent()), toolbarConfig.footer && (0, $kG1qx.createElement)($25f9ba4cb990a500$var$Toolbar, Object.assign({
                        ref: _this.footerRef,
                        extraClassName: "fc-footer-toolbar",
                        model: toolbarConfig.footer,
                        titleId: ""
                    }, toolbarProps)));
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var props = this.props;
                this.calendarInteractions = props.pluginHooks.calendarInteractions.map(function(CalendarInteractionClass) {
                    return new CalendarInteractionClass(props);
                });
                window.addEventListener('resize', this.handleWindowResize);
                var propSetHandlers = props.pluginHooks.propSetHandlers;
                for(var propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var props = this.props;
                var propSetHandlers = props.pluginHooks.propSetHandlers;
                for(var propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this.handleWindowResize);
                this.resizeRunner.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.calendarInteractions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var interaction = _step.value;
                        interaction.destroy();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.props.emitter.trigger('_unmount');
            }
        },
        {
            key: "buildAppendContent",
            value: function buildAppendContent() {
                var props = this.props;
                var children = props.pluginHooks.viewContainerAppends.map(function(buildAppendContent) {
                    return buildAppendContent(props);
                });
                return (0, $kG1qx.createElement).apply(void 0, [
                    (0, $kG1qx.Fragment),
                    {}
                ].concat((0, $hvZMf._)(children)));
            }
        },
        {
            key: "renderView",
            value: function renderView(props) {
                var pluginHooks = props.pluginHooks;
                var viewSpec = props.viewSpec;
                var viewProps = {
                    dateProfile: props.dateProfile,
                    businessHours: props.businessHours,
                    eventStore: props.renderableEventStore,
                    eventUiBases: props.eventUiBases,
                    dateSelection: props.dateSelection,
                    eventSelection: props.eventSelection,
                    eventDrag: props.eventDrag,
                    eventResize: props.eventResize,
                    isHeightAuto: props.isHeightAuto,
                    forPrint: props.forPrint
                };
                var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = transformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var transformer = _step.value;
                        Object.assign(viewProps, transformer.transform(viewProps, props));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var ViewComponent = viewSpec.component;
                return (0, $kG1qx.createElement)(ViewComponent, Object.assign({}, viewProps));
            }
        }
    ]);
    return CalendarContent;
}((0, $4r1TJ.a1));
function $25f9ba4cb990a500$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $4r1TJ.G)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $25f9ba4cb990a500$var$buildViewPropTransformers(theClasses) {
    return theClasses.map(function(TheClass) {
        return new TheClass();
    });
}
var $25f9ba4cb990a500$export$e1aef45b828286de = /*#__PURE__*/ function(CalendarImpl) {
    "use strict";
    (0, $9i7pb._)(Calendar, CalendarImpl);
    function Calendar(el) {
        var optionOverrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $8MSeJ._)(this, Calendar);
        var _this;
        _this = (0, $4v96Q._)(this, Calendar);
        _this.isRendering = false;
        _this.isRendered = false;
        _this.currentClassNames = [];
        _this.customContentRenderId = 0;
        _this.handleAction = function(action) {
            // actions we know we want to render immediately
            switch(action.type){
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    _this.renderRunner.tryDrain();
            }
        };
        _this.handleData = function(data) {
            _this.currentData = data;
            _this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        _this.handleRenderRequest = function() {
            if (_this.isRendering) {
                _this.isRendered = true;
                var currentData = _this.currentData;
                (0, $4r1TJ.a8)(function() {
                    (0, $kG1qx.render)((0, $kG1qx.createElement)((0, $4r1TJ.a9), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, function(classNames, height, isHeightAuto, forPrint) {
                        _this.setClassNames(classNames);
                        _this.setHeight(height);
                        return (0, $kG1qx.createElement)((0, $4r1TJ.aa).Provider, {
                            value: _this.customContentRenderId
                        }, (0, $kG1qx.createElement)($25f9ba4cb990a500$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), _this.el);
                });
            } else if (_this.isRendered) {
                _this.isRendered = false;
                (0, $kG1qx.render)(null, _this.el);
                _this.setClassNames([]);
                _this.setHeight('');
            }
        };
        (0, $4r1TJ.ab)(el);
        _this.el = el;
        _this.renderRunner = new (0, $4r1TJ.D)(_this.handleRenderRequest);
        new $25f9ba4cb990a500$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: _this,
            onAction: _this.handleAction,
            onData: _this.handleData
        });
        return _this;
    }
    (0, $gia3M._)(Calendar, [
        {
            key: "render",
            value: function render() {
                var wasRendering = this.isRendering;
                if (!wasRendering) this.isRendering = true;
                else this.customContentRenderId += 1;
                this.renderRunner.request();
                if (wasRendering) this.updateSize();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.isRendering) {
                    this.isRendering = false;
                    this.renderRunner.request();
                }
            }
        },
        {
            key: "updateSize",
            value: function updateSize() {
                var _this = this;
                (0, $4r1TJ.a8)(function() {
                    (0, $bFyls._)((0, $TCtnO._)(Calendar.prototype), "updateSize", _this).call(_this);
                });
            }
        },
        {
            key: "batchRendering",
            value: function batchRendering(func) {
                this.renderRunner.pause('batchRendering');
                func();
                this.renderRunner.resume('batchRendering');
            }
        },
        {
            key: "pauseRendering",
            value: function pauseRendering() {
                this.renderRunner.pause('pauseRendering');
            }
        },
        {
            key: "resumeRendering",
            value: function resumeRendering() {
                this.renderRunner.resume('pauseRendering', true);
            }
        },
        {
            key: "resetOptions",
            value: function resetOptions(optionOverrides, changedOptionNames) {
                this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
            }
        },
        {
            key: "setClassNames",
            value: function setClassNames(classNames) {
                if (!(0, $4r1TJ.i)(classNames, this.currentClassNames)) {
                    var classList = this.el.classList;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.currentClassNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var className = _step.value;
                            classList.remove(className);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = classNames[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var className1 = _step1.value;
                            classList.add(className1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    this.currentClassNames = classNames;
                }
            }
        },
        {
            key: "setHeight",
            value: function setHeight(height) {
                (0, $4r1TJ.ac)(this.el, 'height', height);
            }
        }
    ]);
    return Calendar;
}((0, $4r1TJ.a7));
function $25f9ba4cb990a500$export$3ae94a2503e890a1(dateInput) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var dateEnv = $25f9ba4cb990a500$var$buildDateEnv(options);
    var formatter = (0, $4r1TJ.x)(options);
    var dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return '';
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $25f9ba4cb990a500$export$9b1080e2eec9158(startInput, endInput, options) {
    var dateEnv = $25f9ba4cb990a500$var$buildDateEnv((typeof options === "undefined" ? "undefined" : (0, $1PKUs._)(options)) === 'object' && options ? options : {}); // pass in if non-null object
    var formatter = (0, $4r1TJ.x)(options);
    var startMeta = dateEnv.createMarkerMeta(startInput);
    var endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return '';
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $4r1TJ.e).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $25f9ba4cb990a500$var$buildDateEnv(settings) {
    var locale = $25f9ba4cb990a500$var$buildLocale(settings.locale || 'en', $25f9ba4cb990a500$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $4r1TJ.Q)(Object.assign(Object.assign({
        timeZone: (0, $4r1TJ.e).timeZone,
        calendarSystem: 'gregory'
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $25f9ba4cb990a500$export$3b384895d0cca0f2(props, allDay) {
    return (0, $4r1TJ.ad)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
var $25f9ba4cb990a500$export$83d89fbfd8236492 = '6.1.19';




var $eBaMo = parcelRequire("eBaMo");


var $aabea1e3bd51b0bd$export$2e2bcd8739ae039 = (0, $25f9ba4cb990a500$export$ae829ec7b2625219)({
    name: '@fullcalendar/daygrid',
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: (0, $eBaMo.DayGridView),
            dateProfileGeneratorClass: (0, $eBaMo.TableDateProfileGenerator)
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: 'dayGrid',
            duration: {
                years: 1
            }
        }
    }
});



var $LCZef = parcelRequire("LCZef");
var $3bd4c1f45bee2ae9$var$_document_querySelector;
var $3bd4c1f45bee2ae9$var$debounce = null;
var $3bd4c1f45bee2ae9$var$calendarElement = document.getElementById('calendar');
var $3bd4c1f45bee2ae9$var$_document_querySelector_content;
var $3bd4c1f45bee2ae9$var$pageId = ($3bd4c1f45bee2ae9$var$_document_querySelector_content = ($3bd4c1f45bee2ae9$var$_document_querySelector = document.querySelector('meta[name=pageID]')) === null || $3bd4c1f45bee2ae9$var$_document_querySelector === void 0 ? void 0 : $3bd4c1f45bee2ae9$var$_document_querySelector.content) !== null && $3bd4c1f45bee2ae9$var$_document_querySelector_content !== void 0 ? $3bd4c1f45bee2ae9$var$_document_querySelector_content : '';
var $3bd4c1f45bee2ae9$var$listView = document.getElementById('listViewEvents');
var $3bd4c1f45bee2ae9$var$calendarView = document.getElementById('calendarViewEvents');
var $3bd4c1f45bee2ae9$var$calendarViewTypeFilterContainer = document.getElementById('calendarViewTypeFilter');
var $3bd4c1f45bee2ae9$var$listViewTypeFilterContainer = document.getElementById('listViewTypeFilter');
var $3bd4c1f45bee2ae9$var$listViewYearFilterContainer = document.getElementById('listViewYearFilter');
var $3bd4c1f45bee2ae9$var$calendarViewTypeFilter = document.querySelector('#calendarViewTypeFilter select');
var $3bd4c1f45bee2ae9$var$viewToggleContainer = document.querySelector('.filters-events .toggle-view');
var $3bd4c1f45bee2ae9$var$calendar = null;
if ($3bd4c1f45bee2ae9$var$calendarElement) {
    $3bd4c1f45bee2ae9$var$calendar = new (0, $25f9ba4cb990a500$export$e1aef45b828286de)($3bd4c1f45bee2ae9$var$calendarElement, {
        initialView: 'dayGridMonth',
        headerToolbar: {
            end: 'today prevYear prev next nextYear'
        },
        events: function(info, success, failure) {
            if ($3bd4c1f45bee2ae9$var$debounce) clearTimeout($3bd4c1f45bee2ae9$var$debounce);
            $3bd4c1f45bee2ae9$var$debounce = setTimeout(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $k1CNB._)(function() {
                    var _calendarElement_dataset, _calendarElement_dataset_endpoint, url, response, data, fcLinks, e;
                    return (0, $9qD8b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = new URL("".concat(window.location.origin).concat((_calendarElement_dataset_endpoint = (_calendarElement_dataset = $3bd4c1f45bee2ae9$var$calendarElement.dataset) === null || _calendarElement_dataset === void 0 ? void 0 : _calendarElement_dataset.endpoint) !== null && _calendarElement_dataset_endpoint !== void 0 ? _calendarElement_dataset_endpoint : ''));
                                url.searchParams.append('pageId', $3bd4c1f45bee2ae9$var$pageId);
                                url.searchParams.append('start', info.startStr);
                                url.searchParams.append('end', info.endStr);
                                if ($3bd4c1f45bee2ae9$var$calendarViewTypeFilter && $3bd4c1f45bee2ae9$var$calendarViewTypeFilter.value) url.searchParams.append('type', $3bd4c1f45bee2ae9$var$calendarViewTypeFilter.value);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    fetch(url.href, {
                                        method: 'GET'
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                if (!((response === null || response === void 0 ? void 0 : response.status) === 200)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                success(data);
                                fcLinks = document.querySelectorAll('.fc-more-link');
                                fcLinks.forEach(function(fcLink) {
                                    return fcLink.addEventListener('click', $3bd4c1f45bee2ae9$var$handleFcMoreClick);
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                failure(new Error('Failed to load events'));
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                failure(new Error('Failed to load events'));
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }, 200);
        },
        eventBackgroundColor: "#FAFAFA",
        eventBorderColor: "#BBB",
        eventTextColor: "#176272",
        eventDisplay: "block",
        displayEventTime: true,
        displayEventEnd: true,
        eventTimeFormat: {
            hour: "numeric",
            minute: "2-digit",
            meridiem: true
        },
        contentHeight: "auto",
        dayMaxEvents: 3,
        plugins: [
            (0, $aabea1e3bd51b0bd$export$2e2bcd8739ae039)
        ]
    });
    $3bd4c1f45bee2ae9$var$calendarViewTypeFilter === null || $3bd4c1f45bee2ae9$var$calendarViewTypeFilter === void 0 ? void 0 : $3bd4c1f45bee2ae9$var$calendarViewTypeFilter.addEventListener('change', function() {
        $3bd4c1f45bee2ae9$var$calendar === null || $3bd4c1f45bee2ae9$var$calendar === void 0 ? void 0 : $3bd4c1f45bee2ae9$var$calendar.refetchEvents();
    });
}
if ($3bd4c1f45bee2ae9$var$viewToggleContainer && $3bd4c1f45bee2ae9$var$listView && $3bd4c1f45bee2ae9$var$calendarView) {
    var $3bd4c1f45bee2ae9$var$listViewToggle = $3bd4c1f45bee2ae9$var$viewToggleContainer.querySelector('button:first-of-type');
    var $3bd4c1f45bee2ae9$var$calendarViewToggle = $3bd4c1f45bee2ae9$var$viewToggleContainer.querySelector('button:last-of-type');
    if ($3bd4c1f45bee2ae9$var$listViewToggle && $3bd4c1f45bee2ae9$var$calendarViewToggle) window.addEventListener('resize', function() {
        if (window.innerWidth < 767 && window.getComputedStyle($3bd4c1f45bee2ae9$var$calendarView).display !== 'none') {
            $3bd4c1f45bee2ae9$var$listViewToggle.ariaExpanded = 'true';
            $3bd4c1f45bee2ae9$var$listViewToggle.classList.add('on');
            $3bd4c1f45bee2ae9$var$calendarViewToggle.ariaExpanded = 'false';
            $3bd4c1f45bee2ae9$var$calendarViewToggle.classList.remove('on');
            (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$calendarView);
            (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$calendarViewTypeFilterContainer);
            (0, $LCZef.show)($3bd4c1f45bee2ae9$var$listViewTypeFilterContainer);
            (0, $LCZef.show)($3bd4c1f45bee2ae9$var$listViewYearFilterContainer);
            (0, $LCZef.show)($3bd4c1f45bee2ae9$var$listView);
            document.documentElement.style.removeProperty('overflow-y');
        }
    });
    if ($3bd4c1f45bee2ae9$var$calendarViewToggle && $3bd4c1f45bee2ae9$var$listViewToggle) {
        $3bd4c1f45bee2ae9$var$calendarViewToggle === null || $3bd4c1f45bee2ae9$var$calendarViewToggle === void 0 ? void 0 : $3bd4c1f45bee2ae9$var$calendarViewToggle.addEventListener('click', function() {
            if ($3bd4c1f45bee2ae9$var$calendarViewToggle.ariaExpanded !== 'true') {
                $3bd4c1f45bee2ae9$var$calendarViewToggle.ariaExpanded = 'true';
                $3bd4c1f45bee2ae9$var$calendarViewToggle.classList.add('on');
                $3bd4c1f45bee2ae9$var$listViewToggle.ariaExpanded = 'false';
                $3bd4c1f45bee2ae9$var$listViewToggle.classList.remove('on');
                (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$listView);
                (0, $LCZef.show)($3bd4c1f45bee2ae9$var$calendarView);
                $3bd4c1f45bee2ae9$var$calendar === null || $3bd4c1f45bee2ae9$var$calendar === void 0 ? void 0 : $3bd4c1f45bee2ae9$var$calendar.render();
                document.documentElement.style.overflowY = 'visible';
                (0, $LCZef.show)($3bd4c1f45bee2ae9$var$calendarViewTypeFilterContainer);
                (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$listViewTypeFilterContainer);
                (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$listViewYearFilterContainer);
                document.querySelectorAll('.fc-more-link').forEach(function(fcLink) {
                    fcLink.removeEventListener('click', $3bd4c1f45bee2ae9$var$handleFcMoreClick);
                    fcLink.addEventListener('click', $3bd4c1f45bee2ae9$var$handleFcMoreClick);
                });
            }
        });
        $3bd4c1f45bee2ae9$var$listViewToggle === null || $3bd4c1f45bee2ae9$var$listViewToggle === void 0 ? void 0 : $3bd4c1f45bee2ae9$var$listViewToggle.addEventListener('click', function() {
            if ($3bd4c1f45bee2ae9$var$listViewToggle.ariaExpanded !== 'true') {
                $3bd4c1f45bee2ae9$var$listViewToggle.ariaExpanded = 'true';
                $3bd4c1f45bee2ae9$var$listViewToggle.classList.add('on');
                $3bd4c1f45bee2ae9$var$calendarViewToggle.ariaExpanded = 'false';
                $3bd4c1f45bee2ae9$var$calendarViewToggle.classList.remove('on');
                (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$calendarView);
                (0, $LCZef.show)($3bd4c1f45bee2ae9$var$listView);
                document.documentElement.style.removeProperty('overflow-y');
                (0, $LCZef.hide)($3bd4c1f45bee2ae9$var$calendarViewTypeFilterContainer);
                (0, $LCZef.show)($3bd4c1f45bee2ae9$var$listViewTypeFilterContainer);
                (0, $LCZef.show)($3bd4c1f45bee2ae9$var$listViewYearFilterContainer);
            }
        });
    }
}
var $3bd4c1f45bee2ae9$var$handleFcMoreClick = function(event) {
    var _fcMorePopver_querySelector;
    var observer = new MutationObserver(function(mutationList) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = mutationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _loop = function() {
                        var node = _step1.value;
                        if (node.nodeType === 1 && node.classList.contains('fc-more-popover')) {
                            var _node_querySelector;
                            (_node_querySelector = node.querySelector('a')) === null || _node_querySelector === void 0 ? void 0 : _node_querySelector.focus();
                            node.addEventListener('focusout', function(event) {
                                if (!event.relatedTarget || !node.contains(event.relatedTarget)) {
                                    var _document_querySelector;
                                    (_document_querySelector = document.querySelector('.fc-popover-close')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.click();
                                    event.target.focus();
                                    observer;
                                }
                            });
                        }
                    };
                    for(var _iterator1 = mutation.addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
    var fcMorePopver = document.querySelector('.fc-more-popover');
    fcMorePopver === null || fcMorePopver === void 0 ? void 0 : (_fcMorePopver_querySelector = fcMorePopver.querySelector('.fc-more-popover a:first')) === null || _fcMorePopver_querySelector === void 0 ? void 0 : _fcMorePopver_querySelector.focus();
    fcMorePopver === null || fcMorePopver === void 0 ? void 0 : fcMorePopver.addEventListener('focusout', function(event) {
        if (!fcMorePopver.contains(event.relatedTarget)) {
            var _document_querySelector;
            (_document_querySelector = document.querySelector('.fc-popover-close')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.click();
            event.target.focus();
        }
    });
};

})();
//# sourceMappingURL=EventsFront.js.map
